import React from 'react';

const UnderseaStaticElements: React.FC = () => {
  return (
    <g className="undersea-static-elements" transform="translate(-165 -400)">
      <defs>
        <linearGradient
          id="b84978ef-de00-428d-a931-2c1e59df6960"
          data-name="grad-28"
          x1="612.86"
          y1="777.37"
          x2="613.03"
          y2="798.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f4cb76" />
          <stop offset="1" stopColor="#bf534f" />
        </linearGradient>
        <linearGradient
          id="b2ce4dac-9d8a-4c28-bd59-c3b249434ca7"
          x1="611.51"
          y1="784.2"
          x2="611.61"
          y2="795.76"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="ba16cce4-e911-4b5f-a24b-897ea98f6ecc"
          x1="612.91"
          y1="787"
          x2="612.51"
          y2="802.2"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="b65fff47-6409-4950-9135-a29080a748f2"
          data-name="grad-109"
          x1="1109.05"
          y1="586.16"
          x2="1192.9"
          y2="586.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#005990" />
          <stop offset="0" stopColor="#00598f" />
          <stop offset="0.07" stopColor="#0c4e71" />
          <stop offset="0.14" stopColor="#13475f" />
          <stop offset="0.18" stopColor="#154558" />
          <stop offset="0.4" stopColor="#114151" />
          <stop offset="0.86" stopColor="#0f3f4f" />
        </linearGradient>
        <linearGradient
          id="b606e0e4-be50-4cd7-aa16-80688afc0275"
          x1="1446.05"
          y1="592.16"
          x2="1529.9"
          y2="592.16"
          xlinkHref="#b65fff47-6409-4950-9135-a29080a748f2"
        />
        <linearGradient
          id="fe711a34-732e-4111-ab74-08e1365c1938"
          x1="439.05"
          y1="680.16"
          x2="522.9"
          y2="680.16"
          xlinkHref="#b65fff47-6409-4950-9135-a29080a748f2"
        />
        <linearGradient
          id="e2761370-1d57-48ad-ad72-a62ee9801391"
          x1="299.05"
          y1="695.16"
          x2="382.9"
          y2="695.16"
          xlinkHref="#b65fff47-6409-4950-9135-a29080a748f2"
        />
        <linearGradient
          id="e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
          data-name="grad-126"
          x1="245.93"
          y1="926.02"
          x2="246.97"
          y2="1056.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ac90" />
          <stop offset="0.09" stopColor="#009e87" />
          <stop offset="0.37" stopColor="#00746c" />
          <stop offset="0.63" stopColor="#005658" />
          <stop offset="0.84" stopColor="#00444c" />
          <stop offset="1" stopColor="#003d48" />
        </linearGradient>
        <linearGradient
          id="a82896fa-10b3-420c-82b9-51a2b017d85a"
          x1="235.53"
          y1="913.02"
          x2="236.67"
          y2="1055.96"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="a3c4c1e5-708f-4de4-bfa7-4ee46b8edc5c"
          x1="256.34"
          y1="904.57"
          x2="257.54"
          y2="1056.05"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="ac6bea89-a9cb-49a7-8e75-1f207ef6ed4f"
          x1="225.13"
          y1="897.42"
          x2="226.39"
          y2="1055.75"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="e70ee380-511a-4707-9880-fcd51af38599"
          x1="214.73"
          y1="920.17"
          x2="215.81"
          y2="1055.47"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="a49d33e7-d77d-4e8a-89b8-b8315aec5f8b"
          x1="193.93"
          y1="920.17"
          x2="195"
          y2="1054.35"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="e2668173-7c88-41d3-aab4-d0c52f8924c3"
          x1="204.33"
          y1="904.57"
          x2="205.53"
          y2="1054.95"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="ba7b7732-c6fd-4268-9c2c-b3a2f185fffb"
          x1="277.14"
          y1="883.12"
          x2="278.51"
          y2="1055.94"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="a38098a3-d88a-4654-b64f-5b23885f4cbb"
          x1="256.34"
          y1="874.02"
          x2="257.77"
          y2="1054.71"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="ac127165-b558-4482-abc9-f5426c72b205"
          x1="225.13"
          y1="874.02"
          x2="226.57"
          y2="1054.71"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="ab0415e0-51b0-460c-bb19-9e395936f094"
          x1="183.53"
          y1="932.52"
          x2="184.49"
          y2="1053.58"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="e30cdc21-bbaf-460f-b3fd-68c5bfd694dc"
          x1="266.74"
          y1="926.02"
          x2="267.77"
          y2="1056.01"
          xlinkHref="#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf"
        />
        <linearGradient
          id="ba14210b-7bf7-4619-8810-0ae1a8222208"
          x1="757.78"
          y1="1091.17"
          x2="758.6"
          y2="1192.46"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="beb04513-6776-48ec-9417-f2e33c985239"
          x1="751.27"
          y1="1124.19"
          x2="751.72"
          y2="1180.15"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="ac568350-a34b-4073-bd11-7daad04b5c13"
          x1="758.04"
          y1="1137.74"
          x2="756.08"
          y2="1211.27"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="adad42da-3e08-42fc-8d61-81dc1758aa0a"
          x1="420.71"
          y1="892.16"
          x2="421.1"
          y2="940.52"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="e0958e15-0ce6-4234-a4e6-0a1b64773843"
          x1="417.61"
          y1="907.92"
          x2="417.82"
          y2="934.64"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="a299bda4-f20a-4878-8f69-2b1baa369782"
          x1="420.84"
          y1="914.39"
          x2="419.9"
          y2="949.5"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="b5956427-a68c-49fa-b059-21100ba18968"
          data-name="grad-48"
          x1="1413.37"
          y1="858.95"
          x2="1413.68"
          y2="896.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f9cb42" />
          <stop offset="1" stopColor="#11686b" />
        </linearGradient>
        <linearGradient
          id="b03cc462-5867-4acc-8fb9-8c9730ea769d"
          x1="1410.93"
          y1="871.35"
          x2="1411.1"
          y2="892.37"
          xlinkHref="#b5956427-a68c-49fa-b059-21100ba18968"
        />
        <linearGradient
          id="b35b6153-a376-4d48-bf65-a85f3d05f1c6"
          x1="1413.47"
          y1="876.44"
          x2="1412.74"
          y2="904.05"
          xlinkHref="#b5956427-a68c-49fa-b059-21100ba18968"
        />
        <linearGradient
          id="aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
          data-name="grad-58"
          x1="1237.52"
          y1="1094.43"
          x2="1238.39"
          y2="1201.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#dd15ff" />
          <stop offset="1" stopColor="#5f3e56" />
        </linearGradient>
        <linearGradient
          id="e2d087f7-96b2-4048-b45a-6956849123cc"
          x1="1230.61"
          y1="1129.49"
          x2="1231.09"
          y2="1188.89"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="a040eed0-3867-4f03-ab1e-8cc547da743a"
          x1="1237.8"
          y1="1143.87"
          x2="1235.71"
          y2="1221.92"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="efdc5447-a912-4609-99e3-0d5c7bdd7ab3"
          x1="1473.65"
          y1="940.62"
          x2="1474.09"
          y2="995.77"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="b64f5880-2b82-4ed8-b20c-5c5ece6ecdba"
          x1="1470.1"
          y1="958.6"
          x2="1470.35"
          y2="989.07"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="a40f7187-9417-4101-8f7e-3ff148770bc8"
          x1="1473.79"
          y1="965.98"
          x2="1472.72"
          y2="1006.01"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="b383d630-9f59-40aa-8302-9af174fe1bc5"
          x1="1058.35"
          y1="1062.48"
          x2="1058.65"
          y2="1099.95"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="a093ed6b-8564-40b8-9360-af360c3f9ceb"
          x1="1055.94"
          y1="1074.69"
          x2="1056.11"
          y2="1095.4"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="bb33fb8a-f2a2-4c07-b5ac-7843d7c310e8"
          x1="1058.45"
          y1="1079.71"
          x2="1057.72"
          y2="1106.91"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="ad7b9758-85f5-4bcf-be69-50a44d89b133"
          x1="1149.98"
          y1="1050.17"
          x2="1150.2"
          y2="1077.19"
          gradientTransform="translate(-251.68 365.31) rotate(-16.28)"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="b48ba470-1bbf-48d8-82c2-97c4698ff48d"
          x1="1148.25"
          y1="1058.97"
          x2="1148.37"
          y2="1073.9"
          gradientTransform="translate(-251.68 365.31) rotate(-16.28)"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="e0e7bd3e-b8e0-478d-b9da-172c06186565"
          x1="1150.05"
          y1="1062.59"
          x2="1149.53"
          y2="1082.21"
          gradientTransform="translate(-251.68 365.31) rotate(-16.28)"
          xlinkHref="#b84978ef-de00-428d-a931-2c1e59df6960"
        />
        <linearGradient
          id="e407068e-1345-47d2-a22d-f80f162c71fd"
          x1="1174.65"
          y1="761.62"
          x2="1175.09"
          y2="816.77"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="ad90e8f8-c17c-43da-98a9-6ba390d63f52"
          x1="1171.1"
          y1="779.6"
          x2="1171.35"
          y2="810.07"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="bc3a540c-e267-4723-823a-658cf4bb1504"
          x1="1174.79"
          y1="786.98"
          x2="1173.72"
          y2="827.01"
          xlinkHref="#aedf39c9-921e-414e-bc6b-d71dd53f7ae7"
        />
        <linearGradient
          id="bd16bdc8-4e8c-4f7b-b1d3-a9b6916b9547"
          data-name="grad-44"
          x1="778.54"
          y1="767.3"
          x2="751.88"
          y2="707.64"
          gradientTransform="translate(381.6 -253.57) rotate(24.89)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#510c0d" />
          <stop offset="0.29" stopColor="#561110" />
          <stop offset="0.65" stopColor="#66201a" />
          <stop offset="1" stopColor="#7c3628" />
        </linearGradient>
        <linearGradient
          id="b1ddecba-7ba1-4252-9631-90e57cba633f"
          data-name="grad-51"
          x1="1103.91"
          y1="638.67"
          x2="1085.57"
          y2="587"
          gradientTransform="translate(-29.14 55.31) rotate(-2.86)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.3" stopColor="#510c0d" />
          <stop offset="0.68" stopColor="#6b251d" />
          <stop offset="1" stopColor="#7c3628" />
        </linearGradient>
        <linearGradient
          id="e2974162-1b25-423f-803e-ea1154af2ad6"
          data-name="grad-47"
          x1="780.26"
          y1="731.61"
          x2="771.93"
          y2="678.94"
          gradientTransform="translate(114.17 -107.3) rotate(8.52)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#510c0d" />
          <stop offset="0.69" stopColor="#6a251d" />
          <stop offset="1" stopColor="#7c3628" />
        </linearGradient>
        <linearGradient
          id="b7093cc1-4e36-4338-971c-4bd5917eaa67"
          data-name="grad-43"
          x1="797.79"
          y1="727.22"
          x2="797.99"
          y2="752.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#510c0d" />
          <stop offset="0.16" stopColor="#621d18" />
          <stop offset="0.37" stopColor="#712b21" />
          <stop offset="0.61" stopColor="#793326" />
          <stop offset="1" stopColor="#7c3628" />
        </linearGradient>
        <linearGradient
          id="b71f5a0b-e864-4ed3-ade2-464e95ce81f3"
          x1="815.06"
          y1="725.95"
          x2="815.27"
          y2="753.03"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="fc89def0-e0ff-4c30-8fac-a3fe98d6862e"
          x1="835.71"
          y1="723.38"
          x2="835.94"
          y2="752.58"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="a152363b-a217-45e6-8331-be22d89975db"
          x1="857.35"
          y1="721.48"
          x2="857.59"
          y2="752.12"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="f4130415-2374-47c7-ab77-765eb8231dea"
          x1="880.14"
          y1="718.78"
          x2="880.4"
          y2="750.54"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="fce62149-dde1-4513-badd-4771db71c073"
          x1="896.18"
          y1="717.01"
          x2="896.44"
          y2="749.48"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="a34a1e4c-402c-4f89-8584-ad45851c70e1"
          x1="920.05"
          y1="713.43"
          x2="920.32"
          y2="747.32"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="eb940756-1191-4bf3-b7d3-601923c15bba"
          x1="944.68"
          y1="708.74"
          x2="944.96"
          y2="743.79"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="b6521dcd-de8d-4c3b-9db3-cc245c2b8ef7"
          x1="966.65"
          y1="702.83"
          x2="966.95"
          y2="740.32"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="f679a0f7-8068-43a1-9ff1-e98348639dd1"
          x1="1102.33"
          y1="642.13"
          x2="1102.65"
          y2="682.65"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="ac8639a9-19e5-4ce2-8315-b4d407b4058f"
          x1="1082.01"
          y1="655.79"
          x2="1082.34"
          y2="696.63"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="fb8bd457-9179-4caf-a8c2-860130397f1b"
          x1="1061.06"
          y1="667.62"
          x2="1061.38"
          y2="707.83"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="a94f6b12-0be6-415d-8dfd-588abddf7079"
          x1="1038.51"
          y1="678.43"
          x2="1038.83"
          y2="718.76"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="ac8f7cae-5820-42ba-aa18-fc35657489da"
          x1="1018.22"
          y1="688.26"
          x2="1018.53"
          y2="727.4"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="b83ae6f6-dac3-4333-bc99-ae398aafb049"
          x1="994.36"
          y1="696.48"
          x2="994.66"
          y2="734.62"
          xlinkHref="#b7093cc1-4e36-4338-971c-4bd5917eaa67"
        />
        <linearGradient
          id="a97b3391-50c3-40d5-96c3-1931869cb817"
          data-name="grad-54"
          x1="1145.38"
          y1="643.12"
          x2="1121.38"
          y2="638.79"
          gradientTransform="translate(-30.54 57.29) rotate(-2.86)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.27" stopColor="#510c0d" />
          <stop offset="0.64" stopColor="#651f19" />
          <stop offset="1" stopColor="#7c3628" />
        </linearGradient>
      </defs>

      <g id="a307d981-b109-4829-bbb0-e387178979ff" data-name="background">
        <path
          d="M68.43,464.46c87,0,215-27,278,0s-135,51-78,63,195-24,288,0-3,33-57,45,208,105,262,87,170-2,242-4,14-56,11-77,296,15,264-18,94-16,151-25-42-41,0-50,128-7,128-7-193-16-116-26,167,4,182,0-68-57,55-60,78,272,78,272v685h-1008c-28,0-719-60-744-84S68.43,464.46,68.43,464.46Z"
          fill="#8bccf3"
        />
        <rect x="162.43" y="397.46" width="1523" height="777" fill="#aee2f6" />
        <path
          d="M68.43,464.46c87,0,215-27,278,0s-135,51-78,63,195-24,288,0-3,33-57,45,208,105,262,87,170-2,242-4,14-56,11-77,296,15,264-18,94-16,151-25-42-41,0-50,128-7,128-7-193-16-116-26,167,4,182,0-68-57,55-60,78,272,78,272v685h-1008c-28,0-719-60-744-84S68.43,464.46,68.43,464.46Z"
          fill="#8bccf3"
        />
        <path
          d="M1030.43,1151c6.76-55.65-149.21-234.4-123.21-299.4s-45.13-100.78-91.13-96.78-94.9-14.47-235.9-6.47-89-10-74-22-153-40-246-31-78,605-78,605l853,2Z"
          fill="#66b1ec"
        />
        <path
          d="M1159,1415.71c-48-36-191-85-206-97s100-308,87-328-106.55-56.07-99.55-83.07,52.29-63.79,39.25-105.21c-3.39-10.79,74.06-15,63.06-23s44.22-28.56,39.22-40.56,258,46.85,243,32.85,112-19,98-34,87-9,79-27,74-26,49-37,29-4,22-14-12-10,11-14,77,12,77,12l47,790Z"
          fill="#66b1ec"
        />
      </g>
      <g id="b19fa046-250f-41fc-a581-84816b4444ee" data-name="reef">
        <g>
          <path
            d="M803.43,741.46c-17,15-25,80-15,85s-12,53-58,65-64,100-49,113-42,157-106,158,45,138,45,138h-503l54-437Z"
            fill="#4843d0"
          />
          <path
            d="M789.43,782.46s-55,49-140.5,40.5c-59,13-75.5,7.5-85,23s-158.5,48.5-205,50-182.5,19.5-212,8c1.77-7.61-2.37-39,10.5-46.5,59.78-35,225.5-42.5,225.5-42.5l409-80Z"
            fill="#161470"
            opacity="0.5"
          />
          <g>
            <path
              d="M197.64,719.24c54.62,4.31,69,34.59,133.69,10.55s134.46-27.5,194.8-25,89.13,7,89.13,7,105.08,3.81,118.1,9.32,57.58,9,59.46,13.66,23.81,10.85,23.28,17.54-26-11-51.13,22.87S637.37,801,585.42,805.9s-32.37,69.19-108.13,63.21-296.13,30.44-309.26-2S162,716.43,197.64,719.24Z"
              fill="#5493e4"
            />
            <path
              d="M208.31,868.06c23.17-9.38,265.75-14.9,288-13.14s51.89-60.92,74.88-68.08,179.31.7,177-26.39C747,746,767,737,785.94,731.84c3.88,1,6.46,1.94,6.88,3,1.88,4.64,23.81,10.85,23.28,17.54s-26-11-51.13,22.87S637.37,801,585.42,805.9s-32.37,69.19-108.13,63.21C402.2,863.19,185.1,898.9,168.46,868,185.25,870,201,871,208.31,868.06Z"
              fill="#2f5e96"
            />
            <path
              d="M751.76,725.7s-46.19,6.72-40.21,16.16S689,771.47,660.42,764.73s-54.13-24.45-89.14-7-110.65,38.35-136.51,25.1-29.26-27-71.95-25.86-64.18-18.7-64.18-18.7l-11.45.73s17,22.31,30.36,23.37,42.52,1.11,58.12,2.34,46.91,30.61,69.19,32.37,81.63-11.5,86.43-15.6,46.86-25.45,60.23-24.4,59.1,18.12,77.46,12.84,49.55-2.81,49.25-27.5c11.67-5.81,42.49-15.15,42.49-15.15Z"
              fill="#3669b2"
            />
            <path
              d="M170.37,751.82c5.84-19.75,14.81-33.56,27.27-32.58,21.14,1.67,36.25,7.22,50.59,12l1,2.56S301.37,796.93,329,787.9s58.81-6.57,79.87,10.79,60.51.29,78,6.16c0,0-77.52,16.3-85.91,8.91s-41.81-10-49.2-1.64-141.43,2.29-161.26-30.66C180.06,764.12,173.88,755.81,170.37,751.82Z"
              fill="#3669b2"
            />
            <path
              d="M162,814.6c17.34-4.88,12.18,3.68,56.39,11.65s73.53,5.81,104.55,10.5,78.34,1.7,85.56-4.46,5.45,16.13-.88,11.14S333,851,322,847.89s-40.11-3.17-49.72,5-31-4.69-39.58-9.85-55.36-8.85-62.4-4.92l-7,3.93Z"
              fill="#3669b2"
            />
          </g>
          <path
            d="M746.7,852.05a45.61,45.61,0,0,1-8.91-7.64c1.47-3.94,4.55-10.16,5.7-14.09,1.58-5.38-3.45-10.37-4.71-10.45,0,0,.88,3.08-.88,8.91a45.48,45.48,0,0,1-4.76,10.06,103,103,0,0,1-5.83-8.52,27,27,0,0,0,6,13.17A10,10,0,0,0,737,847.6a54,54,0,0,0,7.91,6.43A18.23,18.23,0,0,0,746.7,852.05Z"
            fill="#4453a0"
            opacity="0.39"
            style={{ mixBlendMode: 'multiply' }}
          />
        </g>
        <g>
          <path
            d="M1269.43,1189.46s109-137,45-138-121-145-106-158-3-101-49-113c-38.55-10.06-60.25-45.39-60.38-59.52,0-2.73.76-4.67,2.38-5.48,2.07-1,3.37-4.65,4-9.86a77.28,77.28,0,0,0,.36-10.78,159.16,159.16,0,0,0-3.3-26.89c-3.29-15.88-8.86-31.13-16-37.47l632,122,54,437Z"
            fill="#4843d0"
          />
          <g>
            <path
              d="M1203.43,810.46s20.06,49.13,12.53,66.07,146.47,27.93,159.47,74.93,33,63,33,63l-21-143Z"
              fill="#161470"
              opacity="0.33"
            />
            <path
              d="M1086.43,630.46s101,54,120,55,112.84-1.73,141.92,23.64,88.08,69.36,97.58,54.86S1400,777.69,1400,777.69,1236.43,722.46,1194.93,720s-92-36-92-36S1101.43,626.46,1086.43,630.46Z"
              fill="#161470"
              opacity="0.33"
            />
            <g>
              <path
                d="M1690.58,650.29c-54.8,0-71.53,29.05-134.11,0s-131.88-38-192.23-40.24-89.41,0-89.41,0-105-4.47-118.46,0-58.12,4.47-60.35,8.94-24.59,8.94-24.59,15.65,26.82-8.94,49.17,26.82,125.17,35.77,176.58,44.71S1324,777.69,1400,777.69s292.82,53.65,308.46,22.36S1726.34,650.29,1690.58,650.29Z"
                fill="#5493e4"
              />
              <path
                d="M1668.23,797.81c-22.35-11.18-263.76-35.76-286.11-35.76s-46.94-64.82-69.29-73.76S1134,674.87,1138.48,648.05c2.39-14.32-16.89-24.81-35.37-31.49-3.94.65-6.59,1.43-7.09,2.43-2.24,4.47-24.59,8.94-24.59,15.65s26.82-8.94,49.17,26.82,125.17,35.77,176.58,44.71S1324,777.69,1400,777.69c75.33,0,289,52.69,308,23.15C1691.07,801.52,1675.25,801.32,1668.23,797.81Z"
                fill="#5eb1e4"
              />
              <path
                d="M1137.67,613.13s45.52,10.33,38.81,19.27,20.12,31.3,49.18,26.83,55.88-20.12,89.41,0,107.29,46.94,134.11,35.76,31.29-24.59,73.76-20.12,65.46-13.59,65.46-13.59l11.36,1.63s-18.7,20.9-32.12,20.9-42.46-2.23-58.11-2.23S1460.35,708.4,1438,708.4s-80.46-17.88-84.94-22.35S1308.36,657,1295,657s-60.35,13.41-78.23,6.71-49.18-6.71-46.94-31.3c-11.18-6.7-41.17-18.44-41.17-18.44Z"
                fill="#5470e4"
              />
              <path
                d="M1715.2,684.91c-4.27-20.15-12.12-34.62-24.62-34.62-21.21,0-36.71,4.35-51.38,8l-1.15,2.47s-57,58.82-83.82,47.64-58.11-11.17-80.46,4.47-60.35-4.47-78.24,0c0,0,76,22.35,84.94,15.65s42.47-6.71,49.18,2.23,140.81,13.42,163.17-17.88C1704.58,696.41,1711.38,688.61,1715.2,684.91Z"
                fill="#5470e4"
              />
              <path
                d="M1718.66,748.16c-16.9-6.23-12.43,2.71-57.14,7.18s-73.76,0-105,2.24-78.23-4.47-84.94-11.18-6.7,15.65,0,11.18,73.76,13.41,84.94,11.17,40.23,0,49.17,8.94,31.3-2.23,40.24-6.7,55.88-4.47,62.58,0l6.71,4.47Z"
                fill="#2f5e96"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M1437.55,653.57s13.55-4.89,36.13,48.89,121.93,53.78,144.5,48.89,63.22-34.22,58.71-48.89S1464.65,658.46,1437.55,653.57Z"
            fill="#007978"
          />
          <path
            d="M1469.48,666c-6-4.88-18.66-8.88-26.13-10.93,6,3.49,16.46,14.38,30.33,47.41a60.9,60.9,0,0,0,18.88,24.15C1483.64,704.32,1475.43,670.86,1469.48,666Z"
            fill="#025e5b"
            opacity="0.83"
          />
          <path
            d="M1704,663.35c-34.86-31.46-67.46-23.11-94.55-32.89s-203.49-40.45-208,8.44c4.51,34.22,36.12,9.78,63.22,24.45s94.83,53.78,171.6,53.78S1731.08,687.79,1704,663.35Z"
            fill="#66d7d8"
          />
          <path
            d="M1663.34,660.89c9,6.66,31.61,46.57-13.55,46.57s-76.75-3.69-108.36-17c-22.37-9.42-65.1-44.4-89-53-3.81-1.37,12.1-12.4,16-13,28.47-4.34,84.58.72,109,11C1609,648.77,1663.34,660.89,1663.34,660.89Z"
            fill="#009e97"
            opacity="0.43"
          />
          <path
            d="M1492.56,678.17c-8.42-4.31,23.26,9.62,20.25,9.62s9.39,33.39,24.09,58.67l-4.52-4.89s-22.57-34.22-27.09-44S1502.4,683.21,1492.56,678.17Z"
            fill="#025e5b"
            opacity="0.83"
          />
          <path
            d="M1525.13,693.06l28.43,10.34s-18.36,27.78,5.07,47.64c.85.31-9.09-1.46-9.09-1.46s.91-8-12.64-32.45S1525.13,693.06,1525.13,693.06Z"
            fill="#025e5b"
            opacity="0.83"
          />
          <path
            d="M1568.82,707.85l26.57,5.76s-13.33,3.52-13.33,13.3,2.26,28.45,7.9,26.44c-11.29-4-7.86.15-7.86.15S1578.16,708.35,1568.82,707.85Z"
            fill="#025e5b"
            opacity="0.83"
          />
          <g opacity="0.79">
            <path
              d="M1401.43,638.9a44.38,44.38,0,0,0,2.39,7.48,17.68,17.68,0,0,0,4.1,6.19,12.82,12.82,0,0,0,6.21,3.14,28.69,28.69,0,0,0,7.34.38c5.08-.21,10.35-1,15.81-1.16A54,54,0,0,1,1454,656.7a43.84,43.84,0,0,1,8,3.13l7,3.61c4.68,2.4,9.32,4.83,14,7.15s9.36,4.67,14.09,6.9,9.44,4.44,14.22,6.54,9.56,4.16,14.38,6.12,9.7,3.82,14.56,5.68c9.78,3.58,19.68,6.84,29.7,9.7a340.73,340.73,0,0,0,61.7,11.6c-21.11,1.91-42.6-.09-63.46-4.48a294.09,294.09,0,0,1-30.87-8.46q-15.18-5.09-29.81-11.58c-4.88-2.14-9.69-4.43-14.47-6.76s-9.49-4.8-14.17-7.3-9.31-5.11-13.89-7.75l-6.84-3.94a38.25,38.25,0,0,0-6.49-3,51.85,51.85,0,0,0-14.51-2.64c-5.09-.33-10.34-.1-15.81-.4a32.46,32.46,0,0,1-8.3-1.52,15.18,15.18,0,0,1-7.16-4.92,19.62,19.62,0,0,1-3.51-7.53A38.37,38.37,0,0,1,1401.43,638.9Z"
              fill="#bee5e3"
            />
          </g>
          <path
            d="M1602.09,753.12a107.12,107.12,0,0,0,16.09-1.77c17.49-3.78,45.79-22.23,55.58-37.17,0,0-34.69,3-42.88,3C1636.89,726.59,1616.22,749.19,1602.09,753.12Z"
            fill="#025e5b"
            opacity="0.83"
          />
          <g opacity="0.79">
            <path
              d="M1469.16,624.23a125.86,125.86,0,0,1-15.61,1.65c-2.56.17-5.1.37-7.5.71a30.43,30.43,0,0,0-3.42.68,13.18,13.18,0,0,0-2.81,1.09,4.62,4.62,0,0,0-1.67,1.46,4.72,4.72,0,0,0-.71,1.87c0,.2-.07.39-.09.6l0,.66c0,.22,0,.47,0,.71V634l0,.16a3,3,0,0,0,.7,1.36,15.71,15.71,0,0,0,4.6,3.48,56.55,56.55,0,0,0,6.45,3c2.27.94,4.61,1.82,7,2.67s4.78,1.71,7.2,2.57c4.84,1.72,9.74,3.44,14.59,5.39a143.29,143.29,0,0,1,14.36,6.53,58.71,58.71,0,0,1,13,9,138.68,138.68,0,0,0-14.74-4.75c-5-1.33-9.92-2.55-14.91-3.79s-10-2.51-15-3.93c-2.51-.7-5-1.48-7.54-2.29s-5-1.74-7.54-2.76A61.55,61.55,0,0,1,1438,647a32.74,32.74,0,0,1-3.72-2.61,17.6,17.6,0,0,1-3.51-3.78,11.6,11.6,0,0,1-2-5.81l0-.81,0-.61c0-.41,0-.81.11-1.23l.21-1.27c.09-.42.22-.86.33-1.29a12.25,12.25,0,0,1,2.79-5,12.53,12.53,0,0,1,4.6-3,23,23,0,0,1,8.91-1.18,66.32,66.32,0,0,1,8,.84C1459,622.14,1464,623.21,1469.16,624.23Z"
              fill="#bee5e3"
            />
          </g>
        </g>
        <g>
          <path
            d="M1382.43,887.46c0,24.94,47.45,55.93,93,65s1.72,50.06,10.39,68.2l19.53,40.8h65.07s-13-22.67,26-47.6,71.58-47.61,78.09-63.48,49.89-52.14,49.89-52.14Z"
            fill="#874439"
          />
          <path
            d="M1224.21,822.69c0,35.87,70.58,68.48,125.47,81.52s28.76,68.47,39.21,94.56l23.53,58.69h78.42s-15.69-32.61,31.37-68.47,86.26-68.48,94.1-91.3,60.12-75,60.12-75Z"
            fill="#9e5243"
          />
          <g>
            <path
              d="M1389.43,882.46c0,24.94,47.45,55.93,93,65s1.72,50.06,10.39,68.2l19.53,40.8h65.07s-13-22.67,26-47.6,71.58-47.61,78.09-63.48,49.89-52.14,49.89-52.14Z"
              fill="#c47060"
            />
            <path
              d="M1671.54,959s-35.11-11.58-49.11-.58-58,25-77,18-42-9-42-9l-3,15,85,16,58-14Z"
              fill="#874439"
              opacity="0.36"
            />
            <path
              d="M1394.43,889.46c-7-21.93,99.56-20.29,112.58-24.83s169.19-15.86,199.56,0,12.61,92.37-61.14,87.83-62.94-27.73-115-30-76,23.93-107,1C1400.43,906.46,1403.11,916.67,1394.43,889.46Z"
              fill="#0e3b68"
              opacity="0.32"
            />
            <path
              d="M1370.43,882.46c-7-21.93,124.56-32.29,137.58-36.83s169.19-15.86,199.56,0,12.61,92.37-61.14,87.83-62.94-27.73-115-30-74.13,16.34-111,5S1379.11,909.67,1370.43,882.46Z"
              fill="#f2aa68"
            />
            <path
              d="M1721.31,881.55a57.21,57.21,0,0,1-7.31,23.67,62.94,62.94,0,0,1-16.51,19,69.93,69.93,0,0,1-22.75,11.32,87.73,87.73,0,0,1-25.26,3.17l-3.18-.07-3.12-.2L1637,938c-2.08-.12-4.16-.27-6.24-.55l-6.23-.74c-1-.13-2.08-.22-3.11-.4l-3.11-.53-6.21-1.08c-4.11-1-8.26-1.8-12.31-3.15a133.81,133.81,0,0,1-23.32-9.84c-3.69-1.89-7.26-3.68-10.9-5.26-1.81-.79-3.66-1.41-5.49-2.13s-3.75-1.13-5.62-1.7a120.93,120.93,0,0,0-23.58-3.3,217.51,217.51,0,0,0-24.22.38c-8.06.59-16.1,1.65-24.18,3s-16.23,2.86-24.62,3.69a92.37,92.37,0,0,1-25.39-.57c-2.08-.44-4.17-.82-6.23-1.32l-6.09-1.78c-3.89-1.28-7.76-2.45-11.71-3.45s-7.91-1.86-11.94-2.55l-6.1-1a50,50,0,0,1-6.18-1.36,15.42,15.42,0,0,1-5.78-3,16.91,16.91,0,0,1-3.86-5.13,41.07,41.07,0,0,1-2.35-5.79c-.68-2-1.22-4-1.75-5.95a66.39,66.39,0,0,0,5.15,11.14,15.69,15.69,0,0,0,3.89,4.39,13.33,13.33,0,0,0,5.27,2.24c3.86.8,8,1,12.13,1.45s8.27,1,12.38,1.78,8.17,1.81,12.18,2.89l5.85,1.38c2,.37,4,.62,5.91.93a90.65,90.65,0,0,0,23.89-.44c2-.27,4-.63,6-.94l6-1.13,12.13-2.33c8.15-1.53,16.43-2.83,24.78-3.63l6.28-.48c2.09-.13,4.2-.14,6.29-.22l3.15-.09c1,0,2.1,0,3.15,0l6.3.11c8.41.45,16.91,1.21,25.3,3.38,2.06.64,4.15,1.23,6.19,1.92s4.06,1.52,6,2.39c3.91,1.73,7.69,3.66,11.32,5.56l2.73,1.42,2.71,1.35c1.8.94,3.62,1.74,5.44,2.56s3.68,1.54,5.53,2.27c.93.34,1.85.74,2.79,1.06l2.84.93c3.75,1.35,7.69,2.2,11.56,3.24l5.93,1.17,3,.58c1,.2,2,.3,3,.45,4,.54,8,1.23,12.08,1.55l6.09.62,3,.3,3,.18a85.57,85.57,0,0,0,23.73-2A65.88,65.88,0,0,0,1695.2,921,61.28,61.28,0,0,0,1721.31,881.55Z"
              fill="#ffefd2"
            />
          </g>
          <path
            d="M1679.37,859.24c-80.29,0-88.94,13.6-130.15,0s-73.75-13.61-93.27,4.53-69.42-4.53-67.25,18.14,68.26-5.1,103.73,3.55c35.17,8.58,77.86-4.13,106,9,30,14,70.2,14.22,91.78,7.85C1720.06,893.5,1705.4,859.24,1679.37,859.24Z"
            fill="#e2974b"
          />
          <path
            d="M1490.13,816l-262,21.49s3.33,30,88.33,32c27.45.65,51.13,0,71.11-.87,22.47-9,47.56-6.49,68.89-18.13C1471.25,842.56,1482.15,829.78,1490.13,816Z"
            fill="#874439"
          />
          <path
            d="M1679.21,800.46,1490.13,816c-8,13.81-18.88,26.59-33.7,34.49-21.33,11.64-46.42,9.17-68.89,18.13,41.87-1.92,67.41-5.19,76.89-1.13,14,6,136.27,32.17,194.63-7.91S1679.21,800.46,1679.21,800.46Z"
            fill="#0e3b68"
            opacity="0.32"
          />
          <path
            d="M1134.41,797.51c-10.55-34,223.77-56.23,243.4-63.26s255.12-24.6,300.92,0,51.19,91.22-55.61,123c-112,33.34-132-23.66-226-8.66-77.6,12.38-140.3-5.4-195.91-23S1147.5,839.68,1134.41,797.51Z"
            fill="#f2aa68"
          />
          <path
            d="M1713,786.46a50.31,50.31,0,0,1-4.53,19.19,62.39,62.39,0,0,1-4.84,8.72,83.16,83.16,0,0,1-6.08,7.92,96.88,96.88,0,0,1-14.73,13.46A140.29,140.29,0,0,1,1666,846.53a213.08,213.08,0,0,1-36.71,15.4,268.27,268.27,0,0,1-38.67,9.55,183.85,183.85,0,0,1-40,2.45,207.25,207.25,0,0,1-39.59-6.26c-12.91-3.15-25.44-7.07-38.09-9.91a183.72,183.72,0,0,0-38.27-4.85,188.22,188.22,0,0,0-19.28.69c-3.21.26-6.41.65-9.61,1.06l-9.73,1.42c-3.29.51-6.6.85-9.9,1.27s-6.62.71-9.94.95c-6.63.56-13.28.87-19.93,1a352.52,352.52,0,0,1-79.14-7.88c-13-2.74-25.78-6.06-38.46-9.76s-25.23-7.88-37.64-12a132.35,132.35,0,0,0-18.87-4.58,85.73,85.73,0,0,0-19.35-.89l-4.91.34a38.72,38.72,0,0,1-5.07.09,9.83,9.83,0,0,1-5.08-1.64,12.31,12.31,0,0,1-3.43-3.93,48.73,48.73,0,0,1-3.81-9.22c-1-3.13-1.91-6.3-2.79-9.47,1.09,3.1,2.2,6.2,3.43,9.24a50.21,50.21,0,0,0,4.32,8.72,11,11,0,0,0,3.18,3.29,8.14,8.14,0,0,0,4.27,1.09,96.09,96.09,0,0,0,9.68-1,88.67,88.67,0,0,1,20,0,123.15,123.15,0,0,1,19.64,3.87l19,5.53c6.31,1.82,12.64,3.54,19,5.23,12.66,3.38,25.4,6.36,38.24,8.77s25.74,4.3,38.71,5.41a331.62,331.62,0,0,0,39,1.15c6.5-.17,13-.5,19.46-1.09,3.24-.24,6.47-.63,9.7-1s6.45-.77,9.66-1.28l9.79-1.47c3.31-.45,6.64-.86,10-1.15a173.34,173.34,0,0,1,20.13-.74,191.06,191.06,0,0,1,39.86,5.23c13,3,25.61,6.93,38.19,10.24A200.07,200.07,0,0,0,1551,867a188.31,188.31,0,0,0,38.67-1.6,283.61,283.61,0,0,0,38.1-8.39,214.74,214.74,0,0,0,36.44-13.89c11.61-5.8,22.63-13,31.72-22.3a79.65,79.65,0,0,0,6.29-7.43,62.37,62.37,0,0,0,5.16-8.26A49.72,49.72,0,0,0,1713,786.46Z"
            fill="#ffefd2"
          />
          <path
            d="M1644.43,749.46c-119.39,0-111.67,29.11-173,8-61-21-139.32-4.1-168.35,24.21s-103.21-7.07-100,28.31,125.8-17.69,177.41,0,186.77,25.87,231.93,36.48S1683.14,749.46,1644.43,749.46Z"
            fill="#e2974b"
          />
        </g>
        <g>
          <path
            d="M1184.59,1114.24c-10.48,3-19.92,10.24-28.67,19.8a168.53,168.53,0,0,0-12.24,15.25c-24.37,33.84-44.11,80-68.45,86.91-36.44,10.41-83.29-10.41-119.73-26-27.77-11.9-91.79-60.06-120.7-89.23a107.1,107.1,0,0,1-11.59-13.3c-2-2.85-3.05-5.16-3.05-6.79C820.16,1100.85,1064.77,1092.68,1184.59,1114.24Z"
            fill="#5761ec"
          />
          <path
            d="M902.1,1111.32c19.22,1.56,29.17,3,29.17,3-.79,7.54-6.64,71.6,59,110.35-12.92-4.86-53.31-33.67-63.72-64.9S902.1,1111.32,902.1,1111.32Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M1032.3,1138.47c-11.68-.49,27.31,3.16,40.33,4s-13,11.24-18.22,32.07,7.48,70.1,7.48,70.1-17.89-70.1-23.1-75.31S1041.44,1138.85,1032.3,1138.47Z"
            fill="#003a46"
            opacity="0.61"
          />
          <path
            d="M1114.18,1142.46c-4.07,0-16.78,59.56-41.57,94.41.88-.21,1.75-.43,2.62-.67,28.22-8.06,50.25-68.75,80.49-101.93C1155.72,1134.27,1119.92,1142.46,1114.18,1142.46Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M825.89,1101.62l27.21,1.91a1.44,1.44,0,0,1,1.07.6c5.34,7.4,64,88,105.51,108.29a1.45,1.45,0,0,0,1.33-2.58c-34.2-19.07-125-72.36-136.6-106.33A1.44,1.44,0,0,1,825.89,1101.62Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M1228.08,1072.55c-3.89,22.1-28.56,41.86-53.95,54.33a124.9,124.9,0,0,1-18.21,7.16,168.53,168.53,0,0,0-12.24,15.25c-90.85,20.36-228.53-26-261.05-26-12.66,0-30.35-.63-47.83-2.32a107.1,107.1,0,0,1-11.59-13.3c-22.05-2.81-41.81-7.56-48.08-15.17,9.15-17.65,42.3-26.47,71.06-26.47,31.23,0,140.55-31.23,203-41.64s122.79-12.94,161.37,20.82C1221,1054.33,1226.45,1063.55,1228.08,1072.55Z"
            fill="#003a46"
            opacity="0.61"
          />
          <path
            d="M1228.08,1072.55c-3.89,22.1-28.56,41.86-53.95,54.33a124.9,124.9,0,0,1-18.21,7.16c-90.18,28-239.27-22.78-273.29-22.78a501.85,501.85,0,0,1-59.42-3.62c-22.05-2.81-41.81-7.56-48.08-15.17a7.89,7.89,0,0,1-1.82-7.23c5.21-20.83,41.64-31.24,72.88-31.24s140.55-31.23,203-41.64,122.79-12.94,161.37,20.82C1225.74,1046.45,1230.32,1059.89,1228.08,1072.55Z"
            fill="#5784ec"
          />
          <path
            d="M953.7,1124.48l38.55,8.35s-10.82,1.63-7.82,21.63,45.72,82,45.72,82-58.72-69-68.72-79-12.44-33.72-21.22-35.86C953.65,1124.32,953.7,1124.48,953.7,1124.48Z"
            fill="#003a46"
            opacity="0.51"
          />
          <path
            d="M1226.08,1070.55a43.79,43.79,0,0,1-4.71,14.69,70.14,70.14,0,0,1-8.85,12.84,99.13,99.13,0,0,1-11.09,11,140.78,140.78,0,0,1-12.42,9.47c-4.31,2.93-8.79,5.59-13.36,8.09a126,126,0,0,1-14.26,6.69,161.72,161.72,0,0,1-30.27,8.33,232.54,232.54,0,0,1-31.06,3.44c-10.39.53-20.78.45-31.12,0a541.29,541.29,0,0,1-61.6-6.53c-10.17-1.62-20.3-3.48-30.39-5.44s-20.13-4.13-30.14-6.34L916.87,1120c-5-1.12-9.94-2.22-14.91-3.24s-9.91-2-14.78-2.71c-1.22-.17-2.42-.31-3.61-.42-.59-.05-1.19-.11-1.76-.14s-1.11,0-1.79-.06q-3.88-.09-7.74-.25c-5.16-.21-10.31-.46-15.44-.86-10.28-.79-20.53-1.85-30.74-3.3-5.1-.75-10.2-1.63-15.26-2.69a141.07,141.07,0,0,1-15.05-3.93,62.39,62.39,0,0,1-14.23-6.44,22.72,22.72,0,0,1-5.81-5.29,9.32,9.32,0,0,1-1.67-3.58,7.86,7.86,0,0,1,.23-3.86,7.5,7.5,0,0,0,.21,3.74,8.63,8.63,0,0,0,1.89,3.16,21.1,21.1,0,0,0,6,4.36,60.22,60.22,0,0,0,14.22,4.88,205.89,205.89,0,0,0,30.08,4.12c10.13.84,20.3,1.3,30.47,1.5,5.08.08,10.16.19,15.24.16q3.81,0,7.6-.08h2.05c.71,0,1.38,0,2.07.06,1.37.08,2.71.18,4,.31,10.55,1.07,20.6,3.07,30.7,5s20.09,4.08,30.1,6.08,20,4,30,5.9,20,3.67,30.06,5.27,20.09,3,30.16,4.24,20.15,2.13,30.24,2.77c20.17,1.23,40.42,1.17,60.29-1.51q7.46-1,14.77-2.66l3.64-.87c1.21-.3,2.41-.65,3.62-1,2.41-.64,4.79-1.35,7.16-2.13a117.26,117.26,0,0,0,13.87-5.55c4.54-2.15,9-4.51,13.34-7a121.79,121.79,0,0,0,24.16-18,68.24,68.24,0,0,0,9.62-11.61A44.63,44.63,0,0,0,1226.08,1070.55Z"
            fill="#dcf9f7"
          />
          <path
            d="M1184.13,1044.37c-28-26.3-71.68-24.33-117-16.22s-124.5,32.44-147.14,32.44-84.83,4.74-88.6,21,89.24,21.19,115,30.1c25,8.63,181.11,17.88,211.29,5.71S1214.31,1072.75,1184.13,1044.37Z"
            fill="#fff"
            opacity="0.13"
          />
        </g>
        <g>
          <path
            d="M605.43,912.46s-17,257-71,288c119,1,168,3,168,3s-63-251,136-277C622.43,929.46,605.43,912.46,605.43,912.46Z"
            fill="#be279d"
          />
          <path
            d="M773.51,946.91l3.92-5.45-172-6-2,1.88c-.52,5.72-1.13,12.26-1.86,19.47,5,3.38,11.7,7.93,19.87,13.65,20,14,59,6,87-3a90.11,90.11,0,0,1,40.67-3.3A140.21,140.21,0,0,1,773.51,946.91Z"
            fill="#a02ca2"
          />
          <g>
            <path
              d="M549.68,903.26c41.66-14.12,202.62-59,307.75,9-15.93,18.89-56.08,47.62-103.87,40.06s-86,34-143.35,0S527.38,910.81,549.68,903.26Z"
              fill="#b96fc6"
            />
            <path
              d="M857.43,912.31a94.5,94.5,0,0,1-7.38,8.38c-2.64,2.63-5.41,5.15-8.28,7.54a131.44,131.44,0,0,1-18.52,12.71,127.29,127.29,0,0,1-20.56,9.31c-3.57,1.24-7.22,2.24-10.9,3.15s-7.42,1.58-11.19,2a101,101,0,0,1-22.79.38c-1.89-.17-3.82-.46-5.66-.68s-3.54-.45-5.33-.56a83.51,83.51,0,0,0-10.73,0,126,126,0,0,0-21.46,3.38c-7.14,1.65-14.24,3.71-21.49,5.53A195.33,195.33,0,0,1,671,967.94a95.65,95.65,0,0,1-22.88.5,87.74,87.74,0,0,1-22.3-5.32,94.63,94.63,0,0,1-10.42-4.68c-3.37-1.74-6.66-3.74-9.78-5.66-12.65-7.71-25.44-15.19-38.26-22.71q-4.8-2.84-9.56-5.75c-3.17-2-6.33-3.93-9.38-6.13a49.17,49.17,0,0,1-4.42-3.53,17.91,17.91,0,0,1-2-2.1,6.38,6.38,0,0,1-1.33-2.68,3.39,3.39,0,0,1,.1-1.58,3.75,3.75,0,0,1,.77-1.33,8.11,8.11,0,0,1,2.31-1.71,28.51,28.51,0,0,1,5.22-2,28.28,28.28,0,0,0-5,2.39,7.57,7.57,0,0,0-2,1.75,2.64,2.64,0,0,0-.51,2.29,5.71,5.71,0,0,0,1.3,2.16,16.35,16.35,0,0,0,2,1.83,46.11,46.11,0,0,0,4.5,3.12c6.28,3.83,12.88,7.23,19.45,10.67,13.14,6.88,26.31,13.81,39.23,21.2,3.26,1.87,6.37,3.62,9.65,5.19a102.56,102.56,0,0,0,10,4.21,82.28,82.28,0,0,0,21,4.59,97.07,97.07,0,0,0,21.53-.71,188.34,188.34,0,0,0,21.44-4.49c7.13-1.85,14.32-3.8,21.65-5.48a132.48,132.48,0,0,1,22.5-3.38,82.08,82.08,0,0,1,11.52.2c1.91.16,3.83.42,5.73.71s3.58.56,5.38.76a103.74,103.74,0,0,0,21.65.19c3.61-.3,7.2-.91,10.77-1.57s7.1-1.6,10.59-2.67a123.69,123.69,0,0,0,20.37-8.07,136.94,136.94,0,0,0,18.9-11.35q4.5-3.21,8.71-6.83A97,97,0,0,0,857.43,912.31Z"
              fill="#e4b9ed"
            />
            <path
              d="M591.21,898.45c28.73-11.75,149.37-44,221.86,12.58-11,15.72-48.32,34.59-81.27,28.3s-59.31,28.31-98.85,0S575.83,904.74,591.21,898.45Z"
              fill="#dc9cd0"
            />
          </g>
        </g>
        <g>
          <path
            d="M331.71,857.83s65.72,40.63,66.72,64.63c-15,36-40.86,96.09-40.86,96.09l146.86-.09s-16-119,75-144C644.38,856.62,331.71,857.83,331.71,857.83Z"
            fill="#2a0a54"
          />
          <g>
            <path
              d="M317.68,843.86c41.66-13.4,216.62-50.22,321.75,14.35-15.93,17.94-70.08,39.47-117.87,32.29s-86,32.29-143.35,0S295.38,851,317.68,843.86Z"
              fill="#b96fc6"
            />
            <path
              d="M638.82,858.21c-4.91,5.83-11.25,10.3-17.77,14.22a150,150,0,0,1-20.61,10A176.57,176.57,0,0,1,556,893.49a142.24,142.24,0,0,1-23.08.85l-2.9-.15-2.89-.23c-1.93-.14-3.85-.41-5.77-.64s-3.66-.43-5.5-.59-3.65-.26-5.48-.22a101.42,101.42,0,0,0-11,.51c-3.67.43-7.34.93-11,1.66-7.32,1.37-14.61,3.29-22,5.14s-14.83,3.61-22.47,4.83a111.88,111.88,0,0,1-23.23,1.5,93.65,93.65,0,0,1-23-4.09,103.64,103.64,0,0,1-21.21-9.5c-13.07-7.61-26.29-15-39.55-22.35-6.59-3.75-13.26-7.39-19.65-11.6-1.58-1.06-3.15-2.17-4.64-3.4a21.32,21.32,0,0,1-2.14-2,7.44,7.44,0,0,1-1.63-2.54,3.26,3.26,0,0,1-.14-1.61,3,3,0,0,1,.68-1.44,7.32,7.32,0,0,1,2.35-1.78,28.73,28.73,0,0,1,5.36-2,28.5,28.5,0,0,0-5.13,2.37,6.91,6.91,0,0,0-2,1.79,2.31,2.31,0,0,0-.24,2.32,11.25,11.25,0,0,0,3.72,3.84,51.11,51.11,0,0,0,4.73,3c6.54,3.72,13.36,7,20.15,10.4s13.57,6.77,20.33,10.22,13.46,7,20.15,10.64A107.17,107.17,0,0,0,399.19,897a87.88,87.88,0,0,0,21.71,3.44A109.86,109.86,0,0,0,443,898.81c7.33-1.22,14.62-3,21.95-4.86s14.75-3.71,22.34-5.08c3.79-.73,7.64-1.24,11.5-1.66a93,93,0,0,1,11.69-.42c2,0,3.92.22,5.87.35s3.94.49,5.79.73,3.67.55,5.52.71l2.76.28,2.78.2a155.75,155.75,0,0,0,22.34-.25,179.89,179.89,0,0,0,22.21-3.26,184.45,184.45,0,0,0,21.72-5.91q5.34-1.82,10.57-3.95T620.24,871A99.91,99.91,0,0,0,630,865.3,52.72,52.72,0,0,0,638.82,858.21Z"
              fill="#e4b9ed"
            />
            <path
              d="M345,839.3c30.42-11.16,179.71-41.59,256.46,12.16-11.63,14.93-72.72,32.63-107.61,26.66s-62.8,26.88-104.66,0S328.69,845.27,345,839.3Z"
              fill="#dc9cd0"
            />
          </g>
        </g>
        <g>
          <path
            d="M170.43,936.46l316,2s-62,32-66,85l-259,16L157,932.52Z"
            fill="#3a0d6c"
          />
          <g>
            <path
              d="M166.74,926.93c47.48-12.06,246.88-45.17,366.69,12.91-18.15,16.13-79.87,35.49-134.33,29s-98,29-163.38,0S141.33,933.38,166.74,926.93Z"
              fill="#b96fc6"
            />
            <path
              d="M532.74,939.84c-6.23,5.73-13.82,9.77-21.46,13.36a195.51,195.51,0,0,1-23.77,9,243.61,243.61,0,0,1-49.91,9.72,201.3,201.3,0,0,1-25.53.75c-2.13-.07-4.27-.16-6.4-.32s-4.26-.34-6.39-.54l-6.18-.55c-2.06-.06-4.1-.23-6.16-.21-16.49-.26-32.9,3-49.39,6.3-8.27,1.62-16.61,3.2-25.06,4.36a167.22,167.22,0,0,1-25.63,1.67,129.31,129.31,0,0,1-50-11.11c-15.41-7-30.67-13.85-46.13-20.61-7.69-3.46-15.43-6.81-23-10.64-1.89-1-3.75-2-5.58-3.09-.91-.56-1.8-1.15-2.66-1.8a10.37,10.37,0,0,1-2.37-2.31,3.18,3.18,0,0,1-.63-1.68,2.48,2.48,0,0,1,.67-1.69,7.71,7.71,0,0,1,2.78-1.73,37.69,37.69,0,0,1,6.09-1.75,37.85,37.85,0,0,0-5.9,2.17,7.19,7.19,0,0,0-2.43,1.75,1.7,1.7,0,0,0-.4,1.2,2.35,2.35,0,0,0,.57,1.19,10,10,0,0,0,2.27,1.94c.85.56,1.75,1.08,2.67,1.57,1.84,1,3.73,1.85,5.65,2.69,7.69,3.34,15.56,6.35,23.4,9.4s15.69,6.16,23.51,9.31c3.92,1.56,7.81,3.18,11.7,4.81l5.83,2.46,2.91,1.24,2.89,1.16A138,138,0,0,0,262.39,975a122,122,0,0,0,24.55,2.5,168.55,168.55,0,0,0,24.73-1.8c8.23-1.17,16.44-2.78,24.69-4.44s16.58-3.24,25-4.41a154.42,154.42,0,0,1,25.65-1.66c2.16,0,4.31.23,6.46.33l6.39.68c2.06.23,4.12.48,6.19.62s4.13.32,6.21.43a228.25,228.25,0,0,0,24.95-.15c4.16-.23,8.32-.63,12.47-1.06s8.29-1,12.41-1.69c8.26-1.28,16.46-3,24.56-5.1a206.54,206.54,0,0,0,23.92-7.63c3.9-1.54,7.75-3.22,11.48-5.13A62,62,0,0,0,532.74,939.84Z"
              fill="#e4b9ed"
            />
            <path
              d="M214.07,922.83c32.74-10,170.24-37.61,252.85,10.74-12.52,13.43-55.08,29.54-92.63,24.17s-67.59,24.17-112.65,0S196.55,928.2,214.07,922.83Z"
              fill="#dc9cd0"
            />
          </g>
        </g>
        <g>
          <path
            d="M528.34,1107.84c-32.91,41.62-76.91,49.62-76.91,112.62-294,15-331-46-331-46l44-100Z"
            fill="#cd22b1"
          />
          <path
            d="M159.93,1084.68c22.5,11.78,45.5,25.78,67.5,46.78s116,44,156,35,88.81-6.16,95.9-12.08,41.1-30.92,41.1-30.92l-346.06-50.59Z"
            fill="#a02ca2"
          />
          <g>
            <path
              d="M162.56,1039.53c80.39-25.87,418-96.92,620.87,27.69-30.74,34.61-135.24,76.15-227.45,62.3s-166,62.31-276.63,0S119.52,1053.37,162.56,1039.53Z"
              fill="#b45bc6"
            />
            <path
              d="M782.26,1067.22a101.23,101.23,0,0,1-16,15.1A188.7,188.7,0,0,1,748,1094.66c-6.33,3.77-12.87,7.18-19.5,10.4s-13.41,6.11-20.26,8.86a341,341,0,0,1-85.85,21.38l-5.54.6-5.55.45c-3.69.35-7.41.47-11.12.68-1.86.12-3.72.1-5.58.14s-3.72.08-5.58,0l-5.58-.09-2.8-.06-2.79-.14-5.59-.28-5.58-.46c-3.72-.26-7.42-.78-11.14-1.22l-2.71-.32-2.63-.29c-1.76-.17-3.5-.44-5.26-.54-3.53-.16-7-.5-10.59-.42-1.77,0-3.53,0-5.3,0l-5.31.22c-.89,0-1.77.06-2.66.12l-2.66.22-5.31.45-5.3.65-2.66.34-2.65.41-5.3.84-5.29,1c-14.12,2.65-28.19,6.32-42.39,9.87s-28.6,7-43.34,9.37c-3.69.55-7.37,1.14-11.1,1.52-1.86.2-3.71.48-5.58.61l-5.61.45c-1.86.18-3.75.22-5.62.3s-3.76.15-5.64.2l-5.65,0-2.82,0c-.94,0-1.88-.11-2.83-.16a180.51,180.51,0,0,1-44.41-7.89c-3.56-1.21-7.11-2.43-10.64-3.71-3.47-1.44-7-2.79-10.39-4.32s-6.76-3.22-10.09-4.91l-9.81-5.4c-12.59-7.37-25.32-14.53-38-21.73s-25.5-14.26-38.29-21.39q-9.56-5.38-19.1-10.87c-6.33-3.7-12.67-7.41-18.81-11.51-3.06-2.06-6.09-4.2-9-6.58a38.37,38.37,0,0,1-4.12-3.86,14.66,14.66,0,0,1-3.16-4.91,6.54,6.54,0,0,1-.27-3.11,6,6,0,0,1,1.31-2.78,14.12,14.12,0,0,1,4.53-3.44,53.55,53.55,0,0,1,10.35-3.78,58.25,58.25,0,0,0-9.9,4.58,13,13,0,0,0-3.9,3.44,4.45,4.45,0,0,0-.46,4.48,12.92,12.92,0,0,0,3,4,36.7,36.7,0,0,0,4.12,3.38,105.91,105.91,0,0,0,9.13,5.79c12.63,7.18,25.78,13.58,38.88,20.07s26.19,13.06,39.24,19.71,26,13.56,38.87,20.54l9.58,4.88c3.23,1.51,6.52,2.92,9.77,4.39s6.64,2.59,9.95,3.9c3.37,1.14,6.76,2.23,10.14,3.31a169.57,169.57,0,0,0,41.88,6.63,210.79,210.79,0,0,0,42.54-3.17c14.15-2.33,28.22-5.79,42.37-9.32,7.1-1.75,14.19-3.55,21.38-5.23,3.57-.87,7.2-1.64,10.8-2.46l5.45-1.12q2.72-.57,5.48-1l5.49-1,5.55-.82,2.77-.41,2.79-.33,5.59-.63,5.62-.43,2.81-.2c.94-.06,1.88-.07,2.82-.1l5.66-.16c1.88,0,3.77.07,5.66.11,3.77,0,7.55.42,11.32.66,1.88.15,3.75.46,5.63.69l5.55.73c3.54.49,7.07,1.06,10.64,1.37l5.34.55,5.36.37,2.68.18,2.69.1,5.38.2c3.59,0,7.19.07,10.78,0s7.19-.09,10.79-.31l5.4-.27,5.38-.42a349.47,349.47,0,0,0,42.86-6.29,355.12,355.12,0,0,0,41.91-11.41c6.87-2.33,13.68-4.85,20.39-7.61s13.29-5.85,19.79-9.11a191.2,191.2,0,0,0,18.84-10.95A106.35,106.35,0,0,0,782.26,1067.22Z"
              fill="#e4b9ed"
            />
            <path
              d="M242.7,1030.73c55.43-21.54,288.24-80.68,428.12,23-21.2,28.81-93.26,63.38-156.84,51.86s-114.45,51.86-190.75,0S213,1042.25,242.7,1030.73Z"
              fill="#dc9cd0"
            />
          </g>
        </g>
        <g>
          <path
            d="M1441.43,1019.46s46,25,42,51l117-23-4-33.6Z"
            fill="#5a9e94"
          />
          <path
            d="M1723.91,1043.72a15.38,15.38,0,0,1-11.48,11.74,112.09,112.09,0,0,1-14.73,3.19c-23.67,3.4-38.86-4.14-74.27-14.19-18.28-5.19-40.83-7.7-63.43-8.49a511.66,511.66,0,0,0-79.57,3.49c-25.93,3.38-72.31-8.21-93.8-20.8-8.29-4.87-12.87-9.88-11.13-14.23,6.25-15.62,42.71-24,88.55-30.21s113.54,27.09,153.13,0,59.37-3.12,83.33,0C1700.51,974.22,1729.73,1020.63,1723.91,1043.72Z"
            fill="#3dd87c"
          />
          <path
            d="M1656.43,984.46c-16.49-1.32-36.75-3.46-64,8s-79.84-10.23-111.39-7.59-56.64,6.18-60.94,12.79,48.4,21.17,73.13,19.19,53.78-4.86,82.82.22,58.8,14.33,81.74,10.36S1656.43,984.46,1656.43,984.46Z"
            fill="#4a9375"
          />
        </g>
        <g>
          <path
            d="M1211.56,1088.41s308,29.55,231.78,158.66c269.1,12.44,248.88-10.89,238-39.67s-73.11-95.66-73.11-95.66Z"
            fill="#5a9e94"
          />
          <path
            d="M1715.44,1185.62c-49.77,14-114.33-18.66-177.33-36.55s-126-7.78-179.66-.78-168-44.33-158.66-67.66,63.78-17.78,132.22-27.11c14.83-2,31.2-10.27,48.35-8.25,61.65,7.22,133.32,21.7,179.64-9.3l.67-.45c59.11-40.45,88.66-4.67,124.44,0,0,0,5.43,9.23,12.59,23.13,2.16,4.2,4.49,8.84,6.87,13.77C1724.51,1113.8,1748.34,1176.37,1715.44,1185.62Z"
            fill="#3dd87c"
          />
          <path
            d="M1714.44,1183.62a87.56,87.56,0,0,1-16.68,4.16,117.48,117.48,0,0,1-17.29,1.21,164.61,164.61,0,0,1-17.33-1c-5.75-.64-11.46-1.58-17.14-2.62-22.69-4.36-44.62-11.32-66.34-18s-43.29-13.82-64.88-17.71a277.29,277.29,0,0,0-33-3.88l-4.15-.27-4.17-.15c-2.78-.07-5.55-.24-8.33-.24h-8.35c-2.79,0-5.58.13-8.37.18q-16.74.43-33.54,2c-11.21,1-22.43,2.22-33.7,3.55l-16.94,2-4.24.5c-.73.09-1.37.17-2.17.25l-2.35.22c-3.1.22-6.17.27-9.21.22-12.14-.27-23.77-2.34-35.14-5-5.68-1.35-11.27-3-16.81-4.7s-11-3.63-16.42-5.7a306.48,306.48,0,0,1-31.64-14.09,204,204,0,0,1-29.44-18.24,86.62,86.62,0,0,1-12.85-11.75,31.54,31.54,0,0,1-4.81-7.34,13.41,13.41,0,0,1-1.15-4.25,8.2,8.2,0,0,1,.74-4.25,7.81,7.81,0,0,0-.09,4.15,12.59,12.59,0,0,0,1.61,3.77,29.65,29.65,0,0,0,5.44,6.24,85.49,85.49,0,0,0,13.6,9.76,235.73,235.73,0,0,0,30.26,14.77c10.4,4.28,21,8,31.73,11.28a311.69,311.69,0,0,0,32.48,8.05c5.45,1,10.91,1.86,16.35,2.41a130.2,130.2,0,0,0,16.18.82c2.65-.05,5.27-.2,7.83-.49l4-.54,4.21-.62,16.92-2.46c22.61-3.2,45.54-5.9,68.74-6.53s46.65.79,69.62,5.5l8.59,1.88c2.84.7,5.66,1.52,8.49,2.27L1539,1140l4.14,1.28c2.76.85,5.48,1.76,8.23,2.65,10.92,3.59,21.68,7.51,32.37,11.47,21.37,7.9,42.46,16.14,64.09,22.29,5.4,1.53,10.85,2.91,16.33,4.09s11,2.08,16.59,2.77a116.77,116.77,0,0,0,16.83.8A97.51,97.51,0,0,0,1714.44,1183.62Z"
            fill="#dcf9f7"
          />
          <path
            d="M1612.43,1066.46c-24.63-2-59.31-14.12-100,3s-102.93-13-150-9-84.59,9.22-91,19.1,72.27,31.61,109.21,28.64,80.3-7.24,123.67.33,87.79,21.4,122.06,15.48S1612.43,1066.46,1612.43,1066.46Z"
            fill="#3db57c"
          />
        </g>
        <ellipse
          cx="1160.12"
          cy="731.9"
          rx="3.52"
          ry="22.44"
          transform="translate(106.62 1610.37) rotate(-72.07)"
          fill="#0e3b68"
          opacity="0.32"
        />
        <path
          d="M443.43,1012.46c22,1,32,47,16,57s-49,28-76,29-23,15-60,16-41,12-57,9-13.62-4.54-17.81-10.27-10.19-29.73-33.19-37.73-48-22-28-35,60-17,66-19S443.43,1012.46,443.43,1012.46Z"
          fill="#b96fc6"
        />
        <path
          d="M738.78,708.46c8,2,37.76,38.64-50,41s-114.69-26.22-114.69-26.22Z"
          fill="#2f5e96"
        />
      </g>
      <g id="e66d8736-3ed5-41c3-84f7-c42a038b18d6" data-name="decor12">
        <g id="ef740bff-b866-43f8-ac98-9fe8ca5089f1" data-name="decor">
          <path
            d="M792.89,762.46c-2.74-6.76-8.45-20.08-6.55-31.28s4-25.16,1.27-29.39"
            fill="#318099"
          />
          <path
            d="M799,684.88c2.12,7,3.39,7.61,0,15.85s-9.72,30.87-9.51,35.52,5.71,23,5.71,23"
            fill="#318099"
          />
          <path
            d="M801.14,719.55c1.48,2.54-1.48,9.93-5.92,16.7s-5.71,26.21-5.71,26.21"
            fill="#318099"
          />
          <path
            d="M785.92,674.94c-.85-3.8-4-3-3.6,0s1.06,4.65,0,4.87-3.59,0-2.53,5.07l1.05,5.07s-5.7-2.75.43,5.71c-1.06,1.06-4,1.48.84,5.29-.42.84-3.59.84-1.48,3.8s8.8,6.56,8.8,6.56,6-11.63,3.46-13.54-3.38,1.27-3.38,1.27,5.29-13.1,0-8.66c.21-1.48,5.08-9.52,0-7,.64-2.33,2.12-9.94-2.11-4A8,8,0,0,0,785.92,674.94Z"
            fill="#318099"
          />
          <path
            d="M789.22,711.31s6-11.63,3.46-13.54S789.3,699,789.3,699s5.29-13.1,0-8.66c.21-1.48,5.07-9.52,0-7,.63-2.33,2.11-9.94-2.11-4a8,8,0,0,0-1.48-4.44"
            fill="#318099"
          />
          <path
            d="M789.3,711.3s2.33-11.62-.21-13.53-4-.84-4-.84,5.29-10.15.64-6.55c.21-1.48,3.8-8.25,0-7,.21-1.06.21-7.4-1.69-5.5a25.36,25.36,0,0,1,0-4.65"
            fill="#318099"
          />
          <path
            d="M785.92,674.94c-.85-3.8-4-3-3.6,0s1.06,4.65,0,4.87-3.59,0-2.53,5.07l1.05,5.07s-5.7-2.75.43,5.71c-1.06,1.06-4,1.48.84,5.29-.42.84-3.59.84-1.48,3.8s8.8,6.56,8.8,6.56"
            fill="#318099"
          />
          <path
            d="M796.91,652.32c-.84-3.8-4-3-3.59,0s1,4.66,0,4.87-3.6,0-2.54,5.07l1.06,5.07s-5.71-2.74.42,5.71c-1.06,1.06-4,1.48.85,5.29-.43.84-3.6.84-1.48,3.8s8.79,6.56,8.79,6.56,6-11.63,3.47-13.53-3.39,1.26-3.39,1.26,5.29-13.1,0-8.66c.22-1.48,5.08-9.52,0-7,.64-2.33,2.12-9.94-2.11-4A8,8,0,0,0,796.91,652.32Z"
            fill="#318099"
          />
          <path
            d="M800.21,688.69s6-11.63,3.47-13.53-3.39,1.26-3.39,1.26,5.29-13.1,0-8.66c.21-1.48,5.08-9.52,0-7,.64-2.33,2.12-9.94-2.11-4a8,8,0,0,0-1.48-4.44"
            fill="#318099"
          />
          <path
            d="M800.29,688.68s2.33-11.62-.21-13.52-4-.85-4-.85,5.28-10.15.63-6.55c.21-1.48,3.8-8.25,0-7,.21-1.06.21-7.4-1.69-5.5a26.56,26.56,0,0,1,0-4.65"
            fill="#318099"
          />
          <path
            d="M796.91,652.32c-.84-3.8-4-3-3.59,0s1,4.66,0,4.87-3.6,0-2.54,5.07l1.06,5.07s-5.71-2.74.42,5.71c-1.06,1.06-4,1.48.85,5.29-.43.84-3.6.84-1.48,3.8s8.79,6.56,8.79,6.56"
            fill="#318099"
          />
          <path
            d="M811.39,685.89c.51-3.86-2.75-4.16-3.37-1.24s-.61,4.74-1.67,4.57-3.38-1.23-4.13,3.89l-.75,5.13s-4.42-4.54-1.56,5.51c-1.36.63-4.28,0-1,5.25-.68.65-3.66-.44-2.69,3.07s6,9.18,6,9.18,9.64-8.86,7.91-11.52-3.61,0-3.61,0,9.46-10.5,3-8.14c.71-1.32,8-7.19,2.4-6.55,1.4-2,5.4-8.61-.6-4.5A8.09,8.09,0,0,0,811.39,685.89Z"
            fill="#318099"
          />
          <path
            d="M802,721.17s9.64-8.86,7.91-11.52-3.61,0-3.61,0,9.46-10.49,3-8.14c.7-1.31,8-7.19,2.39-6.55,1.4-2,5.4-8.6-.6-4.5a8,8,0,0,0,.13-4.67"
            fill="#318099"
          />
          <path
            d="M802.07,721.2s6.18-10.12,4.45-12.78-3.48-2.17-3.48-2.17,8.45-7.72,2.85-5.94c.71-1.32,6.41-6.44,2.4-6.55.56-.92,2.74-6.88.3-5.74a26.17,26.17,0,0,1,1.6-4.37"
            fill="#318099"
          />
          <path
            d="M811.39,685.89c.51-3.86-2.75-4.16-3.37-1.24s-.61,4.74-1.67,4.57-3.38-1.23-4.13,3.89l-.75,5.13s-4.42-4.54-1.56,5.51c-1.36.63-4.28,0-1,5.25-.68.65-3.66-.44-2.69,3.07s6,9.18,6,9.18"
            fill="#318099"
          />
        </g>
        <g id="a440814a-6cc5-403b-8ab0-1b8b2187cb1b" data-name="decor">
          <path
            d="M257.89,754.46c-2.74-6.76-8.45-20.08-6.55-31.28s4-25.16,1.27-29.39"
            fill="#318099"
          />
          <path
            d="M264,676.88c2.12,7,3.39,7.61,0,15.85s-9.72,30.87-9.51,35.52,5.71,23,5.71,23"
            fill="#318099"
          />
          <path
            d="M266.14,711.55c1.48,2.54-1.48,9.93-5.92,16.7s-5.71,26.21-5.71,26.21"
            fill="#318099"
          />
          <path
            d="M250.92,666.94c-.85-3.8-4-3-3.6,0s1.06,4.65,0,4.87-3.59,0-2.53,5.07l1.05,5.07s-5.7-2.75.43,5.71c-1.06,1.06-4,1.48.84,5.29-.42.84-3.59.84-1.48,3.8s8.8,6.56,8.8,6.56,6-11.63,3.46-13.54-3.38,1.27-3.38,1.27,5.29-13.1,0-8.66c.21-1.48,5.08-9.52,0-7,.64-2.33,2.12-9.94-2.11-4A8,8,0,0,0,250.92,666.94Z"
            fill="#318099"
          />
          <path
            d="M254.22,703.31s6-11.63,3.46-13.54S254.3,691,254.3,691s5.29-13.1,0-8.66c.21-1.48,5.07-9.52,0-7,.63-2.33,2.11-9.94-2.11-4a8,8,0,0,0-1.48-4.44"
            fill="#318099"
          />
          <path
            d="M254.3,703.3s2.33-11.62-.21-13.53-4-.84-4-.84,5.29-10.15.64-6.55c.21-1.48,3.8-8.25,0-7,.21-1.06.21-7.4-1.69-5.5a25.36,25.36,0,0,1,0-4.65"
            fill="#318099"
          />
          <path
            d="M250.92,666.94c-.85-3.8-4-3-3.6,0s1.06,4.65,0,4.87-3.59,0-2.53,5.07l1.05,5.07s-5.7-2.75.43,5.71c-1.06,1.06-4,1.48.84,5.29-.42.84-3.59.84-1.48,3.8s8.8,6.56,8.8,6.56"
            fill="#318099"
          />
          <path
            d="M261.91,644.32c-.84-3.8-4-3-3.59,0s1.05,4.66,0,4.87-3.6,0-2.54,5.07l1.06,5.07s-5.71-2.74.42,5.71c-1.06,1.06-4,1.48.85,5.29-.43.84-3.6.84-1.48,3.8s8.79,6.56,8.79,6.56,6-11.63,3.47-13.53-3.39,1.26-3.39,1.26,5.29-13.1,0-8.66c.22-1.48,5.08-9.52,0-7,.64-2.33,2.12-9.94-2.11-4A8,8,0,0,0,261.91,644.32Z"
            fill="#318099"
          />
          <path
            d="M265.21,680.69s6-11.63,3.47-13.53-3.39,1.26-3.39,1.26,5.29-13.1,0-8.66c.21-1.48,5.08-9.52,0-7,.64-2.33,2.12-9.94-2.11-4a8,8,0,0,0-1.48-4.44"
            fill="#318099"
          />
          <path
            d="M265.29,680.68s2.33-11.62-.21-13.52-4-.85-4-.85,5.28-10.15.63-6.55c.21-1.48,3.8-8.25,0-7,.21-1.06.21-7.4-1.69-5.5a26.56,26.56,0,0,1,0-4.65"
            fill="#318099"
          />
          <path
            d="M261.91,644.32c-.84-3.8-4-3-3.59,0s1.05,4.66,0,4.87-3.6,0-2.54,5.07l1.06,5.07s-5.71-2.74.42,5.71c-1.06,1.06-4,1.48.85,5.29-.43.84-3.6.84-1.48,3.8s8.79,6.56,8.79,6.56"
            fill="#318099"
          />
          <path
            d="M276.39,677.89c.51-3.86-2.75-4.16-3.37-1.24s-.61,4.74-1.67,4.57-3.38-1.23-4.13,3.89l-.75,5.13s-4.42-4.54-1.56,5.51c-1.36.63-4.28,0-1,5.25-.68.65-3.66-.44-2.69,3.07s6,9.18,6,9.18,9.64-8.86,7.91-11.52-3.61,0-3.61,0,9.46-10.5,3-8.14c.71-1.32,8-7.19,2.4-6.55,1.4-2,5.4-8.61-.6-4.5A8.09,8.09,0,0,0,276.39,677.89Z"
            fill="#318099"
          />
          <path
            d="M267,713.17s9.64-8.86,7.91-11.52-3.61,0-3.61,0,9.46-10.49,3-8.14c.7-1.31,8-7.19,2.39-6.55,1.4-2,5.4-8.6-.6-4.5a8,8,0,0,0,.13-4.67"
            fill="#318099"
          />
          <path
            d="M267.07,713.2s6.18-10.12,4.45-12.78-3.48-2.17-3.48-2.17,8.45-7.72,2.85-5.94c.71-1.32,6.41-6.44,2.4-6.55.56-.92,2.74-6.88.3-5.74a26.17,26.17,0,0,1,1.6-4.37"
            fill="#318099"
          />
          <path
            d="M276.39,677.89c.51-3.86-2.75-4.16-3.37-1.24s-.61,4.74-1.67,4.57-3.38-1.23-4.13,3.89l-.75,5.13s-4.42-4.54-1.56,5.51c-1.36.63-4.28,0-1,5.25-.68.65-3.66-.44-2.69,3.07s6,9.18,6,9.18"
            fill="#318099"
          />
        </g>
        <g>
          <ellipse cx="618.61" cy="796.96" rx="21.5" ry="4.5" fill="#161470" />
          <g>
            <path
              d="M627.24,796.38a1.93,1.93,0,0,0,.6-3.64,7,7,0,0,0-5.76-.37c5.67-2.43,8.58-5.4,4.86-8.1-3-2.16-7.56,5.67-8.64,5.67s.54-3.24,3-6.21,2.16-5.41.27-6.22-5.13.54-5.95,8.92c0-1.35.54-9.73-1.62-8.92s-3.78,5.41-.27,10.27c-2.16.81-1.89-1.35-1.89-1.35s-1.08-8.11-4.86-6.49-2.7,5.95,0,8.65,2.7,4.32-.81,2.7-5.14-5.4-8.38-1.62,5.67,8.38,10.81,8.65C612.29,798.51,622.12,797.15,627.24,796.38Z"
              fill="url(#b84978ef-de00-428d-a931-2c1e59df6960)"
            />
            <path
              d="M624,795.65c.2-1.53-2.68-3.07-5-1.15,3.46-3.07,4.23-5.57,2.5-5.57s-5.57,3.27-6.33,3.27,1.69-1.5,3.42-3.61.8-3.75-.54-4.32S613,784.94,612,790a.88.88,0,0,1-.59.67c-.3.09-.64-.69-.64-.69s-1.73-6.57-4.41-5.42-1.92,4.22,0,6.14,1.91,3.07-.58,1.92-3.65-3.84-6-1.15,2.69,4,6.33,4.22S624,795.65,624,795.65Z"
              fill="url(#b2ce4dac-9d8a-4c28-bd59-c3b249434ca7)"
            />
            <path
              d="M617.27,797.8c-.72-.26,2.1-.83,4.44-2.23s2-3.25,1-4.25-5-1.09-7.64,3.31a.88.88,0,0,1-.79.42c-.31,0-.36-.86-.36-.86s.6-6.77-2.32-6.6-3.23,3.32-2.08,5.78.77,3.54-1.19,1.61-2.13-4.85-5.21-3.1,1.16,4.7,4.53,6.12S618,798.06,617.27,797.8Z"
              fill="url(#ba16cce4-e911-4b5f-a24b-897ea98f6ecc)"
            />
          </g>
        </g>
        <g opacity="0.47">
          <path
            d="M1188.54,608.7a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1149.15,614.32,1175,610.72,1188.54,608.7Z"
            fill="url(#b65fff47-6409-4950-9135-a29080a748f2)"
          />
          <path
            d="M1179.93,606.77c.5-4-7.08-8.08-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.05,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.69,11.12S1179.93,606.77,1179.93,606.77Z"
            fill="#318099"
          />
          <path
            d="M1162.26,612.45c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.19-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.07,12.39,11.93,16.12S1164.17,613.13,1162.26,612.45Z"
            fill="#318099"
          />
        </g>
        <g opacity="0.47">
          <path
            d="M1525.54,614.7a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1486.15,620.32,1512,616.72,1525.54,614.7Z"
            fill="url(#b606e0e4-be50-4cd7-aa16-80688afc0275)"
          />
          <path
            d="M1516.93,612.77c.5-4-7.08-8.08-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.05,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.69,11.12S1516.93,612.77,1516.93,612.77Z"
            fill="#318099"
          />
          <path
            d="M1499.26,618.45c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.19-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.07,12.39,11.93,16.12S1501.17,619.13,1499.26,618.45Z"
            fill="#318099"
          />
        </g>
        <g opacity="0.47">
          <path
            d="M518.54,702.7a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,14.95-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56S475,655.13,465.08,659.4s-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C479.15,708.32,505,704.72,518.54,702.7Z"
            fill="url(#fe711a34-732e-4111-ab74-08e1365c1938)"
          />
          <path
            d="M509.93,700.77c.5-4-7.08-8.08-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.05,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.69,11.12S509.93,700.77,509.93,700.77Z"
            fill="#318099"
          />
          <path
            d="M492.26,706.45c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.19-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17S458,703.23,466.82,707,494.17,707.13,492.26,706.45Z"
            fill="#318099"
          />
        </g>
        <g opacity="0.47">
          <path
            d="M378.54,717.7a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,14.95-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56S335,670.13,325.08,674.4s-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C339.15,723.32,365,719.72,378.54,717.7Z"
            fill="url(#e2761370-1d57-48ad-ad72-a62ee9801391)"
          />
          <path
            d="M369.93,715.77c.5-4-7.08-8.08-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.05,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.69,11.12S369.93,715.77,369.93,715.77Z"
            fill="#318099"
          />
          <path
            d="M352.26,721.45c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.19-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17S318,718.23,326.82,722,354.17,722.13,352.26,721.45Z"
            fill="#318099"
          />
        </g>
        <g>
          <path
            d="M245.94,960.74c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.61a118.13,118.13,0,0,1,4.47,33.42c3.08,0,6.15,0,9.22.06.18-1.92.39-3.58.61-4.88C258.29,1040.05,246.59,980.24,245.94,960.74Z"
            fill="url(#e8f4970d-66ec-41a2-a1ad-1f141c83eaaf)"
          />
          <path
            d="M235.54,947.74c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.6a122.18,122.18,0,0,1,3.78,46.25q4.53.1,9,.16c.39-7.41.83-14.08,1.48-17.8C247.89,1027.05,236.19,967.24,235.54,947.74Z"
            fill="url(#a82896fa-10b3-420c-82b9-51a2b017d85a)"
          />
          <path
            d="M256.34,939.29c-.65-19.5,11.71-30.55,10.41-31.85s-2.6-5.85-11.71,0-13,56.55-2.6,93.6c6.19,22.05,4.79,40,2.77,54.94,3.21,0,6.42,0,9.63,0,.52-10.53,1-21.22,1.91-26.34C268.7,1018.6,257,958.79,256.34,939.29Z"
            fill="url(#a3c4c1e5-708f-4de4-bfa7-4ee46b8edc5c)"
          />
          <path
            d="M225.14,932.14c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.6c7.12,25.34,4.2,45.21,1.85,61.48,3.4.13,6.79.24,10.19.32.68-12.41,1.16-27,2.26-33.19C237.49,1011.45,225.79,951.64,225.14,932.14Z"
            fill="url(#ac6bea89-a9cb-49a7-8e75-1f207ef6ed4f)"
          />
          <path
            d="M214.74,954.89c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.61a119,119,0,0,1,4.34,38.36c3,.16,5.95.29,8.93.4.28-4.21.61-7.79,1-10.16C227.09,1034.2,215.39,974.39,214.74,954.89Z"
            fill="url(#e70ee380-511a-4707-9880-fcd51af38599)"
          />
          <path
            d="M193.94,954.89c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.61a119,119,0,0,1,4.4,36.88q4.47.42,8.95.75c.26-3.71.57-6.87,1-9C206.29,1034.2,194.59,974.39,193.94,954.89Z"
            fill="url(#a49d33e7-d77d-4e8a-89b8-b8315aec5f8b)"
          />
          <path
            d="M204.34,939.29c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.6c6,21.22,4.88,38.6,3,53.24,3.15.24,6.3.43,9.46.61.5-10.17,1-20.3,1.85-25.24C216.69,1018.6,205,958.79,204.34,939.29Z"
            fill="url(#e2668173-7c88-41d3-aab4-d0c52f8924c3)"
          />
          <path
            d="M277.15,917.84c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.6,93.6c9.44,33.65,1.2,57.64.09,76.37l10.84-.06c1.48-12.15,1.77-38.65,3.37-47.71C289.5,997.14,277.8,937.34,277.15,917.84Z"
            fill="url(#ba7b7732-c6fd-4268-9c2c-b3a2f185fffb)"
          />
          <path
            d="M252.44,1052.4s7.15,5.2,9.75,0,2.61-42.26,4.56-53.31-9.76-70.85-10.41-90.35,11.71-30.55,10.41-31.85-2.6-5.85-11.71,0-13,56.55-2.6,93.6S251.79,1032.9,252.44,1052.4Z"
            fill="url(#a38098a3-d88a-4654-b64f-5b23885f4cbb)"
          />
          <path
            d="M221.24,1052.4s7.15,5.2,9.75,0,2.6-42.26,4.55-53.31-9.75-70.85-10.4-90.35,11.7-30.55,10.4-31.85-2.6-5.85-11.7,0-13,56.55-2.6,93.6S220.59,1032.9,221.24,1052.4Z"
            fill="url(#ac127165-b558-4482-abc9-f5426c72b205)"
          />
          <path
            d="M193.94,935.39c-1.3-1.3-2.6-5.85-11.7,0s-13,56.55-2.6,93.61a118.87,118.87,0,0,1,4.14,23.41c3.46.41,6.91.78,10.37,1.1-.27-17.37-10-68.52-10.61-86.27C182.89,947.74,195.24,936.69,193.94,935.39Z"
            fill="url(#ab0415e0-51b0-460c-bb19-9e395936f094)"
          />
          <path
            d="M266.75,960.74c-.65-19.5,11.7-30.55,10.4-31.85s-2.6-5.85-11.7,0-13,56.55-2.61,93.61a118.24,118.24,0,0,1,4.48,33.48l9.22,0c.18-1.9.38-3.55.61-4.84C279.1,1040.05,267.4,980.24,266.75,960.74Z"
            fill="url(#e30cdc21-bbaf-460f-b3fd-68c5bfd694dc)"
          />
        </g>
        <g id="a019b4aa-6a08-4a62-9685-48ab84519dc2" data-name="decor">
          <path
            d="M1055.87,592.5c-1.8-4.44-5.56-13.2-4.3-20.56s2.64-16.54.83-19.31"
            fill="#3499c1"
          />
          <path
            d="M1059.9,541.51c1.39,4.59,2.22,5,0,10.42s-6.39,20.29-6.25,23.34,3.75,15.15,3.75,15.15"
            fill="#3499c1"
          />
          <path
            d="M1061.29,564.3c1,1.66-1,6.53-3.89,11s-3.75,17.23-3.75,17.23"
            fill="#3499c1"
          />
          <path
            d="M1051.29,535c-.56-2.5-2.64-1.94-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.34s-3.75-1.81.28,3.75c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31,4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.61,0-5.7c.14-1,3.33-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64A5.29,5.29,0,0,0,1051.29,535Z"
            fill="#3499c1"
          />
          <path
            d="M1053.45,558.88s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.61,0-5.7c.14-1,3.34-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64a5.29,5.29,0,0,0-1-2.92"
            fill="#3499c1"
          />
          <path
            d="M1053.51,558.88s1.53-7.64-.14-8.89-2.64-.56-2.64-.56,3.48-6.67.42-4.31c.14-1,2.5-5.41,0-4.58.14-.7.14-4.86-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
            fill="#3499c1"
          />
          <path
            d="M1051.29,535c-.56-2.5-2.64-1.94-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.34s-3.75-1.81.28,3.75c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31"
            fill="#3499c1"
          />
          <path
            d="M1058.51,520.11c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.7-2.64,1,.55,3.47-.28.56-2.36.56-1,2.51s5.78,4.31,5.78,4.31,3.94-7.65,2.28-8.9-2.23.83-2.23.83,3.48-8.61,0-5.69c.14-1,3.34-6.25,0-4.59.42-1.53,1.39-6.53-1.39-2.64A5.24,5.24,0,0,0,1058.51,520.11Z"
            fill="#3499c1"
          />
          <path
            d="M1060.68,544s4-7.65,2.28-8.9-2.22.83-2.22.83,3.47-8.61,0-5.69c.13-1,3.33-6.25,0-4.59.41-1.53,1.38-6.53-1.39-2.64a5.29,5.29,0,0,0-1-2.92"
            fill="#3499c1"
          />
          <path
            d="M1060.74,544s1.52-7.64-.14-8.89-2.64-.56-2.64-.56,3.47-6.66.41-4.3c.14-1,2.5-5.42,0-4.59.14-.69.14-4.86-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
            fill="#3499c1"
          />
          <path
            d="M1058.51,520.11c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.7-2.64,1,.55,3.47-.28.56-2.36.56-1,2.51s5.78,4.31,5.78,4.31"
            fill="#3499c1"
          />
          <path
            d="M1068,542.18c.34-2.54-1.81-2.74-2.22-.82s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.42-2.81,0-.67,3.45-.45.43-2.41-.28-1.77,2s3.94,6,3.94,6,6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.9,2-5.35c.47-.86,5.28-4.72,1.58-4.3.91-1.3,3.55-5.66-.4-3A5.24,5.24,0,0,0,1068,542.18Z"
            fill="#3499c1"
          />
          <path
            d="M1061.85,565.37s6.34-5.83,5.2-7.58-2.37,0-2.37,0,6.22-6.89,2-5.35c.47-.86,5.28-4.72,1.58-4.3.91-1.29,3.55-5.66-.4-3a5.25,5.25,0,0,0,.09-3.07"
            fill="#3499c1"
          />
          <path
            d="M1061.91,565.38s4.06-6.65,2.92-8.4-2.29-1.43-2.29-1.43,5.56-5.07,1.87-3.9c.47-.86,4.21-4.23,1.58-4.3.37-.61,1.8-4.52.2-3.78a16.68,16.68,0,0,1,1-2.87"
            fill="#3499c1"
          />
          <path
            d="M1068,542.18c.34-2.54-1.81-2.74-2.22-.82s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.42-2.81,0-.67,3.45-.45.43-2.41-.28-1.77,2s3.94,6,3.94,6"
            fill="#3499c1"
          />
        </g>
        <path
          d="M1030.63,739.61c-3.23,1.39-5.76,3.23-6.17,6.4s-1,5.71-2.76,6c-.52.63,0,1,0,1s2.76.11,3.28,1.44a6.39,6.39,0,0,0,7,3.4c-.87-.4-4.62-.75-3.75-3.4S1031,752,1031,752s.23,2.48,1,3.11,3.34,0,3.34,0-2,.06-2-1.21,0-3.75-1-3.75.29.18,1.27-1.38.06-3.4,1.73-4.09c-3.52.28-4.15,4.09-4.15,4.09h-1.44s-2-1.15-2-2.83a22.68,22.68,0,0,1,.63-4.55Z"
          fill="#314e60"
          opacity="0.68"
        />
        <path
          d="M935.41,777.16c3.13,1.6,5.54,3.61,5.73,6.8s.66,5.76,2.37,6.16c.47.67-.07,1-.07,1s-2.77-.07-3.37,1.22a6.39,6.39,0,0,1-7.25,2.93c.89-.35,4.65-.45,4-3.15s-2.6-2.6-2.6-2.6-.4,2.46-1.19,3-3.33-.22-3.33-.22,2,.19,2-1.08.25-3.74,1.29-3.67-.3.16-1.18-1.46.17-3.4-1.45-4.2c3.49.52,3.87,4.36,3.87,4.36l1.44.1s2-1,2.2-2.69a22.64,22.64,0,0,0-.33-4.58Z"
          fill="#314e60"
          opacity="0.33"
        />
        <path
          d="M981.06,634c3.13,1.59,5.54,3.6,5.73,6.79s.65,5.76,2.36,6.17c.48.66-.07,1-.07,1s-2.76-.07-3.37,1.22a6.37,6.37,0,0,1-7.24,2.93c.89-.35,4.65-.44,4-3.15s-2.6-2.59-2.6-2.59-.39,2.45-1.18,3-3.34-.23-3.34-.23,2,.19,2-1.07.25-3.74,1.28-3.67-.3.15-1.17-1.47.17-3.4-1.46-4.2c3.49.52,3.87,4.36,3.87,4.36l1.44.1s2-1,2.2-2.69a22.64,22.64,0,0,0-.33-4.58Z"
          fill="#314e60"
          opacity="0.68"
        />
        <path
          d="M208.25,632.78c10.81,4.63,19.29,10.81,20.65,21.42s3.47,19.1,9.26,20.07c1.73,2.12,0,3.28,0,3.28s-9.26.38-11,4.82-9.65,13.7-23.54,11.38c2.89-1.35,15.44-2.5,12.54-11.38s-9.26-8.1-9.26-8.1-.77,8.29-3.28,10.42-11.19,0-11.19,0,6.56.19,6.56-4.06,0-12.54,3.47-12.54-1,.58-4.24-4.63-.2-11.38-5.79-13.7c11.77,1,13.89,13.7,13.89,13.7h4.82s6.56-3.86,6.76-9.45-2.12-15.25-2.12-15.25Z"
          fill="#314e60"
        />
        <g>
          <g>
            <path
              d="M754.17,1017c-3.74-.64-13.45-3.18-24.7,0s-4,11,1.35,11.85,24.94,1.84,28.24-.73S762.85,1018.49,754.17,1017Z"
              fill="#f44e92"
            />
            <path
              d="M760.65,1022.16s11,25.18-4.16,43.77H728.74s-15.06-19.11-5.21-43.3C751.8,1024.26,760.65,1022.16,760.65,1022.16Z"
              fill="#f44e92"
            />
            <ellipse
              cx="742.62"
              cy="1022.14"
              rx="13.88"
              ry="2.84"
              fill="#8e1442"
            />
            <ellipse
              cx="742.62"
              cy="1065.9"
              rx="13.88"
              ry="2.84"
              fill="#ff1555"
            />
          </g>
          <ellipse
            cx="740.66"
            cy="1074.46"
            rx="33"
            ry="8"
            fill="#8e1442"
            opacity="0.57"
          />
          <path
            d="M720.39,1043.57a43.78,43.78,0,0,1,3.13-20.9,35.09,35.09,0,0,0,13.29,5.11c4.28,6.48,5.26,6.61,5.26,6.61s4.76-.86,6.84-6.61a30.12,30.12,0,0,0,12.2-4.45c1.24,3.32,4.47,13.36,3,24.41l-33.94,5Z"
            fill="#8e1442"
            opacity="0.58"
          />
          <g>
            <path
              d="M727.87,1027.58c-3.34.26-12.19.16-21.14,5.29s-1.1,10.29,3.69,9.87,21.75-3.77,24-6.68S735.62,1027,727.87,1027.58Z"
              fill="#f44e92"
            />
            <path
              d="M734.52,1030.59s14.81,19.21,5.81,38.37l-23.76,5.94s-17-13.14-13.73-36C727.39,1034.28,734.52,1030.59,734.52,1030.59Z"
              fill="#f44e92"
            />
            <ellipse
              cx="719.08"
              cy="1034.43"
              rx="12.25"
              ry="2.5"
              transform="translate(-229.45 205.32) rotate(-14.04)"
              fill="#8e1442"
            />
            <ellipse
              cx="728.45"
              cy="1071.91"
              rx="12.25"
              ry="2.5"
              transform="translate(-238.26 208.71) rotate(-14.04)"
              fill="#f44e92"
            />
          </g>
          <path
            d="M735.79,1032.43c2.75,4.26,8.9,15.44,7.13,27.89a13.55,13.55,0,0,1-3-2.34s-6.16-18.62-16.35-17.69C723.52,1040.29,732.3,1037.16,735.79,1032.43Z"
            fill="#8e1442"
            opacity="0.45"
          />
          <g>
            <path
              d="M766.68,1038.64c-2.84-1-10.07-4.25-19.26-3.25s-4.6,8-.51,9.42,19.2,4.72,22.12,3.15S773.26,1040.93,766.68,1038.64Z"
              fill="#f44e92"
            />
            <path
              d="M771.06,1043.5s5.26,21.09-9,33.59l-21.64-3.66s-9.22-16.89,1.65-34.45C763.88,1044,771.06,1043.5,771.06,1043.5Z"
              fill="#f44e92"
            />
            <ellipse
              cx="757"
              cy="1041.11"
              rx="2.24"
              ry="10.97"
              transform="translate(-395.75 1613.93) rotate(-80.4)"
              fill="#8e1442"
            />
            <ellipse
              cx="751.23"
              cy="1075.24"
              rx="2.24"
              ry="10.97"
              transform="translate(-434.21 1636.68) rotate(-80.4)"
              fill="#f44e92"
            />
          </g>
          <path
            d="M758.16,1047.45c13.28,1.33,13.26-2.07,13.26-2.07.9,5.43,2.33,21.46-9.38,31.71l-1.48-.25C768.9,1051.87,758.16,1047.45,758.16,1047.45Z"
            fill="#8e1442"
            opacity="0.45"
          />
          <path
            d="M735.22,1072.41c-12.08,3-13,3.42-16.75,3.17-.3-.15-2.26-1-2.54-1.22a37.69,37.69,0,0,1-4.91-5.26C719.08,1072.53,727.32,1072.78,735.22,1072.41Z"
            fill="#8e1442"
            opacity="0.45"
          />
        </g>
        <g>
          <g>
            <path
              d="M1660.07,855.39c-3.74-.63-13.45-3.18-24.69,0s-4,11,1.34,11.86,24.94,1.83,28.24-.74S1668.75,856.85,1660.07,855.39Z"
              fill="#f44e92"
            />
            <path
              d="M1666.55,860.52s11,25.19-4.16,43.77h-27.75s-15.06-19.11-5.2-43.3C1657.7,862.62,1666.55,860.52,1666.55,860.52Z"
              fill="#f44e92"
            />
            <ellipse
              cx="1648.52"
              cy="860.5"
              rx="13.88"
              ry="2.84"
              fill="#8e1442"
            />
            <ellipse
              cx="1648.52"
              cy="904.26"
              rx="13.88"
              ry="2.84"
              fill="#ff1555"
            />
          </g>
          <ellipse
            cx="1646.56"
            cy="912.82"
            rx="33"
            ry="8"
            fill="#8e1442"
            opacity="0.57"
          />
          <path
            d="M1626.29,881.93a43.78,43.78,0,0,1,3.13-20.9,35.21,35.21,0,0,0,13.29,5.12c4.28,6.48,5.26,6.6,5.26,6.6s4.76-.86,6.84-6.6a30,30,0,0,0,12.2-4.46c1.24,3.33,4.47,13.36,3,24.41l-33.94,5Z"
            fill="#8e1442"
            opacity="0.58"
          />
          <g>
            <path
              d="M1633.78,866c-3.34.26-12.2.15-21.15,5.28s-1.1,10.29,3.69,9.87,21.75-3.77,24-6.68S1641.52,865.34,1633.78,866Z"
              fill="#f44e92"
            />
            <path
              d="M1640.42,869s14.81,19.21,5.81,38.37l-23.76,5.94s-17-13.13-13.73-36C1633.29,872.64,1640.42,869,1640.42,869Z"
              fill="#f44e92"
            />
            <ellipse
              cx="1624.98"
              cy="872.79"
              rx="12.25"
              ry="2.5"
              transform="translate(-163.18 420.24) rotate(-14.04)"
              fill="#8e1442"
            />
            <ellipse
              cx="1634.35"
              cy="910.27"
              rx="12.25"
              ry="2.5"
              transform="translate(-171.99 423.63) rotate(-14.04)"
              fill="#f44e92"
            />
          </g>
          <path
            d="M1641.69,870.79c2.75,4.26,8.91,15.44,7.13,27.89a13.55,13.55,0,0,1-3-2.34s-6.16-18.62-16.35-17.68C1629.42,878.66,1638.2,875.53,1641.69,870.79Z"
            fill="#8e1442"
            opacity="0.45"
          />
          <g>
            <path
              d="M1672.58,877c-2.83-1-10.07-4.26-19.26-3.26s-4.59,8-.51,9.42,19.2,4.72,22.12,3.16S1679.16,879.29,1672.58,877Z"
              fill="#f44e92"
            />
            <path
              d="M1677,881.86s5.26,21.1-9,33.59l-21.64-3.66s-9.22-16.89,1.65-34.45C1669.78,882.33,1677,881.86,1677,881.86Z"
              fill="#f44e92"
            />
            <ellipse
              cx="1662.9"
              cy="879.47"
              rx="2.24"
              ry="10.97"
              transform="translate(518.49 2372.46) rotate(-80.4)"
              fill="#8e1442"
            />
            <ellipse
              cx="1657.13"
              cy="913.6"
              rx="2.24"
              ry="10.97"
              transform="translate(480.03 2395.21) rotate(-80.4)"
              fill="#f44e92"
            />
          </g>
          <path
            d="M1664.06,885.81c13.28,1.33,13.26-2.07,13.26-2.07.9,5.43,2.33,21.46-9.38,31.71l-1.48-.25C1674.8,890.24,1664.06,885.81,1664.06,885.81Z"
            fill="#8e1442"
            opacity="0.45"
          />
          <path
            d="M1641.12,910.77c-12.07,3-13,3.42-16.75,3.18-.3-.16-2.25-1.06-2.54-1.22a39.21,39.21,0,0,1-4.91-5.27C1625,910.89,1633.22,911.14,1641.12,910.77Z"
            fill="#8e1442"
            opacity="0.45"
          />
        </g>
        <g>
          <g opacity="0.32">
            <path
              d="M1430.17,756.21s10.64-8.45,11.87-12.36,2.9-4,1.36-4.59c-4.58-1.82-3.42-7.44,6.87-4,12.84,4.32,11.74,9.58,2.11,8.11-2.35,1.6-3.15,2.68-4.36,3.54-1,.69,1.5,6-15.64,11.52Z"
              fill="#a13172"
            />
            <ellipse
              cx="1450.53"
              cy="738.95"
              rx="2.17"
              ry="7.56"
              transform="translate(289.17 1879.71) rotate(-71.48)"
              fill="#a13172"
            />
            <path
              d="M1443.13,751.26c3.19-.41,5.49-1.56,7.66-2s4.51-2.39,6.81-3.21,9.69-2.78,6.89-8.77c-3.44-2.66.65-5.81,10-2.64s11,5.79,8.86,7.17c-1.42.92-1.84,4.42-11,5.22s-13.86,2.7-14.48,3.4-2.61,4.49-9.78,5.84-17,2.54-17,2.54Z"
              fill="#a13172"
            />
            <ellipse
              cx="1474.11"
              cy="738.13"
              rx="2.17"
              ry="7.56"
              transform="translate(306.04 1901.51) rotate(-71.48)"
              fill="#a13172"
            />
            <path
              d="M1452.75,753.06c3.24-.53,8.48.47,12.27.66,1.7.08,4.08.49,6.55.74,3.87.39,7.19-.83,8-2.94,1-2.42,6.16-3.93,9.6-.3,3.24,3.4,5.36,7.58,2.1,9.75-1.74,1.15-4.78.42-6.74-.77a11.29,11.29,0,0,0-6.13-1.4,31.14,31.14,0,0,1-9.27-.87c-3.57-.79-14.24-1.33-24.24,1.64s-12.08,1.35-12.24.85a14.35,14.35,0,0,1-.32-2Z"
              fill="#a13172"
            />
            <ellipse
              cx="1486.9"
              cy="755.58"
              rx="3.09"
              ry="5.29"
              transform="translate(-148 1085.52) rotate(-38.35)"
              fill="#a13172"
            />
            <path
              d="M1451.46,755.31a12.67,12.67,0,0,0,6.37-4.9c.62-.7,5.3-2.59,14.48-3.4,7.54-.65,9.25-3,10-4.45a20.27,20.27,0,0,1-9.15-.77c1.4,1.58,2,2.39-.65,3.32s-4-.45-11.42,3-6.68,6-11.56,6.53c-3.29.35-9.65,2.27-13.45,3.47,1.72-.23,3.74-.52,5.81-.84Z"
              fill="#a13172"
              opacity="0.47"
            />
            <g>
              <path
                d="M1464.63,737.57a4.5,4.5,0,0,1-.41,4.78c2.43-1.59,6.16-1.44,6.16-1.44A21.7,21.7,0,0,1,1464.63,737.57Z"
                fill="#a13172"
                opacity="0.47"
              />
              <polygon
                points="1462.89 743.63 1462.89 743.63 1462.89 743.63 1462.89 743.63"
                fill="#a13172"
              />
            </g>
            <path
              d="M1444.94,759.57c10-3,20.67-2.43,24.24-1.64,5.19,1.45,12.31.47,15.09,1.75,0,0-3.06-2.65-3.47-4.39-.76,2-1.49,2.75-5.71,2.79s-5.51-.9-9.56-1.35a74.27,74.27,0,0,0-13.4.18c-2.93.34-12.5,3.41-14.74,3.47s-4.69,0-4.69,0l2.25.88C1436.71,761.43,1439.75,761.11,1444.94,759.57Z"
              fill="#a13172"
              opacity="0.47"
            />
            <path
              d="M1434.39,754c2.33-.62,2-3.25,5.24-5s2.68-3.43,4.13-5.44,2.14-1.65,3.87-2.21a12,12,0,0,1-3.63-1.54h0a17.89,17.89,0,0,0-2,4c-1.23,3.91-11.87,12.36-11.87,12.36C1431.3,756,1432.05,754.63,1434.39,754Z"
              fill="#a13172"
              opacity="0.47"
            />
            <path
              d="M1445.62,752.13a51.94,51.94,0,0,0,8.61-3c1.7-.78,9.54-3.94,9.12-4.69a5.73,5.73,0,0,0-.49-.75,15.81,15.81,0,0,1-3.91,1.91h0s-3.34,1.67-5.85,2.77a9.45,9.45,0,0,1-2.31.91l-.64.15c-2,.53-.86.8-3.74,1.17C1445.19,751.31,1443.5,752.47,1445.62,752.13Z"
              fill="#a13172"
            />
            <path
              d="M1490.18,755c-1.23-2.32-3.55-4.07-5.38-4a2,2,0,0,0-1.92,1.77C1485.28,751.35,1488.58,753.65,1490.18,755Z"
              fill="#a13172"
              opacity="0.47"
            />
            <path
              d="M1475.54,736.34c-3.9-1.43-7.7-1.8-8.49-.81-.28.35-.13.83.34,1.35,1.15-2.41,12.25,1.8,13,2.1A16,16,0,0,0,1475.54,736.34Z"
              fill="#a13172"
              opacity="0.47"
            />
            <path
              d="M1451.41,737.15l-.7-.42c-3.43-1.07-6.53-1.27-7.23-.38-.34.41-.06,1,.63,1.65.21-.06.71.22,1.77,1.25l.2.12C1443.7,735.3,1451.41,737.15,1451.41,737.15Z"
              fill="#a13172"
              opacity="0.47"
            />
          </g>
          <g>
            <path
              d="M1428.36,759.52s-6.56-14.63-10.72-18.53-3.73-5.26-4.92-4.54c-3.53,2.14-9.71-3-2.52-8.33,9-6.61,14.75-1.76,10.09,4.54,1.13,3,2.13,4.46,2.77,6.06.5,1.26,7.44,3.4,8.57,20.8Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="1414.55"
              cy="730.71"
              rx="6.24"
              ry="2.96"
              transform="translate(-167.83 906.63) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M1426.59,745.78c.51-2.78-.13-5.43,0-7.44s-1.39-5.3-1.64-7.69-.25-9.59-8.07-12c-4.15.63-6.55-4.92,0-9.71s10.12-4.07,11.07-1.37c.62,1.79,4.57,4.77,2.68,12.47s-1.14,12.73-.51,13.74,4.41,5.42,3.78,12-2.27,15-2.27,15Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="1420.85"
              cy="711.92"
              rx="6.24"
              ry="2.96"
              transform="translate(-156.36 906.97) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M1431.63,739.72c.38-2.9,3.16-6.17,4.54-9,.63-1.24,1.83-2.77,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.67-7.73,2.6-7.63,5,.09,10.47,1.64,12,5.8.8,2.21-1,4-3,4.61a5.47,5.47,0,0,0-3.52,3.65,14.72,14.72,0,0,1-3.86,6.49c-2,2.15-5.92,10-5.55,19.92s-2.14,10.34-2.77,10.09-2.4-1.26-2.4-1.26Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="1445.06"
              cy="715.33"
              rx="2.96"
              ry="6.24"
              transform="translate(331.41 1881.38) rotate(-72.65)"
              fill="#170"
            />
            <path
              d="M1433.86,742.43a18.64,18.64,0,0,0-3.74-8.63c-.63-1-1.39-6,.51-13.74,1.55-6.31-.63-9.39-2.09-11.14a10,10,0,0,1-3.71,6.47c2.27.13,3.4.25,3.65,3s-1.76,2.77,0,11.09,4.92,9.71,4,13.87c-.6,2.81-.33,9.17-.1,13,.26-1.5.54-3.28.81-5.12Z"
              fill="#11366d"
              opacity="0.47"
            />
            <g>
              <path
                d="M1417.28,718.8a10.41,10.41,0,0,1,5.44,4,8.25,8.25,0,0,1,.21-5.85A13.87,13.87,0,0,1,1417.28,718.8Z"
                fill="#11366d"
                opacity="0.47"
              />
              <polygon
                points="1423.79 724.74 1423.79 724.74 1423.79 724.74 1423.79 724.74"
                fill="#170"
              />
            </g>
            <path
              d="M1436.8,750.69c-.37-10,3.53-17.77,5.55-19.92,3.28-2.9,4.33-9.13,6.67-10.3,0,0-4,.34-6.16-.67,2.14,2.15,2.74,3.25,1.48,6.52s-2.75,3.57-4.51,6.34a38.34,38.34,0,0,0-3.91,10.47c-.5,2.52.13,12.23-.5,14s-1.39,3.66-1.39,3.66l1.71-1.07C1436.43,758.45,1437,755.86,1436.8,750.69Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M1427.1,754.6c0-2.27-3.16-4-4.17-7.81s-3.15-4.67-5-7.32-1.26-2.9-1.39-4.66a6.64,6.64,0,0,1-2.9,1.63h0a39.6,39.6,0,0,0,4,4.55c4.16,3.9,10.72,18.53,10.72,18.53C1428.48,758.51,1427.1,756.87,1427.1,754.6Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M1428.36,744.52c.25-1.9-.51-7.07-.89-9s-1.64-10.34-2.64-10.59a10.36,10.36,0,0,0-1-.19,16.35,16.35,0,0,1,1,4.47h0s.91,3.84,1.42,6.61a8.78,8.78,0,0,1,.34,2.48c0,.17,0,.38,0,.6,0,1.93.65,1.27.2,3.78C1427.28,744.23,1428.1,746.41,1428.36,744.52Z"
              fill="#86e04b"
            />
            <path
              d="M1445.39,712.35c-3.07-.81-5.83-.36-6.29,1.12-.27.86.33,1.89,1.46,2.81C1439.65,713.36,1443.34,712.57,1445.39,712.35Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M1419.21,709.46c-2.87,1.91-4.46,4.56-3.55,5.92a2,2,0,0,0,1.67.77c-2.45-2.72,5.86-8.07,6.44-8.44A9.87,9.87,0,0,0,1419.21,709.46Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M1412.73,728.67l-.7.22c-2.3,1.83-3.48,4.06-2.67,5.28a2.3,2.3,0,0,0,2.11.77c0-.21.48-.38,2-.41l.2-.07C1408.2,733.2,1412.73,728.67,1412.73,728.67Z"
              fill="#11366d"
              opacity="0.47"
            />
          </g>
          <path
            d="M1439.44,719.83a4.74,4.74,0,0,1,.68,2.4,8.84,8.84,0,0,1-.29,2.51,15.81,15.81,0,0,1-2.06,4.56c-1.73,2.75-3.5,5.46-5.43,8.12a34.08,34.08,0,0,1,2-4.49c.75-1.45,1.58-2.86,2.44-4.25a22.06,22.06,0,0,0,2.18-4.2A8,8,0,0,0,1439.44,719.83Z"
            fill="#86e04b"
          />
          <path
            d="M1441.41,710.52c-.66.37-1.29.71-1.87,1.07a3.8,3.8,0,0,0-1.32,1.25,1.92,1.92,0,0,0,0,1.6c.1.31.26.62.39.94s.35.63.5,1a8.22,8.22,0,0,1-1-.63,5.56,5.56,0,0,1-.76-.9,2.49,2.49,0,0,1-.16-2.56,3.48,3.48,0,0,1,2-1.51A5,5,0,0,1,1441.41,710.52Z"
            fill="#86e04b"
          />
          <path
            d="M1416.4,711.11c-.41.64-.81,1.23-1.15,1.82a3.78,3.78,0,0,0-.58,1.72,1.82,1.82,0,0,0,.71,1.43c.23.23.52.42.78.65a10.14,10.14,0,0,1,.9.65,8.85,8.85,0,0,1-1.13-.12,5.65,5.65,0,0,1-1.09-.44,2.47,2.47,0,0,1-1.34-2.19,3.41,3.41,0,0,1,1-2.24A4.82,4.82,0,0,1,1416.4,711.11Z"
            fill="#86e04b"
          />
          <path
            d="M1409.8,729.25c-.34.71-.66,1.38-.9,2a4,4,0,0,0-.3,1.9,2.51,2.51,0,0,0,.86,1.57c.23.25.54.44.81.69a9,9,0,0,1,.94.66A8.07,8.07,0,0,1,1410,736a5.25,5.25,0,0,1-1.12-.48,2.89,2.89,0,0,1-1.47-2.15,3.73,3.73,0,0,1,.64-2.46A4.88,4.88,0,0,1,1409.8,729.25Z"
            fill="#86e04b"
          />
        </g>
        <g>
          <g opacity="0.59">
            <path
              d="M216.17,824.21s10.64-8.45,11.87-12.36,2.9-4,1.36-4.59c-4.58-1.82-3.42-7.44,6.87-4,12.84,4.32,11.74,9.58,2.11,8.11-2.35,1.6-3.15,2.68-4.36,3.54-1,.69,1.5,6-15.64,11.52Z"
              fill="#30406d"
            />
            <ellipse
              cx="236.53"
              cy="806.95"
              rx="2.17"
              ry="7.56"
              transform="translate(-603.76 774.96) rotate(-71.48)"
              fill="#30406d"
            />
            <path
              d="M229.13,819.26c3.19-.41,5.49-1.56,7.66-2s4.51-2.39,6.81-3.21,9.69-2.78,6.89-8.77c-3.44-2.66.65-5.81,10-2.64s11,5.79,8.86,7.17c-1.42.92-1.84,4.42-11,5.22s-13.86,2.7-14.48,3.4-2.61,4.49-9.78,5.84-17,2.54-17,2.54Z"
              fill="#30406d"
            />
            <ellipse
              cx="260.11"
              cy="806.13"
              rx="2.17"
              ry="7.56"
              transform="translate(-586.9 796.76) rotate(-71.48)"
              fill="#30406d"
            />
            <path
              d="M238.75,821.06c3.24-.53,8.48.47,12.27.66,1.7.08,4.08.49,6.55.74,3.87.39,7.19-.83,8.05-2.94,1-2.42,6.16-3.93,9.6-.3,3.24,3.4,5.36,7.58,2.1,9.75-1.74,1.15-4.78.42-6.74-.77a11.29,11.29,0,0,0-6.13-1.4,31.14,31.14,0,0,1-9.27-.87c-3.57-.79-14.24-1.33-24.24,1.64s-12.08,1.35-12.24.85a14.35,14.35,0,0,1-.32-2Z"
              fill="#30406d"
            />
            <ellipse
              cx="272.9"
              cy="823.58"
              rx="3.09"
              ry="5.29"
              transform="matrix(0.78, -0.62, 0.62, 0.78, -452.1, 346.99)"
              fill="#30406d"
            />
            <path
              d="M237.46,823.31a12.67,12.67,0,0,0,6.37-4.9c.62-.7,5.3-2.59,14.48-3.4,7.54-.65,9.25-3,10.05-4.45a20.27,20.27,0,0,1-9.15-.77c1.4,1.58,2,2.39-.65,3.32s-4-.45-11.42,3-6.68,6-11.56,6.53c-3.29.35-9.65,2.27-13.45,3.47,1.72-.23,3.74-.52,5.81-.84Z"
              fill="#30406d"
              opacity="0.47"
            />
            <g>
              <path
                d="M250.63,805.57a4.5,4.5,0,0,1-.41,4.78c2.43-1.59,6.16-1.44,6.16-1.44A21.7,21.7,0,0,1,250.63,805.57Z"
                fill="#30406d"
                opacity="0.47"
              />
              <polygon
                points="248.89 811.63 248.89 811.63 248.89 811.63 248.89 811.63"
                fill="#30406d"
              />
            </g>
            <path
              d="M230.94,827.57c10-3,20.67-2.43,24.24-1.64,5.19,1.45,12.31.47,15.09,1.75,0,0-3.06-2.65-3.47-4.39-.76,2-1.49,2.75-5.71,2.79s-5.51-.9-9.56-1.35a74.27,74.27,0,0,0-13.4.18c-2.93.34-12.5,3.41-14.74,3.47s-4.69,0-4.69,0l2.25.88C222.71,829.43,225.75,829.11,230.94,827.57Z"
              fill="#30406d"
              opacity="0.47"
            />
            <path
              d="M220.39,822c2.33-.62,2-3.25,5.24-5s2.68-3.43,4.13-5.44,2.14-1.65,3.87-2.21a12,12,0,0,1-3.63-1.54h0a17.89,17.89,0,0,0-2,4c-1.23,3.91-11.87,12.36-11.87,12.36C217.3,824,218.05,822.63,220.39,822Z"
              fill="#30406d"
              opacity="0.47"
            />
            <path
              d="M231.62,820.13a51.94,51.94,0,0,0,8.61-3c1.7-.78,9.54-3.94,9.12-4.69a5.73,5.73,0,0,0-.49-.75,15.81,15.81,0,0,1-3.91,1.91h0s-3.34,1.67-5.85,2.77a9.45,9.45,0,0,1-2.31.91l-.64.15c-2,.53-.86.8-3.74,1.17C231.19,819.31,229.5,820.47,231.62,820.13Z"
              fill="#30406d"
            />
            <path
              d="M276.18,823c-1.23-2.32-3.55-4.07-5.38-4a2,2,0,0,0-1.92,1.77C271.28,819.35,274.58,821.65,276.18,823Z"
              fill="#30406d"
              opacity="0.47"
            />
            <path
              d="M261.54,804.34c-3.9-1.43-7.7-1.8-8.49-.81-.28.35-.13.83.34,1.35,1.15-2.41,12.25,1.8,13,2.1A16,16,0,0,0,261.54,804.34Z"
              fill="#30406d"
              opacity="0.47"
            />
            <path
              d="M237.41,805.15l-.7-.42c-3.43-1.07-6.53-1.27-7.23-.38-.34.41-.06,1,.63,1.65.21-.06.71.22,1.77,1.25l.2.12C229.7,803.3,237.41,805.15,237.41,805.15Z"
              fill="#30406d"
              opacity="0.47"
            />
          </g>
          <g>
            <path
              d="M214.36,827.52S207.8,812.89,203.64,809s-3.73-5.26-4.92-4.54c-3.53,2.14-9.71-3-2.52-8.33,9-6.61,14.75-1.76,10.09,4.54,1.13,3,2.13,4.46,2.77,6.06.5,1.26,7.44,3.4,8.57,20.8Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="200.55"
              cy="798.71"
              rx="6.24"
              ry="2.96"
              transform="translate(-409.1 245.1) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M212.59,813.78c.51-2.78-.13-5.43,0-7.44s-1.39-5.3-1.64-7.69-.25-9.59-8.07-12c-4.15.63-6.55-4.92,0-9.71S213,772.89,214,775.59c.62,1.79,4.57,4.77,2.68,12.47s-1.14,12.73-.51,13.74,4.41,5.42,3.78,12-2.27,15-2.27,15Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="206.85"
              cy="779.92"
              rx="6.24"
              ry="2.96"
              transform="translate(-397.63 245.45) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M217.63,807.72c.38-2.9,3.16-6.17,4.54-9,.63-1.24,1.83-2.77,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.67-7.73,2.6-7.63,5,.09,10.47,1.64,12,5.8.8,2.21-1,4-3,4.61a5.47,5.47,0,0,0-3.52,3.65,14.72,14.72,0,0,1-3.86,6.49c-2,2.15-5.92,10-5.55,19.92S220.66,829,220,828.78s-2.4-1.26-2.4-1.26Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="231.06"
              cy="783.33"
              rx="2.96"
              ry="6.24"
              transform="translate(-585.53 770.32) rotate(-72.65)"
              fill="#170"
            />
            <path
              d="M219.86,810.43a18.64,18.64,0,0,0-3.74-8.63c-.63-1-1.39-6,.51-13.74,1.55-6.31-.63-9.39-2.09-11.14a10,10,0,0,1-3.71,6.47c2.27.13,3.4.25,3.65,3s-1.76,2.77,0,11.09,4.92,9.71,4,13.87c-.6,2.81-.33,9.17-.1,13,.26-1.5.54-3.28.81-5.12Z"
              fill="#11366d"
              opacity="0.47"
            />
            <g>
              <path
                d="M203.28,786.8a10.41,10.41,0,0,1,5.44,4,8.25,8.25,0,0,1,.21-5.85A13.87,13.87,0,0,1,203.28,786.8Z"
                fill="#11366d"
                opacity="0.47"
              />
              <polygon
                points="209.79 792.74 209.79 792.74 209.79 792.74 209.79 792.74"
                fill="#170"
              />
            </g>
            <path
              d="M222.8,818.69c-.37-10,3.53-17.77,5.55-19.92,3.28-2.9,4.33-9.13,6.67-10.3,0,0-4,.34-6.16-.67,2.14,2.15,2.74,3.25,1.48,6.52s-2.75,3.57-4.51,6.34a38.34,38.34,0,0,0-3.91,10.47c-.5,2.52.13,12.23-.5,14s-1.39,3.66-1.39,3.66l1.71-1.07C222.43,826.45,223,823.86,222.8,818.69Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M213.1,822.6c0-2.27-3.16-4-4.17-7.81s-3.15-4.67-5-7.32-1.26-2.9-1.39-4.66a6.64,6.64,0,0,1-2.9,1.63h0a39.6,39.6,0,0,0,4,4.55c4.16,3.9,10.72,18.53,10.72,18.53C214.48,826.51,213.1,824.87,213.1,822.6Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M214.36,812.52c.25-1.9-.51-7.07-.89-9s-1.64-10.34-2.64-10.59a10.36,10.36,0,0,0-1-.19,16.35,16.35,0,0,1,1,4.47h0s.91,3.84,1.42,6.61a8.78,8.78,0,0,1,.34,2.48c0,.17,0,.38,0,.6,0,1.93.65,1.27.2,3.78C213.28,812.23,214.1,814.41,214.36,812.52Z"
              fill="#86e04b"
            />
            <path
              d="M231.39,780.35c-3.07-.81-5.83-.36-6.29,1.12-.27.86.33,1.89,1.46,2.81C225.65,781.36,229.34,780.57,231.39,780.35Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M205.21,777.46c-2.87,1.91-4.46,4.56-3.55,5.92a2,2,0,0,0,1.67.77c-2.45-2.72,5.86-8.07,6.44-8.44A9.87,9.87,0,0,0,205.21,777.46Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M198.73,796.67l-.7.22c-2.3,1.83-3.48,4.06-2.67,5.28a2.3,2.3,0,0,0,2.11.77c0-.21.48-.38,2-.41l.2-.07C194.2,801.2,198.73,796.67,198.73,796.67Z"
              fill="#11366d"
              opacity="0.47"
            />
          </g>
          <path
            d="M225.44,787.83a4.74,4.74,0,0,1,.68,2.4,8.84,8.84,0,0,1-.29,2.51,15.81,15.81,0,0,1-2.06,4.56c-1.73,2.75-3.5,5.46-5.43,8.12a34.08,34.08,0,0,1,2-4.49c.75-1.45,1.58-2.86,2.44-4.25a22.06,22.06,0,0,0,2.18-4.2A8,8,0,0,0,225.44,787.83Z"
            fill="#86e04b"
          />
          <path
            d="M227.41,778.52c-.66.37-1.29.71-1.87,1.07a3.8,3.8,0,0,0-1.32,1.25,1.92,1.92,0,0,0,0,1.6c.1.31.26.62.39.94s.35.63.5,1a8.22,8.22,0,0,1-.95-.63,5.56,5.56,0,0,1-.76-.9,2.49,2.49,0,0,1-.16-2.56,3.48,3.48,0,0,1,2-1.51A5,5,0,0,1,227.41,778.52Z"
            fill="#86e04b"
          />
          <path
            d="M202.4,779.11c-.41.64-.81,1.23-1.15,1.82a3.78,3.78,0,0,0-.58,1.72,1.82,1.82,0,0,0,.71,1.43c.23.23.52.42.78.65a10.14,10.14,0,0,1,.9.65,8.85,8.85,0,0,1-1.13-.12,6,6,0,0,1-1.1-.44,2.48,2.48,0,0,1-1.33-2.19,3.41,3.41,0,0,1,1-2.24A4.82,4.82,0,0,1,202.4,779.11Z"
            fill="#86e04b"
          />
          <path
            d="M195.8,797.25c-.34.71-.66,1.38-.9,2a4,4,0,0,0-.3,1.9,2.51,2.51,0,0,0,.86,1.57c.23.25.54.44.81.69a9,9,0,0,1,.94.66A8.07,8.07,0,0,1,196,804a5.25,5.25,0,0,1-1.12-.48,2.89,2.89,0,0,1-1.47-2.15,3.73,3.73,0,0,1,.64-2.46A4.88,4.88,0,0,1,195.8,797.25Z"
            fill="#86e04b"
          />
        </g>
        <g>
          <g>
            <path
              d="M556.24,720.9s-6.55-14.62-10.71-18.53-3.74-5.26-4.92-4.54c-3.53,2.14-9.71-3-2.52-8.32,9-6.61,14.75-1.77,10.08,4.54,1.14,3,2.14,4.46,2.78,6.05.5,1.26,7.44,3.4,8.57,20.8Z"
              fill="#318099"
            />
            <ellipse
              cx="542.44"
              cy="692.09"
              rx="6.24"
              ry="2.96"
              transform="translate(-292.67 416.73) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M554.48,707.16c.5-2.77-.13-5.42,0-7.44s-1.39-5.29-1.64-7.69-.25-9.58-8.07-12c-4.15.63-6.56-4.92,0-9.71s10.12-4.06,11.07-1.36c.62,1.78,4.56,4.77,2.67,12.46s-1.13,12.73-.5,13.74,4.41,5.42,3.78,12-2.27,15-2.27,15Z"
              fill="#318099"
            />
            <ellipse
              cx="548.74"
              cy="673.31"
              rx="6.24"
              ry="2.96"
              transform="translate(-281.2 417.08) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M559.52,701.11c.38-2.9,3.15-6.18,4.54-9,.62-1.25,1.83-2.78,2.88-4.49a7,7,0,0,0-.94-8.44c-2.51-2.6-2.67-7.72,2.6-7.63,5,.1,10.46,1.64,12,5.8.8,2.22-1,4-3,4.61a5.47,5.47,0,0,0-3.51,3.66,15,15,0,0,1-3.86,6.49c-2,2.14-5.93,10-5.55,19.92s-2.14,10.34-2.77,10.08-2.4-1.26-2.4-1.26Z"
              fill="#318099"
            />
            <ellipse
              cx="572.95"
              cy="676.71"
              rx="2.96"
              ry="6.24"
              transform="translate(-243.81 1021.83) rotate(-72.65)"
              fill="#318099"
            />
            <path
              d="M561.74,703.82a18.89,18.89,0,0,0-3.73-8.64c-.63-1-1.39-6,.5-13.74,1.55-6.31-.62-9.39-2.09-11.13a10,10,0,0,1-3.71,6.46c2.27.13,3.41.26,3.66,3s-1.77,2.77,0,11.1,4.92,9.7,4,13.86c-.59,2.81-.33,9.17-.09,13,.25-1.51.54-3.29.81-5.12Z"
              fill="#318099"
              opacity="0.47"
            />
            <g>
              <path
                d="M545.17,680.18a10.34,10.34,0,0,1,5.43,4,8.25,8.25,0,0,1,.22-5.84A14,14,0,0,1,545.17,680.18Z"
                fill="#318099"
                opacity="0.47"
              />
              <polygon
                points="551.67 686.13 551.67 686.13 551.67 686.13 551.67 686.13"
                fill="#318099"
              />
            </g>
            <path
              d="M564.69,712.08c-.38-10,3.53-17.78,5.55-19.92,3.28-2.9,4.33-9.13,6.67-10.31,0,0-4,.35-6.17-.66,2.15,2.14,2.75,3.24,1.49,6.52s-2.75,3.56-4.51,6.34a37.85,37.85,0,0,0-3.91,10.46c-.51,2.52.12,12.23-.51,14s-1.38,3.65-1.38,3.65l1.71-1.07C564.32,719.83,564.88,717.25,564.69,712.08Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M555,716c0-2.27-3.15-4-4.16-7.82s-3.15-4.67-5-7.31-1.26-2.9-1.39-4.67a6.64,6.64,0,0,1-2.9,1.63h0a39.6,39.6,0,0,0,4,4.55c4.16,3.91,10.71,18.53,10.71,18.53C556.37,719.89,555,718.26,555,716Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M556.24,705.9c.26-1.89-.5-7.06-.88-8.95s-1.64-10.34-2.65-10.59a7.76,7.76,0,0,0-1-.19,15.91,15.91,0,0,1,1,4.47h0s.91,3.84,1.43,6.61a8.67,8.67,0,0,1,.34,2.47c0,.17,0,.38,0,.61,0,1.92.66,1.26.2,3.77C555.17,705.61,556,707.79,556.24,705.9Z"
              fill="#318099"
            />
            <path
              d="M573.28,673.74c-3.07-.82-5.83-.36-6.29,1.11-.27.87.33,1.89,1.46,2.82C567.54,674.74,571.22,674,573.28,673.74Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M547.1,670.84c-2.87,1.91-4.46,4.56-3.55,5.93a2.06,2.06,0,0,0,1.67.77c-2.46-2.73,5.86-8.08,6.44-8.45A9.87,9.87,0,0,0,547.1,670.84Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M540.62,690.05l-.7.22c-2.3,1.83-3.49,4.07-2.68,5.28a2.32,2.32,0,0,0,2.12.77c0-.21.47-.38,2-.41l.19-.07C536.09,694.59,540.62,690.05,540.62,690.05Z"
              fill="#318099"
              opacity="0.47"
            />
          </g>
          <path
            d="M567.33,681.21s1.71,3-2,8.84-5.14,8.75-5.14,8.75"
            fill="#318099"
          />
          <path d="M569.3,671.9s-7,1.17-2.34,5.86" fill="#318099" />
          <path d="M544.29,672.49s-5.67,4.32.66,6.27" fill="#318099" />
          <path d="M537.69,690.63s-4.92,4.91,1.41,6.86" fill="#318099" />
        </g>
        <g>
          <g>
            <path
              d="M1088.7,744.06s-2.77-6.18-4.53-7.84-1.58-2.22-2.08-1.92c-1.49.91-4.1-1.28-1.06-3.52,3.79-2.79,6.23-.74,4.26,1.92.48,1.28.91,1.89,1.18,2.56s3.14,1.44,3.62,8.8Z"
              fill="#318099"
            />
            <ellipse
              cx="1082.87"
              cy="731.88"
              rx="2.64"
              ry="1.25"
              transform="translate(-224.1 722.97) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M1088,738.25a22,22,0,0,0,0-3.15c0-.85-.59-2.24-.7-3.25s-.1-4.05-3.41-5.06c-1.75.26-2.77-2.08,0-4.11s4.28-1.72,4.68-.58c.27.76,1.93,2,1.13,5.27s-.48,5.39-.21,5.81a7.34,7.34,0,0,1,1.6,5.07c-.27,2.77-1,6.34-1,6.34Z"
              fill="#318099"
            />
            <ellipse
              cx="1085.53"
              cy="723.93"
              rx="2.64"
              ry="1.25"
              transform="translate(-219.25 723.11) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M1090.09,735.69c.16-1.23,1.33-2.61,1.92-3.79.26-.52.77-1.17,1.22-1.89a3,3,0,0,0-.4-3.57c-1.06-1.1-1.13-3.27,1.1-3.23s4.43.7,5.07,2.46a1.57,1.57,0,0,1-1.26,1.94,2.3,2.3,0,0,0-1.48,1.55,6.26,6.26,0,0,1-1.64,2.74c-.85.91-2.5,4.22-2.34,8.43s-.91,4.37-1.18,4.26-1-.53-1-.53Z"
              fill="#318099"
            />
            <ellipse
              cx="1095.77"
              cy="725.37"
              rx="1.25"
              ry="2.64"
              transform="translate(76.67 1555.02) rotate(-72.65)"
              fill="#318099"
            />
            <path
              d="M1091,736.84a8,8,0,0,0-1.58-3.66c-.27-.42-.59-2.56.21-5.81.66-2.66-.26-4-.88-4.71a4.25,4.25,0,0,1-1.57,2.74c1,.05,1.44.11,1.55,1.28s-.75,1.17,0,4.69,2.08,4.11,1.7,5.87a28.51,28.51,0,0,0,0,5.5c.11-.64.23-1.39.34-2.17Z"
              fill="#318099"
              opacity="0.47"
            />
            <g>
              <path
                d="M1084,726.84a4.43,4.43,0,0,1,2.3,1.67,3.47,3.47,0,0,1,.09-2.47A5.79,5.79,0,0,1,1084,726.84Z"
                fill="#318099"
                opacity="0.47"
              />
              <polygon
                points="1086.77 729.35 1086.77 729.35 1086.77 729.35 1086.77 729.35"
                fill="#318099"
              />
            </g>
            <path
              d="M1092.28,740.33c-.16-4.21,1.49-7.52,2.34-8.43,1.39-1.22,1.83-3.86,2.82-4.35a6.65,6.65,0,0,1-2.6-.28,2,2,0,0,1,.62,2.75c-.53,1.39-1.16,1.51-1.9,2.68a16.35,16.35,0,0,0-1.66,4.43c-.21,1.07.06,5.17-.21,5.92s-.59,1.54-.59,1.54l.73-.45A8,8,0,0,0,1092.28,740.33Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1088.17,742c0-1-1.33-1.7-1.76-3.3s-1.33-2-2.13-3.1a2.36,2.36,0,0,1-.59-2,2.83,2.83,0,0,1-1.22.69h0a16.37,16.37,0,0,0,1.7,1.92c1.76,1.66,4.53,7.84,4.53,7.84C1088.76,743.63,1088.17,742.94,1088.17,742Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1088.7,737.72a18,18,0,0,0-.37-3.79c-.16-.8-.69-4.37-1.12-4.48a4,4,0,0,0-.43-.08,6.7,6.7,0,0,1,.43,1.89h0s.39,1.63.6,2.8a3.47,3.47,0,0,1,.15,1,2.44,2.44,0,0,1,0,.26c0,.81.28.54.09,1.59C1088.25,737.59,1088.6,738.52,1088.7,737.72Z"
              fill="#318099"
            />
            <path
              d="M1095.91,724.11c-1.3-.34-2.47-.15-2.66.48-.11.36.14.8.62,1.19C1093.48,724.54,1095,724.2,1095.91,724.11Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1084.84,722.89c-1.22.81-1.89,1.93-1.5,2.51a.85.85,0,0,0,.7.32c-1-1.15,2.48-3.41,2.73-3.57A4.18,4.18,0,0,0,1084.84,722.89Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1082.1,731l-.3.1c-1,.77-1.47,1.72-1.13,2.23a1,1,0,0,0,.9.33c0-.09.2-.17.84-.18l.08,0C1080.18,732.93,1082.1,731,1082.1,731Z"
              fill="#318099"
              opacity="0.47"
            />
          </g>
          <path
            d="M1093.39,727.28s.73,1.26-.83,3.73-2.17,3.7-2.17,3.7"
            fill="#318099"
          />
          <path d="M1094.23,723.34s-3,.49-1,2.47" fill="#318099" />
          <path d="M1083.65,723.59s-2.4,1.82.28,2.65" fill="#318099" />
          <path d="M1080.86,731.26s-2.08,2.07.59,2.9" fill="#318099" />
        </g>
        <g>
          <g>
            <path
              d="M871.62,778.4s-2.77-6.19-4.53-7.84-1.58-2.22-2.08-1.92c-1.5.91-4.11-1.28-1.07-3.52,3.8-2.8,6.24-.75,4.27,1.92.48,1.28.9,1.89,1.17,2.56s3.15,1.44,3.63,8.8Z"
              fill="#318099"
            />
            <ellipse
              cx="865.78"
              cy="766.21"
              rx="2.64"
              ry="1.25"
              transform="translate(-279.54 608.39) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M870.87,772.59a19.37,19.37,0,0,0,0-3.15c.06-.85-.58-2.24-.69-3.25s-.11-4.06-3.41-5.07c-1.76.27-2.78-2.08,0-4.1s4.28-1.72,4.68-.58c.26.75,1.93,2,1.13,5.27s-.48,5.38-.21,5.81a7.42,7.42,0,0,1,1.6,5.07c-.27,2.77-1,6.34-1,6.34Z"
              fill="#318099"
            />
            <ellipse
              cx="868.45"
              cy="758.27"
              rx="2.64"
              ry="1.25"
              transform="translate(-274.69 608.54) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M873,770c.16-1.23,1.33-2.62,1.92-3.79.26-.53.77-1.17,1.21-1.9a2.93,2.93,0,0,0-.39-3.56c-1.07-1.11-1.14-3.27,1.09-3.23s4.43.69,5.07,2.45a1.57,1.57,0,0,1-1.25,2,2.33,2.33,0,0,0-1.49,1.55,6.35,6.35,0,0,1-1.63,2.74c-.86.91-2.51,4.21-2.35,8.43s-.9,4.37-1.17,4.26-1-.53-1-.53Z"
              fill="#318099"
            />
            <ellipse
              cx="878.68"
              cy="759.71"
              rx="1.25"
              ry="2.64"
              transform="translate(-108.46 1371.91) rotate(-72.65)"
              fill="#318099"
            />
            <path
              d="M873.94,771.17a7.92,7.92,0,0,0-1.57-3.65c-.27-.43-.59-2.56.21-5.81.65-2.67-.27-4-.88-4.71a4.27,4.27,0,0,1-1.57,2.74c1,0,1.44.1,1.54,1.27s-.74,1.18,0,4.7,2.08,4.1,1.71,5.86a28.62,28.62,0,0,0,0,5.51c.11-.64.23-1.39.34-2.17Z"
              fill="#318099"
              opacity="0.47"
            />
            <g>
              <path
                d="M866.93,761.18a4.3,4.3,0,0,1,2.3,1.67,3.51,3.51,0,0,1,.1-2.47A6.14,6.14,0,0,1,866.93,761.18Z"
                fill="#318099"
                opacity="0.47"
              />
              <polygon
                points="869.69 763.69 869.69 763.69 869.69 763.69 869.69 763.69"
                fill="#318099"
              />
            </g>
            <path
              d="M875.19,774.67c-.16-4.22,1.49-7.52,2.35-8.43,1.38-1.23,1.83-3.86,2.82-4.36a6.51,6.51,0,0,1-2.61-.28,2,2,0,0,1,.63,2.76c-.53,1.39-1.16,1.51-1.91,2.68a15.87,15.87,0,0,0-1.65,4.43c-.21,1.06,0,5.17-.21,5.91s-.59,1.55-.59,1.55l.72-.45A8,8,0,0,0,875.19,774.67Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M871.09,776.32c0-1-1.34-1.71-1.76-3.31s-1.34-2-2.14-3.09a2.32,2.32,0,0,1-.58-2,2.89,2.89,0,0,1-1.23.69h0a17,17,0,0,0,1.71,1.92c1.76,1.65,4.53,7.84,4.53,7.84C871.67,778,871.09,777.28,871.09,776.32Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M871.62,772.05a17.94,17.94,0,0,0-.37-3.78c-.16-.8-.7-4.38-1.12-4.48a2.86,2.86,0,0,0-.43-.08,7.48,7.48,0,0,1,.43,1.89h0s.38,1.62.6,2.79a3.49,3.49,0,0,1,.14,1.05v.26c0,.81.27.53.08,1.59C871.17,771.93,871.51,772.85,871.62,772.05Z"
              fill="#318099"
            />
            <path
              d="M878.82,758.45c-1.3-.34-2.46-.15-2.66.47-.11.37.14.8.62,1.19C876.4,758.88,878,758.54,878.82,758.45Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M867.75,757.23c-1.21.8-1.88,1.93-1.5,2.5a.87.87,0,0,0,.71.33c-1-1.15,2.48-3.42,2.72-3.57A4.15,4.15,0,0,0,867.75,757.23Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M865,765.35l-.29.09c-1,.78-1.48,1.72-1.14,2.24a1,1,0,0,0,.9.32c0-.09.2-.16.84-.17l.09,0C863.1,767.27,865,765.35,865,765.35Z"
              fill="#318099"
              opacity="0.47"
            />
          </g>
          <path
            d="M876.31,761.61s.72,1.26-.83,3.74-2.17,3.7-2.17,3.7"
            fill="#318099"
          />
          <path d="M877.14,757.68s-3,.49-1,2.47" fill="#318099" />
          <path d="M866.56,757.92s-2.39,1.83.28,2.66" fill="#318099" />
          <path d="M863.77,765.6s-2.08,2.07.6,2.9" fill="#318099" />
        </g>
        <g>
          <g>
            <path
              d="M1415.36,616.52s-6.56-14.63-10.72-18.53-3.73-5.26-4.92-4.54c-3.53,2.14-9.71-3-2.52-8.33,9-6.61,14.75-1.76,10.09,4.54,1.13,3,2.13,4.46,2.77,6.06.5,1.26,7.44,3.4,8.57,20.8Z"
              fill="#318099"
            />
            <ellipse
              cx="1401.55"
              cy="587.71"
              rx="6.24"
              ry="2.96"
              transform="translate(-90.75 875.44) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M1413.59,602.78c.51-2.78-.13-5.43,0-7.44s-1.39-5.3-1.64-7.69-.25-9.59-8.07-12c-4.15.63-6.55-4.92,0-9.71s10.12-4.07,11.07-1.37c.62,1.79,4.57,4.77,2.68,12.47s-1.14,12.73-.51,13.74,4.41,5.42,3.78,12-2.27,15-2.27,15Z"
              fill="#318099"
            />
            <ellipse
              cx="1407.85"
              cy="568.92"
              rx="6.24"
              ry="2.96"
              transform="translate(-79.28 875.79) rotate(-33.66)"
              fill="#318099"
            />
            <path
              d="M1418.63,596.72c.38-2.9,3.16-6.17,4.54-9,.63-1.24,1.83-2.77,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.67-7.73,2.6-7.63,5,.09,10.47,1.64,12,5.8.8,2.21-1,4-3,4.61a5.47,5.47,0,0,0-3.52,3.65,14.72,14.72,0,0,1-3.86,6.49c-2,2.15-5.92,10-5.55,19.92s-2.14,10.34-2.77,10.09-2.4-1.26-2.4-1.26Z"
              fill="#318099"
            />
            <ellipse
              cx="1432.06"
              cy="572.33"
              rx="2.96"
              ry="6.24"
              transform="matrix(0.3, -0.95, 0.95, 0.3, 458.78, 1768.61)"
              fill="#318099"
            />
            <path
              d="M1420.86,599.43a18.64,18.64,0,0,0-3.74-8.63c-.63-1-1.39-6,.51-13.74,1.55-6.31-.63-9.39-2.09-11.14a10,10,0,0,1-3.71,6.47c2.27.13,3.4.25,3.65,3s-1.76,2.77,0,11.09,4.92,9.71,4,13.87c-.6,2.81-.33,9.17-.1,13,.26-1.5.54-3.28.81-5.12Z"
              fill="#318099"
              opacity="0.47"
            />
            <g>
              <path
                d="M1404.28,575.8a10.41,10.41,0,0,1,5.44,4,8.25,8.25,0,0,1,.21-5.85A13.87,13.87,0,0,1,1404.28,575.8Z"
                fill="#318099"
                opacity="0.47"
              />
              <polygon
                points="1410.79 581.74 1410.79 581.74 1410.79 581.74 1410.79 581.74"
                fill="#318099"
              />
            </g>
            <path
              d="M1423.8,607.69c-.37-10,3.53-17.77,5.55-19.92,3.28-2.9,4.33-9.13,6.67-10.3,0,0-4,.34-6.16-.67,2.14,2.15,2.74,3.25,1.48,6.52s-2.75,3.57-4.51,6.34a38.34,38.34,0,0,0-3.91,10.47c-.5,2.52.13,12.23-.5,14s-1.39,3.66-1.39,3.66l1.71-1.07C1423.43,615.45,1424,612.86,1423.8,607.69Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1414.1,611.6c0-2.27-3.16-4-4.17-7.81s-3.15-4.67-5-7.32-1.26-2.9-1.39-4.66a6.64,6.64,0,0,1-2.9,1.63h0a39.6,39.6,0,0,0,4,4.55c4.16,3.9,10.72,18.53,10.72,18.53C1415.48,615.51,1414.1,613.87,1414.1,611.6Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1415.36,601.52c.25-1.9-.51-7.07-.89-9s-1.64-10.34-2.64-10.59a10.36,10.36,0,0,0-1-.19,16.35,16.35,0,0,1,1,4.47h0s.91,3.84,1.42,6.61a8.78,8.78,0,0,1,.34,2.48c0,.17,0,.38,0,.6,0,1.93.65,1.27.2,3.78C1414.28,601.23,1415.1,603.41,1415.36,601.52Z"
              fill="#318099"
            />
            <path
              d="M1432.39,569.35c-3.07-.81-5.83-.36-6.29,1.12-.27.86.33,1.89,1.46,2.81C1426.65,570.36,1430.34,569.57,1432.39,569.35Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1406.21,566.46c-2.87,1.91-4.46,4.56-3.55,5.92a2,2,0,0,0,1.67.77c-2.45-2.72,5.86-8.07,6.44-8.44A9.87,9.87,0,0,0,1406.21,566.46Z"
              fill="#318099"
              opacity="0.47"
            />
            <path
              d="M1399.73,585.67l-.7.22c-2.3,1.83-3.48,4.06-2.67,5.28a2.3,2.3,0,0,0,2.11.77c0-.21.48-.38,2-.41l.2-.07C1395.2,590.2,1399.73,585.67,1399.73,585.67Z"
              fill="#318099"
              opacity="0.47"
            />
          </g>
          <path
            d="M1426.44,576.83s1.72,3-2,8.84-5.14,8.75-5.14,8.75"
            fill="#318099"
          />
          <path d="M1428.41,567.52s-7,1.17-2.34,5.85" fill="#318099" />
          <path d="M1403.4,568.11s-5.66,4.31.66,6.27" fill="#318099" />
          <path d="M1396.8,586.25s-4.92,4.9,1.41,6.86" fill="#318099" />
        </g>
        <g>
          <path
            d="M827.37,1183.14c9-1.35,11-13.55,2.9-17.62s-18.63-5.73-27.88-1.77c27.45-11.76,41.5-26.15,23.53-39.22-14.38-10.45-36.61,27.46-41.84,27.46s2.62-15.69,14.38-30.07,10.46-26.15,1.31-30.07S774.93,1094.47,771,1135c0-6.53,2.62-47.06-7.84-43.14s-18.3,26.15-1.31,49.68c-10.46,3.92-9.15-6.54-9.15-6.54s-5.23-39.22-23.53-31.37-13.07,28.76,0,41.83,13.07,20.91-3.92,13.07-24.84-26.14-40.52-7.84,27.45,40.52,52.28,41.83C755,1193.46,802.57,1186.85,827.37,1183.14Z"
            fill="url(#ba14210b-7bf7-4619-8810-0ae1a8222208)"
          />
          <path
            d="M811.55,1179.61c.93-7.43-13-14.86-24.14-5.58,16.72-14.85,20.43-26.93,12.07-26.93s-26.93,15.79-30.64,15.79,8.19-7.23,16.55-17.44,3.89-18.13-2.61-20.92c-6.1-2.61-24.58,3.26-29.33,27.56a4.24,4.24,0,0,1-2.9,3.21c-1.44.47-3.07-3.31-3.07-3.31s-8.36-31.82-21.36-26.24-9.28,20.43,0,29.71,9.29,14.86-2.78,9.29-17.65-18.57-28.79-5.57,13,19.5,30.64,20.43S811.55,1179.61,811.55,1179.61Z"
            fill="url(#beb04513-6776-48ec-9417-f2e33c985239)"
          />
          <path
            d="M779.11,1190c-3.49-1.26,10.16-4,21.49-10.8s9.79-15.75,4.62-20.57c-4.85-4.52-24.23-5.26-36.92,16a4.24,4.24,0,0,1-3.82,2c-1.51,0-1.77-4.15-1.77-4.15s2.91-32.77-11.21-31.93-15.65,16.08-10.06,28,3.7,17.13-5.77,7.8-10.31-23.45-25.2-15,5.63,22.75,21.92,29.6S782.61,1191.28,779.11,1190Z"
            fill="url(#ac568350-a34b-4073-bd11-7daad04b5c13)"
          />
        </g>
        <g>
          <ellipse cx="421.93" cy="938.96" rx="21.5" ry="4.5" fill="#531063" />
          <g>
            <path
              d="M453.94,936.07a4.48,4.48,0,0,0,1.38-8.42c-3.84-1.92-8.89-2.74-13.31-.84,13.11-5.62,19.82-12.48,11.24-18.73-6.87-5-17.48,13.11-20,13.11s1.25-7.49,6.87-14.35,5-12.49.62-14.36-11.86,1.25-13.73,20.6c0-3.12,1.25-22.47-3.74-20.6s-8.74,12.48-.63,23.72c-5,1.87-4.37-3.12-4.37-3.12s-2.49-18.73-11.23-15-6.24,13.73,0,20,6.24,10-1.87,6.24-11.86-12.48-19.35-3.74,13.11,19.34,25,20C419.4,941,442.1,937.84,453.94,936.07Z"
              fill="url(#adad42da-3e08-42fc-8d61-81dc1758aa0a)"
            />
            <path
              d="M446.39,934.38c.44-3.55-6.21-7.1-11.53-2.66,8-7.1,9.76-12.86,5.77-12.86S427.77,926.4,426,926.4s3.92-3.45,7.91-8.33,1.85-8.66-1.25-10c-2.91-1.24-11.74,1.56-14,13.16a2,2,0,0,1-1.39,1.53c-.68.23-1.46-1.58-1.46-1.58s-4-15.19-10.2-12.53-4.43,9.76,0,14.19,4.43,7.09-1.33,4.43-8.42-8.86-13.74-2.66,6.2,9.31,14.63,9.76S446.39,934.38,446.39,934.38Z"
              fill="url(#e0958e15-0ce6-4234-a4e6-0a1b64773843)"
            />
            <path
              d="M430.9,939.35c-1.67-.6,4.85-1.92,10.26-5.16s4.67-7.51,2.2-9.82c-2.31-2.15-11.56-2.51-17.62,7.64a2,2,0,0,1-1.82,1c-.73,0-.85-2-.85-2s1.39-15.64-5.35-15.24-7.48,7.67-4.81,13.35,1.77,8.17-2.75,3.72-4.92-11.2-12-7.16,2.69,10.86,10.46,14.13S432.57,940,430.9,939.35Z"
              fill="url(#a299bda4-f20a-4878-8f69-2b1baa369782)"
            />
          </g>
        </g>
        <g>
          <path
            d="M1396.89,897c-3.46,1.17,16.82,8.4,23.8,5.17s1.62,1.74,5.55,4.12,12.69-2.42,11.44-4.64,17.28-5.2,12.64-12.09-55.89-.14-55.89-.14Z"
            fill="#0e3b68"
            opacity="0.32"
          />
          <g>
            <path
              d="M1439.5,893.49a3.52,3.52,0,0,0,1.09-6.62,12.7,12.7,0,0,0-10.47-.66c10.31-4.42,15.59-9.82,8.84-14.73-5.4-3.92-13.75,10.31-15.71,10.31s1-5.89,5.4-11.29,3.93-9.82.49-11.29-9.32,1-10.8,16.2c0-2.46,1-17.67-2.94-16.2s-6.87,9.82-.49,18.65c-3.93,1.48-3.44-2.45-3.44-2.45s-2-14.73-8.83-11.78-4.91,10.8,0,15.71,4.9,7.85-1.48,4.9-9.32-9.81-15.21-2.94,10.31,15.22,19.63,15.71C1412.34,897.36,1430.19,894.88,1439.5,893.49Z"
              fill="url(#b5956427-a68c-49fa-b059-21100ba18968)"
            />
            <path
              d="M1433.57,892.16c.34-2.79-4.89-5.58-9.07-2.09,6.28-5.58,7.67-10.11,4.53-10.11s-10.11,5.92-11.5,5.92,3.07-2.71,6.21-6.54,1.46-6.81-1-7.86c-2.29-1-9.23,1.22-11,10.35a1.58,1.58,0,0,1-1.09,1.2c-.54.18-1.15-1.24-1.15-1.24s-3.14-11.94-8-9.85-3.49,7.67,0,11.16,3.48,5.57-1,3.48-6.62-7-10.81-2.09,4.88,7.32,11.51,7.67S1433.57,892.16,1433.57,892.16Z"
              fill="url(#b03cc462-5867-4acc-8fb9-8c9730ea769d)"
            />
            <path
              d="M1421.39,896.07c-1.32-.47,3.81-1.51,8.06-4.06s3.68-5.91,1.74-7.72-9.1-2-13.87,6a1.58,1.58,0,0,1-1.43.76c-.57,0-.66-1.56-.66-1.56s1.09-12.3-4.21-12-5.88,6-3.78,10.49,1.39,6.43-2.17,2.93-3.87-8.8-9.46-5.63,2.12,8.54,8.23,11.12S1422.7,896.54,1421.39,896.07Z"
              fill="url(#b35b6153-a376-4d48-bf65-a85f3d05f1c6)"
            />
          </g>
        </g>
        <g>
          <path
            d="M1311.39,1192.06c9.57-1.43,11.73-14.38,3.08-18.71s-19.78-6.08-29.6-1.87c29.14-12.49,44.06-27.75,25-41.63-15.27-11.1-38.86,29.14-44.41,29.14s2.78-16.65,15.27-31.91,11.1-27.76,1.39-31.92-26.37,2.77-30.53,45.79c0-6.94,2.77-50-8.33-45.79s-19.43,27.75-1.39,52.73c-11.1,4.16-9.71-6.94-9.71-6.94s-5.55-41.63-25-33.3-13.87,30.53,0,44.4,13.88,22.2-4.16,13.88-26.36-27.75-43-8.33,29.14,43,55.51,44.41C1234.6,1203,1285.07,1196,1311.39,1192.06Z"
            fill="url(#aedf39c9-921e-414e-bc6b-d71dd53f7ae7)"
          />
          <path
            d="M1294.6,1188.31c1-7.89-13.8-15.77-25.63-5.92,17.75-15.77,21.69-28.58,12.82-28.58s-28.59,16.76-32.53,16.76,8.7-7.67,17.57-18.52,4.13-19.24-2.77-22.2c-6.47-2.77-26.1,3.45-31.13,29.25a4.49,4.49,0,0,1-3.08,3.4c-1.53.5-3.26-3.51-3.26-3.51s-8.87-33.77-22.67-27.85-9.86,21.68,0,31.54,9.85,15.77-3,9.86-18.73-19.72-30.56-5.92,13.8,20.7,32.53,21.69S1294.6,1188.31,1294.6,1188.31Z"
            fill="url(#e2d087f7-96b2-4048-b45a-6956849123cc)"
          />
          <path
            d="M1260.17,1199.36c-3.71-1.33,10.78-4.27,22.8-11.46s10.4-16.71,4.91-21.83c-5.15-4.8-25.72-5.59-39.2,17a4.5,4.5,0,0,1-4,2.17c-1.61,0-1.88-4.42-1.88-4.42s3.09-34.77-11.9-33.88-16.62,17.06-10.68,29.68,3.93,18.18-6.13,8.27-10.94-24.89-26.74-15.91,6,24.15,23.26,31.42S1263.88,1200.7,1260.17,1199.36Z"
            fill="url(#a040eed0-3867-4f03-ab1e-8cc547da743a)"
          />
        </g>
        <g>
          <path
            d="M1511.54,990.7a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1472.15,996.32,1498,992.72,1511.54,990.7Z"
            fill="url(#efdc5447-a912-4609-99e3-0d5c7bdd7ab3)"
          />
          <path
            d="M1502.93,988.77c.5-4-7.08-8.08-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.05,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.69,11.12S1502.93,988.77,1502.93,988.77Z"
            fill="url(#b64f5880-2b82-4ed8-b20c-5c5ece6ecdba)"
          />
          <path
            d="M1485.26,994.45c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.19-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.07,12.39,11.93,16.12S1487.17,995.13,1485.26,994.45Z"
            fill="url(#a40f7187-9417-4101-8f7e-3ff148770bc8)"
          />
        </g>
        <g>
          <g opacity="0.25">
            <path
              d="M484,1028.17s10.64-8.46,11.87-12.36,2.9-4,1.36-4.59c-4.58-1.82-3.42-7.44,6.86-4,12.85,4.32,11.75,9.58,2.12,8.11-2.35,1.6-3.15,2.67-4.36,3.54-1,.69,1.5,6-15.64,11.52Z"
              fill="#531063"
            />
            <ellipse
              cx="504.31"
              cy="1010.91"
              rx="2.17"
              ry="7.56"
              transform="translate(-614.42 1168.06) rotate(-71.48)"
              fill="#531063"
            />
            <path
              d="M496.91,1023.22c3.19-.41,5.49-1.56,7.65-2s4.52-2.39,6.82-3.21,9.69-2.79,6.89-8.77c-3.44-2.66.65-5.81,10-2.64s11,5.79,8.86,7.17c-1.42.92-1.84,4.42-11,5.22s-13.86,2.7-14.48,3.4-2.61,4.49-9.78,5.84-17,2.54-17,2.54Z"
              fill="#531063"
            />
            <ellipse
              cx="527.89"
              cy="1010.09"
              rx="2.17"
              ry="7.56"
              transform="translate(-597.56 1189.86) rotate(-71.48)"
              fill="#531063"
            />
            <path
              d="M506.53,1025c3.24-.54,8.48.46,12.27.66,1.7.08,4.08.49,6.55.74,3.87.39,7.18-.83,8-2.94,1-2.42,6.15-3.93,9.6-.3,3.24,3.4,5.36,7.58,2.09,9.75-1.73,1.15-4.77.42-6.73-.77a11.29,11.29,0,0,0-6.13-1.4,31.11,31.11,0,0,1-9.27-.87c-3.57-.79-14.24-1.33-24.24,1.64s-12.08,1.35-12.25.85a15.89,15.89,0,0,1-.31-2Z"
              fill="#531063"
            />
            <ellipse
              cx="540.67"
              cy="1027.53"
              rx="3.09"
              ry="5.29"
              transform="translate(-520.87 557.13) rotate(-38.35)"
              fill="#531063"
            />
            <path
              d="M505.24,1027.27a12.67,12.67,0,0,0,6.37-4.9c.62-.7,5.3-2.59,14.48-3.4,7.54-.66,9.25-3,10-4.45a20.44,20.44,0,0,1-9.15-.77c1.4,1.58,2,2.39-.65,3.31s-4-.44-11.42,3-6.68,6-11.56,6.52c-3.29.36-9.65,2.27-13.45,3.48,1.72-.23,3.74-.52,5.81-.84Z"
              fill="#531063"
              opacity="0.47"
            />
            <g>
              <path
                d="M518.41,1009.53a4.5,4.5,0,0,1-.41,4.78c2.42-1.59,6.16-1.44,6.16-1.44A21.53,21.53,0,0,1,518.41,1009.53Z"
                fill="#531063"
                opacity="0.47"
              />
              <polygon
                points="516.67 1015.58 516.67 1015.58 516.67 1015.58 516.67 1015.58"
                fill="#531063"
              />
            </g>
            <path
              d="M498.72,1031.53c10-3,20.67-2.43,24.24-1.64,5.19,1.45,12.31.47,15.09,1.75,0,0-3.06-2.66-3.47-4.39-.76,2-1.49,2.75-5.71,2.78s-5.52-.9-9.56-1.35a74.2,74.2,0,0,0-13.4.19c-2.93.34-12.5,3.41-14.74,3.46s-4.7.05-4.7.05l2.26.88C490.49,1033.39,493.53,1033.07,498.72,1031.53Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M488.17,1026c2.33-.62,2-3.25,5.24-5s2.68-3.42,4.13-5.43,2.14-1.65,3.87-2.21a12,12,0,0,1-3.63-1.54h0a17.63,17.63,0,0,0-2,4c-1.23,3.9-11.87,12.36-11.87,12.36C485.08,1028,485.83,1026.59,488.17,1026Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M499.39,1024.08a50,50,0,0,0,8.62-3c1.69-.77,9.54-3.93,9.12-4.68a5.73,5.73,0,0,0-.49-.75,15.7,15.7,0,0,1-3.92,1.91h0s-3.33,1.67-5.84,2.77a9.36,9.36,0,0,1-2.32.91l-.63.15c-2,.53-.86.8-3.74,1.17C499,1023.27,497.28,1024.43,499.39,1024.08Z"
              fill="#531063"
            />
            <path
              d="M544,1027c-1.23-2.32-3.55-4.07-5.38-4a2,2,0,0,0-1.92,1.77C539.06,1023.31,542.35,1025.6,544,1027Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M529.32,1008.3c-3.9-1.44-7.7-1.8-8.49-.81-.28.35-.13.82.33,1.35,1.15-2.42,12.26,1.8,13,2.1A16,16,0,0,0,529.32,1008.3Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M505.19,1009.11l-.7-.42c-3.43-1.07-6.53-1.27-7.23-.38-.34.41-.06,1,.63,1.65.21-.06.71.22,1.77,1.25l.2.12C497.47,1007.26,505.19,1009.11,505.19,1009.11Z"
              fill="#531063"
              opacity="0.47"
            />
          </g>
          <g>
            <path
              d="M482.14,1031.48s-6.56-14.63-10.72-18.54-3.73-5.26-4.92-4.54c-3.53,2.15-9.71-3-2.52-8.32,9-6.61,14.75-1.76,10.09,4.54,1.13,3,2.13,4.46,2.77,6,.5,1.27,7.44,3.41,8.57,20.81Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="468.33"
              cy="1002.67"
              rx="6.24"
              ry="2.96"
              transform="translate(-477.25 427.73) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M480.37,1017.73c.5-2.77-.13-5.42,0-7.43s-1.39-5.3-1.64-7.7-.25-9.58-8.07-12c-4.15.63-6.55-4.92,0-9.71s10.12-4.07,11.07-1.37c.62,1.79,4.57,4.77,2.67,12.46s-1.13,12.74-.5,13.75,4.41,5.42,3.78,12-2.27,15-2.27,15Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="474.63"
              cy="983.88"
              rx="6.24"
              ry="2.96"
              transform="translate(-465.78 428.08) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M485.41,1011.68c.38-2.9,3.16-6.18,4.54-8.95.63-1.25,1.83-2.77,2.88-4.49a7,7,0,0,0-.94-8.43c-2.51-2.61-2.67-7.73,2.6-7.63,5,.09,10.47,1.64,12,5.8.8,2.21-1,4-3,4.6a5.51,5.51,0,0,0-3.52,3.66,14.87,14.87,0,0,1-3.86,6.49c-2,2.14-5.93,10-5.55,19.92s-2.14,10.34-2.77,10.09-2.4-1.26-2.4-1.26Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="498.84"
              cy="987.29"
              rx="2.96"
              ry="6.24"
              transform="translate(-592.27 1169.07) rotate(-72.65)"
              fill="#170"
            />
            <path
              d="M487.63,1014.39a18.66,18.66,0,0,0-3.73-8.63c-.63-1-1.39-6,.5-13.75,1.56-6.3-.62-9.39-2.08-11.13a10,10,0,0,1-3.72,6.47c2.27.12,3.41.25,3.66,3s-1.76,2.78,0,11.1,4.92,9.71,4,13.87c-.6,2.81-.33,9.17-.1,13,.26-1.51.54-3.28.81-5.12Z"
              fill="#11366d"
              opacity="0.47"
            />
            <g>
              <path
                d="M471.06,990.76a10.41,10.41,0,0,1,5.44,4,8.25,8.25,0,0,1,.21-5.85A14,14,0,0,1,471.06,990.76Z"
                fill="#11366d"
                opacity="0.47"
              />
              <polygon
                points="477.57 996.7 477.57 996.7 477.57 996.7 477.57 996.7"
                fill="#170"
              />
            </g>
            <path
              d="M490.58,1022.65c-.38-10,3.53-17.78,5.55-19.92,3.28-2.9,4.33-9.13,6.67-10.3,0,0-4,.34-6.17-.67,2.15,2.15,2.75,3.25,1.49,6.52s-2.75,3.57-4.51,6.34a38,38,0,0,0-3.91,10.47c-.5,2.52.13,12.23-.5,14s-1.39,3.66-1.39,3.66l1.71-1.07C490.21,1030.41,490.78,1027.82,490.58,1022.65Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M480.87,1026.56c0-2.27-3.15-4-4.16-7.82s-3.15-4.66-5-7.31-1.26-2.9-1.39-4.66a6.64,6.64,0,0,1-2.9,1.63h0a40,40,0,0,0,4,4.54c4.16,3.91,10.72,18.54,10.72,18.54C482.26,1030.47,480.87,1028.83,480.87,1026.56Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M482.14,1016.47c.25-1.89-.51-7.06-.89-9s-1.64-10.34-2.65-10.59a9.7,9.7,0,0,0-1-.19,15.93,15.93,0,0,1,1,4.47h0s.91,3.84,1.43,6.61a8.74,8.74,0,0,1,.34,2.48c0,.17,0,.37,0,.6,0,1.93.66,1.27.21,3.77C481.06,1016.19,481.88,1018.37,482.14,1016.47Z"
              fill="#86e04b"
            />
            <path
              d="M499.17,984.31c-3.07-.81-5.83-.36-6.29,1.11-.27.87.33,1.9,1.46,2.82C493.43,985.32,497.11,984.52,499.17,984.31Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M473,981.42c-2.87,1.91-4.46,4.56-3.55,5.92a2,2,0,0,0,1.67.77c-2.46-2.72,5.86-8.08,6.44-8.45A10,10,0,0,0,473,981.42Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M466.51,1000.62l-.7.23c-2.3,1.82-3.48,4.06-2.68,5.28a2.33,2.33,0,0,0,2.12.76c0-.2.48-.38,2-.4l.2-.07C462,1005.16,466.51,1000.62,466.51,1000.62Z"
              fill="#11366d"
              opacity="0.47"
            />
          </g>
          <path
            d="M493.22,991.79a4.74,4.74,0,0,1,.68,2.39,8.91,8.91,0,0,1-.29,2.52,15.81,15.81,0,0,1-2.06,4.56c-1.73,2.75-3.5,5.46-5.43,8.11a34.55,34.55,0,0,1,2-4.48c.75-1.46,1.58-2.86,2.44-4.25a22.14,22.14,0,0,0,2.18-4.21A7.9,7.9,0,0,0,493.22,991.79Z"
            fill="#86e04b"
          />
          <path
            d="M495.19,982.48c-.66.37-1.29.7-1.87,1.07A3.8,3.8,0,0,0,492,984.8a1.88,1.88,0,0,0,0,1.6c.1.31.26.61.39.94a10.15,10.15,0,0,1,.5,1,8.22,8.22,0,0,1-1-.63,5.1,5.1,0,0,1-.76-.9,2.49,2.49,0,0,1-.16-2.56,3.48,3.48,0,0,1,1.95-1.51A5,5,0,0,1,495.19,982.48Z"
            fill="#86e04b"
          />
          <path
            d="M470.18,983.06c-.41.65-.82,1.23-1.15,1.83a3.93,3.93,0,0,0-.59,1.71,1.89,1.89,0,0,0,.72,1.44c.23.23.51.42.78.65a10,10,0,0,1,.9.64,8.81,8.81,0,0,1-1.13-.11,6,6,0,0,1-1.1-.44,2.53,2.53,0,0,1-1.34-2.19,3.51,3.51,0,0,1,1-2.25A5,5,0,0,1,470.18,983.06Z"
            fill="#86e04b"
          />
          <path
            d="M463.58,1001.21c-.34.71-.66,1.38-.91,2a4.24,4.24,0,0,0-.3,1.9,2.58,2.58,0,0,0,.87,1.57c.23.25.54.44.81.69a9,9,0,0,1,.94.66,9.72,9.72,0,0,1-1.18-.14,5.25,5.25,0,0,1-1.12-.48,2.91,2.91,0,0,1-1.48-2.15,3.79,3.79,0,0,1,.65-2.46A4.88,4.88,0,0,1,463.58,1001.21Z"
            fill="#86e04b"
          />
        </g>
        <g>
          <path
            d="M1212.54,811.7a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1173.15,817.32,1199,813.72,1212.54,811.7Z"
            fill="url(#e407068e-1345-47d2-a22d-f80f162c71fd)"
          />
          <path
            d="M1203.93,809.77c.5-4-7.08-8.08-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.05,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.69,11.12S1203.93,809.77,1203.93,809.77Z"
            fill="url(#ad90e8f8-c17c-43da-98a9-6ba390d63f52)"
          />
          <path
            d="M1186.26,815.45c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.19-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.07,12.39,11.93,16.12S1188.17,816.13,1186.26,815.45Z"
            fill="url(#bc3a540c-e267-4723-823a-658cf4bb1504)"
          />
        </g>
      </g>
      <g id="bd4ec9fe-6398-4c00-afa9-473f37ec1c69" data-name="bubbl">
        <circle cx="753.55" cy="529.98" r="25.96" fill="#fff" opacity="0.13" />
        <circle cx="986.38" cy="624.59" r="25.96" fill="#fff" opacity="0.13" />
        <circle cx="1158.58" cy="878.02" r="15.85" fill="#fff" opacity="0.13" />
        <image
          width="16"
          height="17"
          transform="translate(601.43 469.46)"
          opacity="0.13"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsSAAALEgHS3X78AAAAYklEQVQ4T82TQQ7AIAgEB+P/v0wPrcY2YCx4cI5AxjUBUVUmtKZ4A9WoWUZXNAqmUR7GGQEoRuMXhTgKOQFwC8LxAd2SIMUZAndNF5AtCVI0QeQbr1vohUX67PecBX8zzQcuvrgNJoTNk7AAAAAASUVORK5CYII="
        />
        <circle cx="703.31" cy="451.15" r="7.92" fill="#fff" opacity="0.13" />
        <circle cx="915.83" cy="474.62" r="7.92" fill="#fff" opacity="0.13" />
        <circle cx="999.21" cy="459.08" r="7.92" fill="#fff" opacity="0.13" />
      </g>
      <g id="fa810a9f-a6d7-417c-82ee-8de2aa163cf2" data-name="bridge">
        <g>
          <path
            d="M1128.53,729.12l-14.63,8.52-14.85-16.7c0-2.73.76-4.67,2.38-5.48,2.07-1,3.37-4.65,4-9.86Z"
            fill="#161470"
          />
          <path
            d="M1146.84,702.86l-16,14.07-25.06-22.11a159.16,159.16,0,0,0-3.3-26.89Z"
            fill="#11115b"
          />
          <rect
            x="758.43"
            y="712.46"
            width="14"
            height="51"
            rx="7"
            transform="translate(-239.47 390.61) rotate(-24.89)"
            fill="url(#bd16bdc8-4e8c-4f7b-b1d3-a9b6916b9547)"
          />
          <rect
            x="1087.43"
            y="586.46"
            width="14"
            height="51"
            rx="7"
            transform="translate(31.86 -53.79) rotate(2.86)"
            fill="url(#b1ddecba-7ba1-4252-9631-90e57cba633f)"
          />
          <rect
            x="770.25"
            y="689"
            width="14"
            height="47.21"
            rx="7"
            transform="translate(-97.01 123.03) rotate(-8.52)"
            fill="url(#e2974162-1b25-423f-803e-ea1154af2ad6)"
          />
          <polygon
            points="802.43 721.46 782.43 751.46 796 752.06 813.27 719.68 802.43 721.46"
            fill="url(#b7093cc1-4e36-4338-971c-4bd5917eaa67)"
          />
          <polygon
            points="816.11 719.25 802.08 751.96 816.1 752.36 828.18 717.96 816.11 719.25"
            fill="url(#b71f5a0b-e864-4ed3-ade2-464e95ce81f3)"
          />
          <polygon
            points="836.29 716.18 823.93 751.96 836.29 751.53 847.65 714.78 836.29 716.18"
            fill="url(#fc89def0-e0ff-4c30-8fac-a3fe98d6862e)"
          />
          <polygon
            points="857.43 714.46 845.43 751.46 861.43 750.46 869.43 712.46 857.43 714.46"
            fill="url(#a152363b-a217-45e6-8331-be22d89975db)"
          />
          <polygon
            points="878.43 711.46 871.03 749.84 880.57 749.14 889.43 709.46 878.43 711.46"
            fill="url(#f4130415-2374-47c7-ab77-765eb8231dea)"
          />
          <polygon
            points="885.1 748.78 896.43 708.46 907.43 707.46 900.42 747.37 885.1 748.78"
            fill="url(#fce62149-dde1-4513-badd-4771db71c073)"
          />
          <polygon
            points="918.43 705.46 907.85 746.59 923.82 744.69 932.43 703.46 918.43 705.46"
            fill="url(#a34a1e4c-402c-4f89-8584-ad45851c70e1)"
          />
          <polygon
            points="942.43 701.46 936.12 743 949 741 953.43 698.46 942.43 701.46"
            fill="url(#eb940756-1191-4bf3-b7d3-601923c15bba)"
          />
          <polygon
            points="964.43 695.46 958.43 739.46 975.43 736.46 974.33 691.85 964.43 695.46"
            fill="url(#b6521dcd-de8d-4c3b-9db3-cc245c2b8ef7)"
          />
          <polygon
            points="1086.43 630.46 1071.43 640.96 1117.42 681.53 1133.43 667.46 1086.43 630.46"
            fill="url(#f679a0f7-8068-43a1-9ff1-e98348639dd1)"
          />
          <polygon
            points="1055.18 651.4 1066.79 644.02 1109.05 687.01 1094.43 695.53 1055.18 651.4"
            fill="url(#ac8639a9-19e5-4ce2-8315-b4d407b4058f)"
          />
          <polygon
            points="1037.43 661.94 1049.11 656 1084.91 700.46 1071.43 706.76 1037.43 661.94"
            fill="url(#fb8bd457-9179-4caf-a8c2-860130397f1b)"
          />
          <polygon
            points="1016.08 673.41 1028.74 666.76 1061.17 711.09 1043.52 717.73 1016.08 673.41"
            fill="url(#a94f6b12-0be6-415d-8dfd-588abddf7079)"
          />
          <polygon
            points="999.21 681.53 1008.99 676.93 1037.43 719.81 1015.71 726.46 999.21 681.53"
            fill="url(#ac8f7cae-5820-42ba-aa18-fc35657489da)"
          />
          <polygon
            points="980.22 689.6 990.43 685.41 1008.7 728.38 986.75 733.74 980.22 689.6"
            fill="url(#b83ae6f6-dac3-4333-bc99-ae398aafb049)"
          />
          <rect x="782.43" y="751.46" width="13.86" height="3" fill="#60281f" />
          <polygon
            points="813.43 719.46 796.43 751.46 796.43 754.46 813.43 720.46 813.43 719.46"
            fill="#60281f"
          />
          <polygon
            points="802.08 751.96 816.1 752.36 816.09 754.86 802.08 754.45 802.08 751.96"
            fill="#60281f"
          />
          <polygon
            points="816.1 752.36 828.18 717.96 828.18 719.59 816.09 754.86 816.1 752.36"
            fill="#60281f"
          />
          <polygon
            points="823.93 751.96 823.93 754.86 836.29 754.09 836.29 751.53 823.93 751.96"
            fill="#60281f"
          />
          <polygon
            points="847.65 714.78 836.29 751.53 836.29 754.09 847.65 715.96 847.65 714.78"
            fill="#60281f"
          />
          <polygon
            points="845.43 751.46 845.43 754.86 861.26 754.09 861.43 750.46 845.43 751.46"
            fill="#60281f"
          />
          <polygon
            points="869.43 712.46 861.43 750.46 861.26 754.09 870.05 713.3 869.43 712.46"
            fill="#60281f"
          />
          <polygon
            points="871.03 749.84 871.03 753.2 880.76 752.66 880.57 749.14 871.03 749.84"
            fill="#60281f"
          />
          <polygon
            points="889.43 709.46 880.57 749.14 880.76 752.66 889.43 711.25 889.43 709.46"
            fill="#60281f"
          />
          <polygon
            points="885.1 748.78 885.1 752.66 900.43 751.46 900.42 747.37 885.1 748.78"
            fill="#60281f"
          />
          <polygon
            points="907.43 707.46 900.42 747.37 900.43 751.46 907.85 709.46 907.43 707.46"
            fill="#60281f"
          />
          <polygon
            points="907.85 746.59 907.85 750.46 923.82 748.78 923.82 744.69 907.85 746.59"
            fill="#60281f"
          />
          <polygon
            points="932.43 703.46 923.82 744.69 923.82 748.78 932.43 705.71 932.43 703.46"
            fill="#60281f"
          />
          <polygon
            points="936.12 743 936.12 747.37 949.01 745.18 949 741 936.12 743"
            fill="#60281f"
          />
          <polygon
            points="953.43 698.46 949 741 949.01 745.18 953.43 700.34 953.43 698.46"
            fill="#60281f"
          />
          <polygon
            points="958.43 739.46 958.43 743 975.43 739.46 975.43 736.46 958.43 739.46"
            fill="#60281f"
          />
          <polygon
            points="986.75 733.74 986.75 738.13 1008.7 732.54 1008.7 728.38 986.75 733.74"
            fill="#60281f"
          />
          <polygon
            points="980.22 689.6 986.75 738.13 986.75 733.74 980.22 689.6"
            fill="#60281f"
          />
          <polygon
            points="1015.71 726.46 1015.71 731.38 1037.43 724.46 1037.43 719.81 1015.71 726.46"
            fill="#60281f"
          />
          <polygon
            points="999.21 681.53 1015.71 731.38 1015.71 726.46 999.21 681.53"
            fill="#60281f"
          />
          <polygon
            points="1043.52 717.73 1043.52 723.04 1061.17 715.63 1061.17 711.09 1043.52 717.73"
            fill="#60281f"
          />
          <polygon
            points="1016.08 673.41 1016.08 676.93 1043.52 723.04 1043.52 717.73 1016.08 673.41"
            fill="#60281f"
          />
          <polygon
            points="1071.43 706.76 1071.43 711.09 1084.91 703.98 1084.91 700.46 1071.43 706.76"
            fill="#60281f"
          />
          <polygon
            points="1037.43 661.94 1037.43 666.76 1071.43 711.09 1071.43 706.76 1037.43 661.94"
            fill="#60281f"
          />
          <polygon
            points="1094.43 695.53 1094.43 700.46 1109.05 692.25 1109.05 687.01 1094.43 695.53"
            fill="#60281f"
          />
          <polygon
            points="1055.18 651.4 1055.18 656.79 1094.43 700.46 1094.43 695.53 1055.18 651.4"
            fill="#60281f"
          />
          <polygon
            points="1117.42 681.53 1117.42 687.96 1133.43 673.9 1133.43 667.46 1117.42 681.53"
            fill="#60281f"
          />
          <polygon
            points="1071.43 640.96 1071.43 646.71 1117.42 687.96 1117.42 681.53 1071.43 640.96"
            fill="#60281f"
          />
          <line
            x1="799.85"
            y1="745.38"
            x2="804.9"
            y2="745.38"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M819.34,745.38s6.54.92,7.1-.69"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M839.09,744.69s8.19,1.06,8.56-.09"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M864.08,741a14.48,14.48,0,0,0,8.18,0"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <line
            x1="883.8"
            y1="738.13"
            x2="887.96"
            y2="736.96"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <line
            x1="902.14"
            y1="737.55"
            x2="910.45"
            y2="736.46"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <line
            x1="925.66"
            y1="735.87"
            x2="937.77"
            y2="732.13"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M950.56,729.46s5.64,1.09,9.38-1.08"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M975.15,725s6.82-.9,8.34-2"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1003.89,717.07s2.11.2,7.2-3.21"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <line
            x1="1029.86"
            y1="708.4"
            x2="1033.24"
            y2="705.78"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1051.76,698.23s2.9,1.87,9.41-2.7"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1076.16,689.6s8.85-3.49,8.75-4.19"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1098.16,675.93s4-3.47,5.77-4.72"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M808.77,728.12s.66.91,3.53,0"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M825.71,726.81s.83,2.53,7.52-1.78"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <rect
            x="1126.43"
            y="615.46"
            width="14"
            height="51"
            rx="7"
            transform="translate(33.36 -55.7) rotate(2.86)"
            fill="url(#a97b3391-50c3-40d5-96c3-1931869cb817)"
          />
          <path
            d="M844.49,725a14.21,14.21,0,0,0,10-1.47"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M868.16,722.09a8.73,8.73,0,0,0,7.74,0"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M887.45,720.73s.95,1.13,6-1.76"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M906.3,718.23s5.76.75,9.51-2.57"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M930.91,713.3s6.28,2.18,10-1.58"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M952.76,707.09s6,.63,10.26-1.31"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M974.62,703.46a10.37,10.37,0,0,0,7.23-1.76"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M994.73,695.53a10.65,10.65,0,0,0,8-3.28"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1014.61,685.41s1.71.63,5.08-2.41"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1035.45,675.93a9.38,9.38,0,0,0,8.07-4.72"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1055.92,664.46s2.11-.52,5.25-3.7"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M1074.05,651.4s3.22-.38,4.38-1.81"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
          <path
            d="M759.12,741s4.43,3.59,14.31-2.43c-1.6-2-12.71-.14-12.71-.14Z"
            fill="#491a0b"
          />
          <path
            d="M771.83,736.55c43.12,6.87,264.8-23.5,357.66-93.42"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M882,742.68c-3.35.53-6.64,1-9.89,1.49"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M925.9,734.72c-5.32,1.09-10.6,2.13-15.8,3.11"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M975.1,723.2q-7.5,2-15,3.82"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M1028.89,706.93q-9,3.11-18.14,6"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M1075.29,688.51q-6.52,3-13.29,5.81"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M1124.84,660.7c-5.62,4-11.63,7.82-18,11.53"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M1098.94,676.72q-7.07,3.85-14.57,7.5"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M1051.91,698.43q-8.13,3.2-16.5,6.2"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M1003.13,715.27Q994,718,984.8,720.59"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M950.21,729.39q-6.24,1.46-12.44,2.81"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M902.59,739.21l-.76.14q-7.51,1.35-14.79,2.53"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M837.24,748.45q-6.51.63-12.47,1.07"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M783.67,749.6a96,96,0,0,0,13.14.94"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M862.47,745.52c-5.42.72-10.68,1.37-15.74,1.93"
            fill="none"
            stroke="#181451"
            strokeMiterlimit="10"
            strokeWidth="3"
            opacity="0.19"
          />
          <path
            d="M786.76,714.19s9,.48,12.26-2.12S1062.26,668,1089.26,611.74"
            fill="none"
            stroke="#ad825c"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="4"
          />
          <path
            d="M761.63,715.44h0a7,7,0,0,0-6.93-.61h0a7,7,0,0,0-3.41,9.3l2.54,5.46S752.75,716.1,761.63,715.44Z"
            fill="#935b4c"
          />
          <path
            d="M775,689.2a7.05,7.05,0,0,0-1.29.06h0a7,7,0,0,0-5.88,8l2.1,14C768.89,704,772.53,694.6,775,689.2Z"
            fill="#935b4c"
          />
          <path
            d="M770,711.23a22.62,22.62,0,0,0,3.49,1.5,13.92,13.92,0,0,0,3.22.64,19.48,19.48,0,0,0,3.38-.12c.6,0,1.19-.19,1.85-.24a14.66,14.66,0,0,1,2-.25,7.78,7.78,0,0,1-3.17,2.74,8.69,8.69,0,0,1-4.29.87,7.85,7.85,0,0,1-4.16-1.59A6.19,6.19,0,0,1,770,711.23Z"
            fill="#ad825c"
          />
          <path
            d="M757.71,736.77a22.06,22.06,0,0,0,3.74.66,13.8,13.8,0,0,0,3.29-.11,19.3,19.3,0,0,0,3.25-.89c.57-.18,1.12-.46,1.75-.65a15,15,0,0,1,1.91-.72,10.18,10.18,0,0,1-1,1.87,10.55,10.55,0,0,1-1.46,1.53,8.61,8.61,0,0,1-4,1.82,7.8,7.8,0,0,1-4.41-.59A6.15,6.15,0,0,1,757.71,736.77Z"
            fill="#ad825c"
          />
          <path
            d="M771,718a21.81,21.81,0,0,0,3.46-.49,29.26,29.26,0,0,0,3-.88c1-.33,2-.77,3-1.17.52-.21,1-.45,1.63-.63a10.67,10.67,0,0,1,1.81-.6,9.2,9.2,0,0,1-.89,1.74,10.91,10.91,0,0,1-1.26,1.46,9.26,9.26,0,0,1-3.34,2,8.39,8.39,0,0,1-4,.4A5.46,5.46,0,0,1,771,718Z"
            fill="#ad825c"
          />
          <path
            d="M1126.42,641c1.35-.11,2.54-.11,3.71-.11l3.35,0c1.09,0,2.14-.1,3.25-.2s2.2-.35,3.57-.54a6.39,6.39,0,0,1-2.85,2.78,9.05,9.05,0,0,1-3.9,1,10.37,10.37,0,0,1-3.88-.68A8,8,0,0,1,1126.42,641Z"
            fill="#ad825c"
          />
          <path
            d="M1087.54,610.71c1.35-.11,2.54-.11,3.7-.11l3.36,0c1.09,0,2.14-.1,3.24-.2s2.21-.35,3.58-.54a6.44,6.44,0,0,1-2.85,2.78,9.09,9.09,0,0,1-3.91,1,10.35,10.35,0,0,1-3.87-.68A8,8,0,0,1,1087.54,610.71Z"
            fill="#ad825c"
          />
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1186.37,609.7c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1186.37,609.7Z"
                fill="#2f6840"
              />
              <path
                d="M1185.86,609.35c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1185.86,609.35Z"
                fill="#3ba525"
              />
              <path
                d="M1186.61,609.32a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1186.61,609.32Z"
                fill="#2f6840"
              />
              <path
                d="M1190.09,608.53c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1190.09,608.53Z"
                fill="#2f6840"
              />
              <path
                d="M1188.72,611.74a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1188.72,611.74Z"
                fill="#2f6840"
              />
              <path
                d="M1186.77,609.78c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1186.77,609.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1183.71,618.43c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1183.71,618.43Z"
                fill="#2f6840"
              />
              <path
                d="M1183.2,618.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1183.2,618.08Z"
                fill="#3ba525"
              />
              <path
                d="M1184,618.05a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1184,618.05Z"
                fill="#2f6840"
              />
              <path
                d="M1187.43,617.26a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1187.43,617.26Z"
                fill="#2f6840"
              />
              <path
                d="M1186.06,620.47a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1186.06,620.47Z"
                fill="#2f6840"
              />
              <path
                d="M1184.11,618.51c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1184.11,618.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1178.35,613.47c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1178.35,613.47Z"
                fill="#2f6840"
              />
              <path
                d="M1177.85,613.12c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1177.85,613.12Z"
                fill="#3ba525"
              />
              <path
                d="M1178.6,613.1a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1178.6,613.1Z"
                fill="#2f6840"
              />
              <path
                d="M1182.08,612.3c-.26,0-.49,0-.73.1a3.65,3.65,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1182.08,612.3Z"
                fill="#2f6840"
              />
              <path
                d="M1180.71,615.51a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,1180.71,615.51Z"
                fill="#2f6840"
              />
              <path
                d="M1178.75,613.55c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1178.75,613.55Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1170,610.1c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1170,610.1Z"
                fill="#2f6840"
              />
              <path
                d="M1169.51,609.75c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1169.51,609.75Z"
                fill="#3ba525"
              />
              <path
                d="M1170.26,609.72a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1170.26,609.72Z"
                fill="#2f6840"
              />
              <path
                d="M1173.74,608.93a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1173.74,608.93Z"
                fill="#2f6840"
              />
              <path
                d="M1172.37,612.14a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1172.37,612.14Z"
                fill="#2f6840"
              />
              <path
                d="M1170.41,610.18c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1170.41,610.18Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1184.72,625.59c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1184.72,625.59Z"
                fill="#2f6840"
              />
              <path
                d="M1184.21,625.24c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1184.21,625.24Z"
                fill="#3ba525"
              />
              <path
                d="M1185,625.21a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1185,625.21Z"
                fill="#2f6840"
              />
              <path
                d="M1188.44,624.42a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1188.44,624.42Z"
                fill="#2f6840"
              />
              <path
                d="M1187.07,627.63a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1187.07,627.63Z"
                fill="#2f6840"
              />
              <path
                d="M1185.12,625.67c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1185.12,625.67Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1171.26,620c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1171.26,620Z"
                fill="#2f6840"
              />
              <path
                d="M1170.75,619.67c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1170.75,619.67Z"
                fill="#3ba525"
              />
              <path
                d="M1171.51,619.64a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1171.51,619.64Z"
                fill="#2f6840"
              />
              <path
                d="M1175,618.85a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1175,618.85Z"
                fill="#2f6840"
              />
              <path
                d="M1173.62,622.06a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A1,1,0,0,1,1173.62,622.06Z"
                fill="#2f6840"
              />
              <path
                d="M1171.66,620.1c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1171.66,620.1Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1159.29,615.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1159.29,615.71Z"
                fill="#2f6840"
              />
              <path
                d="M1158.79,615.37c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1158.79,615.37Z"
                fill="#3ba525"
              />
              <path
                d="M1159.54,615.34a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1159.54,615.34Z"
                fill="#2f6840"
              />
              <path
                d="M1163,614.54c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1163,614.54Z"
                fill="#2f6840"
              />
              <path
                d="M1161.65,617.75a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1161.65,617.75Z"
                fill="#2f6840"
              />
              <path
                d="M1159.69,615.8c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1159.69,615.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1156.63,624.44c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1156.63,624.44Z"
                fill="#2f6840"
              />
              <path
                d="M1156.13,624.1c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1156.13,624.1Z"
                fill="#3ba525"
              />
              <path
                d="M1156.88,624.07a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1156.88,624.07Z"
                fill="#2f6840"
              />
              <path
                d="M1160.36,623.27c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1160.36,623.27Z"
                fill="#2f6840"
              />
              <path
                d="M1159,626.48a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1159,626.48Z"
                fill="#2f6840"
              />
              <path
                d="M1157,624.53c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1157,624.53Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1151.28,619.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1151.28,619.48Z"
                fill="#2f6840"
              />
              <path
                d="M1150.78,619.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1150.78,619.14Z"
                fill="#3ba525"
              />
              <path
                d="M1151.53,619.11a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1151.53,619.11Z"
                fill="#2f6840"
              />
              <path
                d="M1155,618.31c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1155,618.31Z"
                fill="#2f6840"
              />
              <path
                d="M1153.64,621.53a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1153.64,621.53Z"
                fill="#2f6840"
              />
              <path
                d="M1151.68,619.57c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1151.68,619.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1142.94,616.11c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1142.94,616.11Z"
                fill="#2f6840"
              />
              <path
                d="M1142.43,615.77c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1142.43,615.77Z"
                fill="#3ba525"
              />
              <path
                d="M1143.19,615.74a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1143.19,615.74Z"
                fill="#2f6840"
              />
              <path
                d="M1146.66,614.94c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1146.66,614.94Z"
                fill="#2f6840"
              />
              <path
                d="M1145.3,618.15a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1145.3,618.15Z"
                fill="#2f6840"
              />
              <path
                d="M1143.34,616.2c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1143.34,616.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1157.64,631.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1157.64,631.6Z"
                fill="#2f6840"
              />
              <path
                d="M1157.14,631.26c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1157.14,631.26Z"
                fill="#3ba525"
              />
              <path
                d="M1157.89,631.23a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1157.89,631.23Z"
                fill="#2f6840"
              />
              <path
                d="M1161.37,630.43c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1161.37,630.43Z"
                fill="#2f6840"
              />
              <path
                d="M1160,633.64a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1160,633.64Z"
                fill="#2f6840"
              />
              <path
                d="M1158,631.69c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1158,631.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1144.19,626c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1144.19,626Z"
                fill="#2f6840"
              />
              <path
                d="M1143.68,625.69c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1143.68,625.69Z"
                fill="#3ba525"
              />
              <path
                d="M1144.43,625.66a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.35,2.35,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1144.43,625.66Z"
                fill="#2f6840"
              />
              <path
                d="M1147.91,624.86c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1147.91,624.86Z"
                fill="#2f6840"
              />
              <path
                d="M1146.54,628.07a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1146.54,628.07Z"
                fill="#2f6840"
              />
              <path
                d="M1144.59,626.12c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,1144.59,626.12Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1136.92,633.36c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1136.92,633.36Z"
                fill="#2f6840"
              />
              <path
                d="M1136.42,633c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1136.42,633Z"
                fill="#3ba525"
              />
              <path
                d="M1137.17,633a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1137.17,633Z"
                fill="#2f6840"
              />
              <path
                d="M1140.65,632.19a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1140.65,632.19Z"
                fill="#2f6840"
              />
              <path
                d="M1139.28,635.4a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1139.28,635.4Z"
                fill="#2f6840"
              />
              <path
                d="M1137.32,633.44c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1137.32,633.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1134.26,642.09c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1134.26,642.09Z"
                fill="#2f6840"
              />
              <path
                d="M1133.76,641.74c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1133.76,641.74Z"
                fill="#3ba525"
              />
              <path
                d="M1134.51,641.71a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1134.51,641.71Z"
                fill="#2f6840"
              />
              <path
                d="M1138,640.92a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1138,640.92Z"
                fill="#2f6840"
              />
              <path
                d="M1136.62,644.13a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1136.62,644.13Z"
                fill="#2f6840"
              />
              <path
                d="M1134.66,642.17c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1134.66,642.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1128.91,637.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1128.91,637.13Z"
                fill="#2f6840"
              />
              <path
                d="M1128.41,636.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1128.41,636.78Z"
                fill="#3ba525"
              />
              <path
                d="M1129.16,636.75a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1129.16,636.75Z"
                fill="#2f6840"
              />
              <path
                d="M1132.64,636c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1132.64,636Z"
                fill="#2f6840"
              />
              <path
                d="M1131.27,639.17a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1131.27,639.17Z"
                fill="#2f6840"
              />
              <path
                d="M1129.31,637.21c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1129.31,637.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1120.57,633.76c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1120.57,633.76Z"
                fill="#2f6840"
              />
              <path
                d="M1120.06,633.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1120.06,633.41Z"
                fill="#3ba525"
              />
              <path
                d="M1120.82,633.38a2.21,2.21,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1120.82,633.38Z"
                fill="#2f6840"
              />
              <path
                d="M1124.29,632.59a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1124.29,632.59Z"
                fill="#2f6840"
              />
              <path
                d="M1122.93,635.8a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1122.93,635.8Z"
                fill="#2f6840"
              />
              <path
                d="M1121,633.84c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1121,633.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1135.27,649.25c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1135.27,649.25Z"
                fill="#2f6840"
              />
              <path
                d="M1134.77,648.9c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1134.77,648.9Z"
                fill="#3ba525"
              />
              <path
                d="M1135.52,648.87a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1135.52,648.87Z"
                fill="#2f6840"
              />
              <path
                d="M1139,648.08a5.58,5.58,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1139,648.08Z"
                fill="#2f6840"
              />
              <path
                d="M1137.63,651.29a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1137.63,651.29Z"
                fill="#2f6840"
              />
              <path
                d="M1135.67,649.33c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1135.67,649.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1121.82,643.68c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1121.82,643.68Z"
                fill="#2f6840"
              />
              <path
                d="M1121.31,643.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1121.31,643.33Z"
                fill="#3ba525"
              />
              <path
                d="M1122.06,643.3a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1122.06,643.3Z"
                fill="#2f6840"
              />
              <path
                d="M1125.54,642.51a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1125.54,642.51Z"
                fill="#2f6840"
              />
              <path
                d="M1124.17,645.72a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1124.17,645.72Z"
                fill="#2f6840"
              />
              <path
                d="M1122.22,643.76c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1122.22,643.76Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1113.48,649.55c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1113.48,649.55Z"
                fill="#2f6840"
              />
              <path
                d="M1113,649.21c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1113,649.21Z"
                fill="#3ba525"
              />
              <path
                d="M1113.73,649.18a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1113.73,649.18Z"
                fill="#2f6840"
              />
              <path
                d="M1117.2,648.38c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1117.2,648.38Z"
                fill="#2f6840"
              />
              <path
                d="M1115.83,651.59a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1115.83,651.59Z"
                fill="#2f6840"
              />
              <path
                d="M1113.88,649.64c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1113.88,649.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1110.82,658.28c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1110.82,658.28Z"
                fill="#2f6840"
              />
              <path
                d="M1110.31,657.94c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1110.31,657.94Z"
                fill="#3ba525"
              />
              <path
                d="M1111.07,657.91a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1111.07,657.91Z"
                fill="#2f6840"
              />
              <path
                d="M1114.54,657.11c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.47,2.47,0,0,1,1113,657,2.12,2.12,0,0,1,1114.54,657.11Z"
                fill="#2f6840"
              />
              <path
                d="M1113.18,660.32a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1113.18,660.32Z"
                fill="#2f6840"
              />
              <path
                d="M1111.22,658.37c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1111.22,658.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1105.47,653.32c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1105.47,653.32Z"
                fill="#2f6840"
              />
              <path
                d="M1105,653c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1105,653Z"
                fill="#3ba525"
              />
              <path
                d="M1105.71,653a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1105.71,653Z"
                fill="#2f6840"
              />
              <path
                d="M1109.19,652.15c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,1109.19,652.15Z"
                fill="#2f6840"
              />
              <path
                d="M1107.82,655.37a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1107.82,655.37Z"
                fill="#2f6840"
              />
              <path
                d="M1105.87,653.41c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1105.87,653.41Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1097.12,650c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1097.12,650Z"
                fill="#2f6840"
              />
              <path
                d="M1096.62,649.61c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1096.62,649.61Z"
                fill="#3ba525"
              />
              <path
                d="M1097.37,649.58a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1097.37,649.58Z"
                fill="#2f6840"
              />
              <path
                d="M1100.85,648.78c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1100.85,648.78Z"
                fill="#2f6840"
              />
              <path
                d="M1099.48,652a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1099.48,652Z"
                fill="#2f6840"
              />
              <path
                d="M1097.52,650c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1097.52,650Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1111.83,665.44c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1111.83,665.44Z"
                fill="#2f6840"
              />
              <path
                d="M1111.32,665.1c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1111.32,665.1Z"
                fill="#3ba525"
              />
              <path
                d="M1112.08,665.07a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1112.08,665.07Z"
                fill="#2f6840"
              />
              <path
                d="M1115.55,664.27c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1115.55,664.27Z"
                fill="#2f6840"
              />
              <path
                d="M1114.19,667.48a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1114.19,667.48Z"
                fill="#2f6840"
              />
              <path
                d="M1112.23,665.53c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1112.23,665.53Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1098.37,659.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1098.37,659.87Z"
                fill="#2f6840"
              />
              <path
                d="M1097.87,659.53c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1097.87,659.53Z"
                fill="#3ba525"
              />
              <path
                d="M1098.62,659.5a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,2,2,0,0,1,.47.53A1,1,0,0,1,1098.62,659.5Z"
                fill="#2f6840"
              />
              <path
                d="M1102.1,658.7c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1102.1,658.7Z"
                fill="#2f6840"
              />
              <path
                d="M1100.73,661.91a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1100.73,661.91Z"
                fill="#2f6840"
              />
              <path
                d="M1098.77,660c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1098.77,660Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1088.63,663.31c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1088.63,663.31Z"
                fill="#2f6840"
              />
              <path
                d="M1088.13,663c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1088.13,663Z"
                fill="#3ba525"
              />
              <path
                d="M1088.88,662.93a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,1088.88,662.93Z"
                fill="#2f6840"
              />
              <path
                d="M1092.36,662.14a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1092.36,662.14Z"
                fill="#2f6840"
              />
              <path
                d="M1091,665.35a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1091,665.35Z"
                fill="#2f6840"
              />
              <path
                d="M1089,663.39c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1089,663.39Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1086,672c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1086,672Z"
                fill="#2f6840"
              />
              <path
                d="M1085.47,671.69c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1085.47,671.69Z"
                fill="#3ba525"
              />
              <path
                d="M1086.22,671.66a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1086.22,671.66Z"
                fill="#2f6840"
              />
              <path
                d="M1089.7,670.87c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1089.7,670.87Z"
                fill="#2f6840"
              />
              <path
                d="M1088.33,674.08a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1088.33,674.08Z"
                fill="#2f6840"
              />
              <path
                d="M1086.37,672.12c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1086.37,672.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1080.62,667.08c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1080.62,667.08Z"
                fill="#2f6840"
              />
              <path
                d="M1080.11,666.73c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1080.11,666.73Z"
                fill="#3ba525"
              />
              <path
                d="M1080.87,666.7a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1080.87,666.7Z"
                fill="#2f6840"
              />
              <path
                d="M1084.34,665.91c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1084.34,665.91Z"
                fill="#2f6840"
              />
              <path
                d="M1083,669.12a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A1,1,0,0,1,1083,669.12Z"
                fill="#2f6840"
              />
              <path
                d="M1081,667.16c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1081,667.16Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1072.28,663.71c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1072.28,663.71Z"
                fill="#2f6840"
              />
              <path
                d="M1071.77,663.36c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1071.77,663.36Z"
                fill="#3ba525"
              />
              <path
                d="M1072.52,663.33a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1072.52,663.33Z"
                fill="#2f6840"
              />
              <path
                d="M1076,662.54a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.45,10.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1076,662.54Z"
                fill="#2f6840"
              />
              <path
                d="M1074.63,665.75a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1074.63,665.75Z"
                fill="#2f6840"
              />
              <path
                d="M1072.68,663.79c-.25.06-.48.09-.7.16a3.87,3.87,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1072.68,663.79Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1087,679.2c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,1087,679.2Z"
                fill="#2f6840"
              />
              <path
                d="M1086.48,678.85c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1086.48,678.85Z"
                fill="#3ba525"
              />
              <path
                d="M1087.23,678.82a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1087.23,678.82Z"
                fill="#2f6840"
              />
              <path
                d="M1090.71,678c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,1090.71,678Z"
                fill="#2f6840"
              />
              <path
                d="M1089.34,681.24a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1089.34,681.24Z"
                fill="#2f6840"
              />
              <path
                d="M1087.38,679.28c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1087.38,679.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1073.53,673.63c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1073.53,673.63Z"
                fill="#2f6840"
              />
              <path
                d="M1073,673.28c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1073,673.28Z"
                fill="#3ba525"
              />
              <path
                d="M1073.77,673.25a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1073.77,673.25Z"
                fill="#2f6840"
              />
              <path
                d="M1077.25,672.46a5.21,5.21,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1077.25,672.46Z"
                fill="#2f6840"
              />
              <path
                d="M1075.88,675.67a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,2,2,0,0,1,.4.57A1,1,0,0,1,1075.88,675.67Z"
                fill="#2f6840"
              />
              <path
                d="M1073.92,673.71c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1073.92,673.71Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1062.69,675.08c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1062.69,675.08Z"
                fill="#2f6840"
              />
              <path
                d="M1062.18,674.74c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1062.18,674.74Z"
                fill="#3ba525"
              />
              <path
                d="M1062.94,674.71a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,1062.94,674.71Z"
                fill="#2f6840"
              />
              <path
                d="M1066.41,673.91c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1066.41,673.91Z"
                fill="#2f6840"
              />
              <path
                d="M1065.05,677.12a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1065.05,677.12Z"
                fill="#2f6840"
              />
              <path
                d="M1063.09,675.17c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1063.09,675.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1060,683.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1060,683.81Z"
                fill="#2f6840"
              />
              <path
                d="M1059.53,683.47c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1059.53,683.47Z"
                fill="#3ba525"
              />
              <path
                d="M1060.28,683.44a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1060.28,683.44Z"
                fill="#2f6840"
              />
              <path
                d="M1063.76,682.64c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1063.76,682.64Z"
                fill="#2f6840"
              />
              <path
                d="M1062.39,685.85a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1062.39,685.85Z"
                fill="#2f6840"
              />
              <path
                d="M1060.43,683.9c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1060.43,683.9Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1054.68,678.85c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1054.68,678.85Z"
                fill="#2f6840"
              />
              <path
                d="M1054.17,678.51c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1054.17,678.51Z"
                fill="#3ba525"
              />
              <path
                d="M1054.93,678.48a2.24,2.24,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1054.93,678.48Z"
                fill="#2f6840"
              />
              <path
                d="M1058.4,677.68c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,1058.4,677.68Z"
                fill="#2f6840"
              />
              <path
                d="M1057,680.89a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1057,680.89Z"
                fill="#2f6840"
              />
              <path
                d="M1055.08,678.94c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1055.08,678.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1046.34,675.48c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1046.34,675.48Z"
                fill="#2f6840"
              />
              <path
                d="M1045.83,675.14c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1045.83,675.14Z"
                fill="#3ba525"
              />
              <path
                d="M1046.58,675.11a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1046.58,675.11Z"
                fill="#2f6840"
              />
              <path
                d="M1050.06,674.31c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1050.06,674.31Z"
                fill="#2f6840"
              />
              <path
                d="M1048.69,677.52a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1048.69,677.52Z"
                fill="#2f6840"
              />
              <path
                d="M1046.73,675.57c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1046.73,675.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1061,691c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1061,691Z"
                fill="#2f6840"
              />
              <path
                d="M1060.53,690.63c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1060.53,690.63Z"
                fill="#3ba525"
              />
              <path
                d="M1061.29,690.6a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1061.29,690.6Z"
                fill="#2f6840"
              />
              <path
                d="M1064.77,689.8c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1064.77,689.8Z"
                fill="#2f6840"
              />
              <path
                d="M1063.4,693a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1063.4,693Z"
                fill="#2f6840"
              />
              <path
                d="M1061.44,691.06a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1061.44,691.06Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1047.58,685.4c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1047.58,685.4Z"
                fill="#2f6840"
              />
              <path
                d="M1047.08,685.06c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1047.08,685.06Z"
                fill="#3ba525"
              />
              <path
                d="M1047.83,685a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1047.83,685Z"
                fill="#2f6840"
              />
              <path
                d="M1051.31,684.23c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1051.31,684.23Z"
                fill="#2f6840"
              />
              <path
                d="M1049.94,687.44a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1049.94,687.44Z"
                fill="#2f6840"
              />
              <path
                d="M1048,685.49c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1048,685.49Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1036.37,686c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1036.37,686Z"
                fill="#2f6840"
              />
              <path
                d="M1035.86,685.65c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1035.86,685.65Z"
                fill="#3ba525"
              />
              <path
                d="M1036.61,685.62a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1036.61,685.62Z"
                fill="#2f6840"
              />
              <path
                d="M1040.09,684.82c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1040.09,684.82Z"
                fill="#2f6840"
              />
              <path
                d="M1038.72,688a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1038.72,688Z"
                fill="#2f6840"
              />
              <path
                d="M1036.77,686.08a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2.07,2.07,0,0,1,1036.77,686.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1033.71,694.72c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1033.71,694.72Z"
                fill="#2f6840"
              />
              <path
                d="M1033.2,694.38c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1033.2,694.38Z"
                fill="#3ba525"
              />
              <path
                d="M1034,694.35a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1034,694.35Z"
                fill="#2f6840"
              />
              <path
                d="M1037.43,693.55c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1037.43,693.55Z"
                fill="#2f6840"
              />
              <path
                d="M1036.06,696.76a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1036.06,696.76Z"
                fill="#2f6840"
              />
              <path
                d="M1034.11,694.81c-.25.06-.48.08-.7.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,1034.11,694.81Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1028.35,689.76c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1028.35,689.76Z"
                fill="#2f6840"
              />
              <path
                d="M1027.85,689.42c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1027.85,689.42Z"
                fill="#3ba525"
              />
              <path
                d="M1028.6,689.39a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1028.6,689.39Z"
                fill="#2f6840"
              />
              <path
                d="M1032.08,688.59c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1032.08,688.59Z"
                fill="#2f6840"
              />
              <path
                d="M1030.71,691.8a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1030.71,691.8Z"
                fill="#2f6840"
              />
              <path
                d="M1028.75,689.85c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,1028.75,689.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1020,686.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1020,686.39Z"
                fill="#2f6840"
              />
              <path
                d="M1019.51,686.05c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1019.51,686.05Z"
                fill="#3ba525"
              />
              <path
                d="M1020.26,686a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1020.26,686Z"
                fill="#2f6840"
              />
              <path
                d="M1023.74,685.22c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,1023.74,685.22Z"
                fill="#2f6840"
              />
              <path
                d="M1022.37,688.43a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1022.37,688.43Z"
                fill="#2f6840"
              />
              <path
                d="M1020.41,686.48a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1020.41,686.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1034.72,701.88c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1034.72,701.88Z"
                fill="#2f6840"
              />
              <path
                d="M1034.21,701.54c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1034.21,701.54Z"
                fill="#3ba525"
              />
              <path
                d="M1035,701.51a2.15,2.15,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A.93.93,0,0,1,1035,701.51Z"
                fill="#2f6840"
              />
              <path
                d="M1038.44,700.71c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1038.44,700.71Z"
                fill="#2f6840"
              />
              <path
                d="M1037.07,703.92a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1037.07,703.92Z"
                fill="#2f6840"
              />
              <path
                d="M1035.12,702a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1035.12,702Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1021.26,696.31c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1021.26,696.31Z"
                fill="#2f6840"
              />
              <path
                d="M1020.75,696c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1020.75,696Z"
                fill="#3ba525"
              />
              <path
                d="M1021.51,695.94a2.17,2.17,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,1021.51,695.94Z"
                fill="#2f6840"
              />
              <path
                d="M1025,695.14c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1025,695.14Z"
                fill="#2f6840"
              />
              <path
                d="M1023.62,698.35a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1023.62,698.35Z"
                fill="#2f6840"
              />
              <path
                d="M1021.66,696.4a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1021.66,696.4Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M1009.83,696.31c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,1009.83,696.31Z"
                fill="#2f6840"
              />
              <path
                d="M1009.32,696c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1009.32,696Z"
                fill="#3ba525"
              />
              <path
                d="M1010.07,695.94a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1010.07,695.94Z"
                fill="#2f6840"
              />
              <path
                d="M1013.55,695.15c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1013.55,695.15Z"
                fill="#2f6840"
              />
              <path
                d="M1012.18,698.36a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1012.18,698.36Z"
                fill="#2f6840"
              />
              <path
                d="M1010.22,696.4c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1010.22,696.4Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1007.17,705c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1007.17,705Z"
                fill="#2f6840"
              />
              <path
                d="M1006.66,704.7c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1006.66,704.7Z"
                fill="#3ba525"
              />
              <path
                d="M1007.41,704.67a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1007.41,704.67Z"
                fill="#2f6840"
              />
              <path
                d="M1010.89,703.88c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,1010.89,703.88Z"
                fill="#2f6840"
              />
              <path
                d="M1009.52,707.09a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1009.52,707.09Z"
                fill="#2f6840"
              />
              <path
                d="M1007.57,705.13c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1007.57,705.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1001.81,700.09c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1001.81,700.09Z"
                fill="#2f6840"
              />
              <path
                d="M1001.31,699.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1001.31,699.74Z"
                fill="#3ba525"
              />
              <path
                d="M1002.06,699.71a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1002.06,699.71Z"
                fill="#2f6840"
              />
              <path
                d="M1005.54,698.92c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1005.54,698.92Z"
                fill="#2f6840"
              />
              <path
                d="M1004.17,702.13a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1004.17,702.13Z"
                fill="#2f6840"
              />
              <path
                d="M1002.21,700.17c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1002.21,700.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M993.47,696.71c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,993.47,696.71Z"
                fill="#2f6840"
              />
              <path
                d="M993,696.37c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,993,696.37Z"
                fill="#3ba525"
              />
              <path
                d="M993.72,696.34a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,993.72,696.34Z"
                fill="#2f6840"
              />
              <path
                d="M997.2,695.55c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,997.2,695.55Z"
                fill="#2f6840"
              />
              <path
                d="M995.83,698.76a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,995.83,698.76Z"
                fill="#2f6840"
              />
              <path
                d="M993.87,696.8c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,993.87,696.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M1008.18,712.2c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1008.18,712.2Z"
                fill="#2f6840"
              />
              <path
                d="M1007.67,711.86c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1007.67,711.86Z"
                fill="#3ba525"
              />
              <path
                d="M1008.42,711.83a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1008.42,711.83Z"
                fill="#2f6840"
              />
              <path
                d="M1011.9,711c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1011.9,711Z"
                fill="#2f6840"
              />
              <path
                d="M1010.53,714.25a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,1010.53,714.25Z"
                fill="#2f6840"
              />
              <path
                d="M1008.58,712.29c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1008.58,712.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M994.72,706.63c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,994.72,706.63Z"
                fill="#2f6840"
              />
              <path
                d="M994.21,706.29c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,994.21,706.29Z"
                fill="#3ba525"
              />
              <path
                d="M995,706.26a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,995,706.26Z"
                fill="#2f6840"
              />
              <path
                d="M998.44,705.47c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,998.44,705.47Z"
                fill="#2f6840"
              />
              <path
                d="M997.08,708.68a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,997.08,708.68Z"
                fill="#2f6840"
              />
              <path
                d="M995.12,706.72c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,995.12,706.72Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M982.74,705.15c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,982.74,705.15Z"
                fill="#2f6840"
              />
              <path
                d="M982.23,704.81c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,982.23,704.81Z"
                fill="#3ba525"
              />
              <path
                d="M983,704.78a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,983,704.78Z"
                fill="#2f6840"
              />
              <path
                d="M986.46,704c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,986.46,704Z"
                fill="#2f6840"
              />
              <path
                d="M985.09,707.19a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,985.09,707.19Z"
                fill="#2f6840"
              />
              <path
                d="M983.13,705.24a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,983.13,705.24Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M980.08,713.88c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,980.08,713.88Z"
                fill="#2f6840"
              />
              <path
                d="M979.57,713.53c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,979.57,713.53Z"
                fill="#3ba525"
              />
              <path
                d="M980.32,713.51a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,980.32,713.51Z"
                fill="#2f6840"
              />
              <path
                d="M983.8,712.71c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,983.8,712.71Z"
                fill="#2f6840"
              />
              <path
                d="M982.43,715.92a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.1,2.1,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,982.43,715.92Z"
                fill="#2f6840"
              />
              <path
                d="M980.48,714c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,980.48,714Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M974.72,708.92c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,974.72,708.92Z"
                fill="#2f6840"
              />
              <path
                d="M974.22,708.58c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,974.22,708.58Z"
                fill="#3ba525"
              />
              <path
                d="M975,708.55a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,975,708.55Z"
                fill="#2f6840"
              />
              <path
                d="M978.45,707.75c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,978.45,707.75Z"
                fill="#2f6840"
              />
              <path
                d="M977.08,711a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,977.08,711Z"
                fill="#2f6840"
              />
              <path
                d="M975.12,709c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,975.12,709Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M966.38,705.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,966.38,705.55Z"
                fill="#2f6840"
              />
              <path
                d="M965.88,705.2c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,965.88,705.2Z"
                fill="#3ba525"
              />
              <path
                d="M966.63,705.18a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74A2.28,2.28,0,0,1,966,704a2.2,2.2,0,0,1,.48.53A1,1,0,0,1,966.63,705.18Z"
                fill="#2f6840"
              />
              <path
                d="M970.11,704.38c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,970.11,704.38Z"
                fill="#2f6840"
              />
              <path
                d="M968.74,707.59a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,968.74,707.59Z"
                fill="#2f6840"
              />
              <path
                d="M966.78,705.64a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,966.78,705.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M981.09,721c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,981.09,721Z"
                fill="#2f6840"
              />
              <path
                d="M980.58,720.69c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,980.58,720.69Z"
                fill="#3ba525"
              />
              <path
                d="M981.33,720.67a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,981.33,720.67Z"
                fill="#2f6840"
              />
              <path
                d="M984.81,719.87c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,984.81,719.87Z"
                fill="#2f6840"
              />
              <path
                d="M983.44,723.08a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,983.44,723.08Z"
                fill="#2f6840"
              />
              <path
                d="M981.48,721.12c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,981.48,721.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M967.63,715.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,967.63,715.47Z"
                fill="#2f6840"
              />
              <path
                d="M967.12,715.12c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,967.12,715.12Z"
                fill="#3ba525"
              />
              <path
                d="M967.88,715.1a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,967.88,715.1Z"
                fill="#2f6840"
              />
              <path
                d="M971.35,714.3c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,971.35,714.3Z"
                fill="#2f6840"
              />
              <path
                d="M970,717.51a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,970,717.51Z"
                fill="#2f6840"
              />
              <path
                d="M968,715.56a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,968,715.56Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M955.32,712.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,955.32,712.65Z"
                fill="#2f6840"
              />
              <path
                d="M954.82,712.3c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,954.82,712.3Z"
                fill="#3ba525"
              />
              <path
                d="M955.57,712.28a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,955.57,712.28Z"
                fill="#2f6840"
              />
              <path
                d="M959.05,711.48c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,959.05,711.48Z"
                fill="#2f6840"
              />
              <path
                d="M957.68,714.69a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,957.68,714.69Z"
                fill="#2f6840"
              />
              <path
                d="M955.72,712.73c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,955.72,712.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M952.66,721.38c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,952.66,721.38Z"
                fill="#2f6840"
              />
              <path
                d="M952.16,721c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,952.16,721Z"
                fill="#3ba525"
              />
              <path
                d="M952.91,721a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,952.91,721Z"
                fill="#2f6840"
              />
              <path
                d="M956.39,720.21c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,956.39,720.21Z"
                fill="#2f6840"
              />
              <path
                d="M955,723.42a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,955,723.42Z"
                fill="#2f6840"
              />
              <path
                d="M953.06,721.46c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,953.06,721.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M947.31,716.42c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,947.31,716.42Z"
                fill="#2f6840"
              />
              <path
                d="M946.8,716.07c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,946.8,716.07Z"
                fill="#3ba525"
              />
              <path
                d="M947.56,716.05a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,947.56,716.05Z"
                fill="#2f6840"
              />
              <path
                d="M951,715.25c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,951,715.25Z"
                fill="#2f6840"
              />
              <path
                d="M949.67,718.46a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,949.67,718.46Z"
                fill="#2f6840"
              />
              <path
                d="M947.71,716.51a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,947.71,716.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M939,713.05c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,939,713.05Z"
                fill="#2f6840"
              />
              <path
                d="M938.46,712.7c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.08-2.37A14.65,14.65,0,0,1,938.46,712.7Z"
                fill="#3ba525"
              />
              <path
                d="M939.21,712.67a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,939.21,712.67Z"
                fill="#2f6840"
              />
              <path
                d="M942.69,711.88c-.25,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,942.69,711.88Z"
                fill="#2f6840"
              />
              <path
                d="M941.32,715.09a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,941.32,715.09Z"
                fill="#2f6840"
              />
              <path
                d="M939.37,713.13c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,939.37,713.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M953.67,728.54c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,953.67,728.54Z"
                fill="#2f6840"
              />
              <path
                d="M953.17,728.19c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,953.17,728.19Z"
                fill="#3ba525"
              />
              <path
                d="M953.92,728.16a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,953.92,728.16Z"
                fill="#2f6840"
              />
              <path
                d="M957.4,727.37c-.26,0-.49,0-.73.1a3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,957.4,727.37Z"
                fill="#2f6840"
              />
              <path
                d="M956,730.58a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,956,730.58Z"
                fill="#2f6840"
              />
              <path
                d="M954.07,728.62c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,954.07,728.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M940.22,723c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,940.22,723Z"
                fill="#2f6840"
              />
              <path
                d="M939.71,722.62c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,939.71,722.62Z"
                fill="#3ba525"
              />
              <path
                d="M940.46,722.59a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,940.46,722.59Z"
                fill="#2f6840"
              />
              <path
                d="M943.94,721.8c-.26,0-.49,0-.72.1a3.22,3.22,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,943.94,721.8Z"
                fill="#2f6840"
              />
              <path
                d="M942.57,725a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,942.57,725Z"
                fill="#2f6840"
              />
              <path
                d="M940.61,723.05c-.24.06-.47.09-.69.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,940.61,723.05Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M927.19,717.16c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,927.19,717.16Z"
                fill="#2f6840"
              />
              <path
                d="M926.68,716.82c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,926.68,716.82Z"
                fill="#3ba525"
              />
              <path
                d="M927.43,716.79a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,927.43,716.79Z"
                fill="#2f6840"
              />
              <path
                d="M930.91,716c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,930.91,716Z"
                fill="#2f6840"
              />
              <path
                d="M929.54,719.21a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,929.54,719.21Z"
                fill="#2f6840"
              />
              <path
                d="M927.59,717.25c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,927.59,717.25Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M924.53,725.89c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S919.8,727,920,727A14.65,14.65,0,0,1,924.53,725.89Z"
                fill="#2f6840"
              />
              <path
                d="M924,725.55c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,924,725.55Z"
                fill="#3ba525"
              />
              <path
                d="M924.78,725.52a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,924.78,725.52Z"
                fill="#2f6840"
              />
              <path
                d="M928.25,724.72c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,928.25,724.72Z"
                fill="#2f6840"
              />
              <path
                d="M926.88,727.93a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,926.88,727.93Z"
                fill="#2f6840"
              />
              <path
                d="M924.93,726c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,924.93,726Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M919.18,720.93c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,919.18,720.93Z"
                fill="#2f6840"
              />
              <path
                d="M918.67,720.59c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,918.67,720.59Z"
                fill="#3ba525"
              />
              <path
                d="M919.42,720.56a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,919.42,720.56Z"
                fill="#2f6840"
              />
              <path
                d="M922.9,719.77c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,922.9,719.77Z"
                fill="#2f6840"
              />
              <path
                d="M921.53,723a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,921.53,723Z"
                fill="#2f6840"
              />
              <path
                d="M919.57,721c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,919.57,721Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M910.83,717.56c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,910.83,717.56Z"
                fill="#2f6840"
              />
              <path
                d="M910.33,717.22c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,910.33,717.22Z"
                fill="#3ba525"
              />
              <path
                d="M911.08,717.19a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,911.08,717.19Z"
                fill="#2f6840"
              />
              <path
                d="M914.56,716.39c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,914.56,716.39Z"
                fill="#2f6840"
              />
              <path
                d="M913.19,719.6a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,913.19,719.6Z"
                fill="#2f6840"
              />
              <path
                d="M911.23,717.65c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,911.23,717.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M925.54,733.05c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,925.54,733.05Z"
                fill="#2f6840"
              />
              <path
                d="M925,732.71c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.92,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,925,732.71Z"
                fill="#3ba525"
              />
              <path
                d="M925.78,732.68a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,925.78,732.68Z"
                fill="#2f6840"
              />
              <path
                d="M929.26,731.88c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,929.26,731.88Z"
                fill="#2f6840"
              />
              <path
                d="M927.89,735.09a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,927.89,735.09Z"
                fill="#2f6840"
              />
              <path
                d="M925.94,733.14c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,925.94,733.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M912.08,727.48c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,912.08,727.48Z"
                fill="#2f6840"
              />
              <path
                d="M911.58,727.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,911.58,727.14Z"
                fill="#3ba525"
              />
              <path
                d="M912.33,727.11a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,912.33,727.11Z"
                fill="#2f6840"
              />
              <path
                d="M915.81,726.31c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,915.81,726.31Z"
                fill="#2f6840"
              />
              <path
                d="M914.44,729.52a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,914.44,729.52Z"
                fill="#2f6840"
              />
              <path
                d="M912.48,727.57c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,912.48,727.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M898.93,720.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,898.93,720.17Z"
                fill="#2f6840"
              />
              <path
                d="M898.42,719.82c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,898.42,719.82Z"
                fill="#3ba525"
              />
              <path
                d="M899.17,719.8a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,899.17,719.8Z"
                fill="#2f6840"
              />
              <path
                d="M902.65,719c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,902.65,719Z"
                fill="#2f6840"
              />
              <path
                d="M901.28,722.21a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,901.28,722.21Z"
                fill="#2f6840"
              />
              <path
                d="M899.33,720.26a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,899.33,720.26Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M896.27,728.9c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,896.27,728.9Z"
                fill="#2f6840"
              />
              <path
                d="M895.76,728.55c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,895.76,728.55Z"
                fill="#3ba525"
              />
              <path
                d="M896.51,728.53a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,896.51,728.53Z"
                fill="#2f6840"
              />
              <path
                d="M900,727.73c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,900,727.73Z"
                fill="#2f6840"
              />
              <path
                d="M898.62,730.94a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,898.62,730.94Z"
                fill="#2f6840"
              />
              <path
                d="M896.67,729c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,896.67,729Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M890.92,723.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,890.92,723.94Z"
                fill="#2f6840"
              />
              <path
                d="M890.41,723.6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,890.41,723.6Z"
                fill="#3ba525"
              />
              <path
                d="M891.16,723.57a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.54A1,1,0,0,1,891.16,723.57Z"
                fill="#2f6840"
              />
              <path
                d="M894.64,722.77c-.26,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,894.64,722.77Z"
                fill="#2f6840"
              />
              <path
                d="M893.27,726a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.2,2.2,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,893.27,726Z"
                fill="#2f6840"
              />
              <path
                d="M891.31,724c-.24.06-.47.08-.69.15a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,891.31,724Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M882.57,720.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S885,717,886.7,717.6s3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,882.57,720.57Z"
                fill="#2f6840"
              />
              <path
                d="M882.07,720.22c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,882.07,720.22Z"
                fill="#3ba525"
              />
              <path
                d="M882.82,720.2a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,882.82,720.2Z"
                fill="#2f6840"
              />
              <path
                d="M886.3,719.4c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,886.3,719.4Z"
                fill="#2f6840"
              />
              <path
                d="M884.93,722.61a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,884.93,722.61Z"
                fill="#2f6840"
              />
              <path
                d="M883,720.65c-.24.06-.47.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,883,720.65Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M897.28,736.06c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,897.28,736.06Z"
                fill="#2f6840"
              />
              <path
                d="M896.77,735.71c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,896.77,735.71Z"
                fill="#3ba525"
              />
              <path
                d="M897.52,735.68a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,897.52,735.68Z"
                fill="#2f6840"
              />
              <path
                d="M901,734.89c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.45,14.45,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,901,734.89Z"
                fill="#2f6840"
              />
              <path
                d="M899.63,738.1a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,899.63,738.1Z"
                fill="#2f6840"
              />
              <path
                d="M897.68,736.14c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,897.68,736.14Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M883.82,730.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,883.82,730.49Z"
                fill="#2f6840"
              />
              <path
                d="M883.32,730.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,883.32,730.14Z"
                fill="#3ba525"
              />
              <path
                d="M884.07,730.12a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.48.53A1,1,0,0,1,884.07,730.12Z"
                fill="#2f6840"
              />
              <path
                d="M887.55,729.32c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,887.55,729.32Z"
                fill="#2f6840"
              />
              <path
                d="M886.18,732.53a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,886.18,732.53Z"
                fill="#2f6840"
              />
              <path
                d="M884.22,730.57c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,884.22,730.57Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M870.43,720.36c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,870.43,720.36Z"
                fill="#2f6840"
              />
              <path
                d="M869.93,720c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,869.93,720Z"
                fill="#3ba525"
              />
              <path
                d="M870.68,720a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,870.68,720Z"
                fill="#2f6840"
              />
              <path
                d="M874.16,719.19c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.44,2.44,0,0,1,1.24-.86A2.07,2.07,0,0,1,874.16,719.19Z"
                fill="#2f6840"
              />
              <path
                d="M872.79,722.4a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,872.79,722.4Z"
                fill="#2f6840"
              />
              <path
                d="M870.83,720.44c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,870.83,720.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M867.77,729.08c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,867.77,729.08Z"
                fill="#2f6840"
              />
              <path
                d="M867.27,728.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,867.27,728.74Z"
                fill="#3ba525"
              />
              <path
                d="M868,728.71a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,868,728.71Z"
                fill="#2f6840"
              />
              <path
                d="M871.5,727.92c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,871.5,727.92Z"
                fill="#2f6840"
              />
              <path
                d="M870.13,731.13a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,870.13,731.13Z"
                fill="#2f6840"
              />
              <path
                d="M868.17,729.17c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,868.17,729.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M862.42,724.13c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71S863,725,863,725s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,862.42,724.13Z"
                fill="#2f6840"
              />
              <path
                d="M861.92,723.78c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,861.92,723.78Z"
                fill="#3ba525"
              />
              <path
                d="M862.67,723.75a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,862.67,723.75Z"
                fill="#2f6840"
              />
              <path
                d="M866.15,723a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,866.15,723Z"
                fill="#2f6840"
              />
              <path
                d="M864.78,726.17a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,864.78,726.17Z"
                fill="#2f6840"
              />
              <path
                d="M862.82,724.21c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,862.82,724.21Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M854.08,720.75c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,854.08,720.75Z"
                fill="#2f6840"
              />
              <path
                d="M853.57,720.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,853.57,720.41Z"
                fill="#3ba525"
              />
              <path
                d="M854.33,720.38a2.09,2.09,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,854.33,720.38Z"
                fill="#2f6840"
              />
              <path
                d="M857.8,719.59c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,857.8,719.59Z"
                fill="#2f6840"
              />
              <path
                d="M856.44,722.8a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,856.44,722.8Z"
                fill="#2f6840"
              />
              <path
                d="M854.48,720.84c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,854.48,720.84Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M868.78,736.24c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,868.78,736.24Z"
                fill="#2f6840"
              />
              <path
                d="M868.28,735.9c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.24.26,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,868.28,735.9Z"
                fill="#3ba525"
              />
              <path
                d="M869,735.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,869,735.87Z"
                fill="#2f6840"
              />
              <path
                d="M872.51,735.08c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52A2.42,2.42,0,0,1,871,735,2.07,2.07,0,0,1,872.51,735.08Z"
                fill="#2f6840"
              />
              <path
                d="M871.14,738.29a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,871.14,738.29Z"
                fill="#2f6840"
              />
              <path
                d="M869.18,736.33c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,869.18,736.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M855.33,730.67c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,855.33,730.67Z"
                fill="#2f6840"
              />
              <path
                d="M854.82,730.33c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,854.82,730.33Z"
                fill="#3ba525"
              />
              <path
                d="M855.57,730.3a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,855.57,730.3Z"
                fill="#2f6840"
              />
              <path
                d="M859.05,729.51c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,859.05,729.51Z"
                fill="#2f6840"
              />
              <path
                d="M857.68,732.72a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,857.68,732.72Z"
                fill="#2f6840"
              />
              <path
                d="M855.73,730.76c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,855.73,730.76Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M841.94,720.49c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,841.94,720.49Z"
                fill="#2f6840"
              />
              <path
                d="M841.43,720.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71S842,721,842,721s-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,841.43,720.15Z"
                fill="#3ba525"
              />
              <path
                d="M842.19,720.12a2.17,2.17,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.87,1.87,0,0,1,.47.54A1,1,0,0,1,842.19,720.12Z"
                fill="#2f6840"
              />
              <path
                d="M845.66,719.32c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,845.66,719.32Z"
                fill="#2f6840"
              />
              <path
                d="M844.3,722.53a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,844.3,722.53Z"
                fill="#2f6840"
              />
              <path
                d="M842.34,720.58a6.56,6.56,0,0,0-.7.16,3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,842.34,720.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M839.28,729.22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,839.28,729.22Z"
                fill="#2f6840"
              />
              <path
                d="M838.77,728.87c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,838.77,728.87Z"
                fill="#3ba525"
              />
              <path
                d="M839.53,728.85a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,839.53,728.85Z"
                fill="#2f6840"
              />
              <path
                d="M843,728.05c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,843,728.05Z"
                fill="#2f6840"
              />
              <path
                d="M841.64,731.26a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,841.64,731.26Z"
                fill="#2f6840"
              />
              <path
                d="M839.68,729.31a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,839.68,729.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M833.93,724.26c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,833.93,724.26Z"
                fill="#2f6840"
              />
              <path
                d="M833.42,723.92c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,833.42,723.92Z"
                fill="#3ba525"
              />
              <path
                d="M834.17,723.89a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.25,2.25,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,834.17,723.89Z"
                fill="#2f6840"
              />
              <path
                d="M837.65,723.09c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,837.65,723.09Z"
                fill="#2f6840"
              />
              <path
                d="M836.28,726.3a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,836.28,726.3Z"
                fill="#2f6840"
              />
              <path
                d="M834.33,724.35c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,834.33,724.35Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M825.58,720.89c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S820.86,722,821,722A14.55,14.55,0,0,1,825.58,720.89Z"
                fill="#2f6840"
              />
              <path
                d="M825.08,720.55c4.42-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,825.08,720.55Z"
                fill="#3ba525"
              />
              <path
                d="M825.83,720.52a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,825.83,720.52Z"
                fill="#2f6840"
              />
              <path
                d="M829.31,719.72c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,829.31,719.72Z"
                fill="#2f6840"
              />
              <path
                d="M827.94,722.93a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,827.94,722.93Z"
                fill="#2f6840"
              />
              <path
                d="M826,721a7,7,0,0,0-.69.15,4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,826,721Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M840.29,736.38c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,840.29,736.38Z"
                fill="#2f6840"
              />
              <path
                d="M839.78,736c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,839.78,736Z"
                fill="#3ba525"
              />
              <path
                d="M840.54,736a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,840.54,736Z"
                fill="#2f6840"
              />
              <path
                d="M844,735.21c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,844,735.21Z"
                fill="#2f6840"
              />
              <path
                d="M842.65,738.42a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.17,2.17,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,842.65,738.42Z"
                fill="#2f6840"
              />
              <path
                d="M840.69,736.47a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,840.69,736.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M826.83,730.81c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45S828,730,828,730s1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,826.83,730.81Z"
                fill="#2f6840"
              />
              <path
                d="M826.33,730.47c4.42-.26-4.33.45-4.36-.62s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.25,14.25,0,0,1,826.33,730.47Z"
                fill="#3ba525"
              />
              <path
                d="M827.08,730.44a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,827.08,730.44Z"
                fill="#2f6840"
              />
              <path
                d="M830.56,729.64c-.26,0-.5.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,830.56,729.64Z"
                fill="#2f6840"
              />
              <path
                d="M829.19,732.85a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,829.19,732.85Z"
                fill="#2f6840"
              />
              <path
                d="M827.23,730.9a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,827.23,730.9Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M813.72,724.23c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,813.72,724.23Z"
                fill="#2f6840"
              />
              <path
                d="M813.21,723.88c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,813.21,723.88Z"
                fill="#3ba525"
              />
              <path
                d="M814,723.85a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,814,723.85Z"
                fill="#2f6840"
              />
              <path
                d="M817.44,723.06a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,817.44,723.06Z"
                fill="#2f6840"
              />
              <path
                d="M816.07,726.27a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,816.07,726.27Z"
                fill="#2f6840"
              />
              <path
                d="M814.12,724.31c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,814.12,724.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M811.06,733c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,811.06,733Z"
                fill="#2f6840"
              />
              <path
                d="M810.55,732.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,810.55,732.61Z"
                fill="#3ba525"
              />
              <path
                d="M811.3,732.58a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,811.3,732.58Z"
                fill="#2f6840"
              />
              <path
                d="M814.78,731.79a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,9.91,9.91,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,814.78,731.79Z"
                fill="#2f6840"
              />
              <path
                d="M813.41,735a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,813.41,735Z"
                fill="#2f6840"
              />
              <path
                d="M811.46,733c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,811.46,733Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M805.7,728c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,805.7,728Z"
                fill="#2f6840"
              />
              <path
                d="M805.2,727.65c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,805.2,727.65Z"
                fill="#3ba525"
              />
              <path
                d="M806,727.62a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,806,727.62Z"
                fill="#2f6840"
              />
              <path
                d="M809.43,726.83c-.26,0-.49,0-.73.1a3,3,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,809.43,726.83Z"
                fill="#2f6840"
              />
              <path
                d="M808.06,730a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.08,2.08,0,0,1,1.21.55,1.76,1.76,0,0,1,.41.56A1,1,0,0,1,808.06,730Z"
                fill="#2f6840"
              />
              <path
                d="M806.1,728.08c-.24.06-.47.09-.69.16a4.54,4.54,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,806.1,728.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M797.36,724.63c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,797.36,724.63Z"
                fill="#2f6840"
              />
              <path
                d="M796.86,724.28c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,796.86,724.28Z"
                fill="#3ba525"
              />
              <path
                d="M797.61,724.25a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74A2.34,2.34,0,0,1,797,723a1.85,1.85,0,0,1,.47.53A1,1,0,0,1,797.61,724.25Z"
                fill="#2f6840"
              />
              <path
                d="M801.09,723.46a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,801.09,723.46Z"
                fill="#2f6840"
              />
              <path
                d="M799.72,726.67a2,2,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,799.72,726.67Z"
                fill="#2f6840"
              />
              <path
                d="M797.76,724.71c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,797.76,724.71Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M812.07,740.12c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,812.07,740.12Z"
                fill="#2f6840"
              />
              <path
                d="M811.56,739.77c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,811.56,739.77Z"
                fill="#3ba525"
              />
              <path
                d="M812.31,739.74a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,812.31,739.74Z"
                fill="#2f6840"
              />
              <path
                d="M815.79,739c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,9.91,9.91,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,815.79,739Z"
                fill="#2f6840"
              />
              <path
                d="M814.42,742.16a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,814.42,742.16Z"
                fill="#2f6840"
              />
              <path
                d="M812.47,740.2c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,11.39,11.39,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2.07,2.07,0,0,1,812.47,740.2Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M798.61,734.55c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,798.61,734.55Z"
                fill="#2f6840"
              />
              <path
                d="M798.1,734.2c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,798.1,734.2Z"
                fill="#3ba525"
              />
              <path
                d="M798.86,734.17a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,798.86,734.17Z"
                fill="#2f6840"
              />
              <path
                d="M802.33,733.38a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,802.33,733.38Z"
                fill="#2f6840"
              />
              <path
                d="M801,736.59a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,801,736.59Z"
                fill="#2f6840"
              />
              <path
                d="M799,734.63c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,799,734.63Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M786.29,731.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,786.29,731.62Z"
                fill="#2f6840"
              />
              <path
                d="M785.78,731.27c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,785.78,731.27Z"
                fill="#3ba525"
              />
              <path
                d="M786.54,731.24a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74A2.28,2.28,0,0,1,786,730a1.71,1.71,0,0,1,.47.53A1,1,0,0,1,786.54,731.24Z"
                fill="#2f6840"
              />
              <path
                d="M790,730.45a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,790,730.45Z"
                fill="#2f6840"
              />
              <path
                d="M788.65,733.66a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,788.65,733.66Z"
                fill="#2f6840"
              />
              <path
                d="M786.69,731.7c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,10.08,10.08,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,786.69,731.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M783.63,740.35c4.43-.26-4.33.45-4.35-.62s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,783.63,740.35Z"
                fill="#2f6840"
              />
              <path
                d="M783.12,740c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,783.12,740Z"
                fill="#3ba525"
              />
              <path
                d="M783.88,740a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,783.88,740Z"
                fill="#2f6840"
              />
              <path
                d="M787.35,739.18c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,787.35,739.18Z"
                fill="#2f6840"
              />
              <path
                d="M786,742.39a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,786,742.39Z"
                fill="#2f6840"
              />
              <path
                d="M784,740.43c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,784,740.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M778.28,735.39c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,778.28,735.39Z"
                fill="#2f6840"
              />
              <path
                d="M777.77,735c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,777.77,735Z"
                fill="#3ba525"
              />
              <path
                d="M778.52,735a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,778.52,735Z"
                fill="#2f6840"
              />
              <path
                d="M782,734.22a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,12.12,12.12,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,782,734.22Z"
                fill="#2f6840"
              />
              <path
                d="M780.63,737.43a1.9,1.9,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,780.63,737.43Z"
                fill="#2f6840"
              />
              <path
                d="M778.68,735.47c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,778.68,735.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M769.93,732c4.43-.26-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.24,14.24,0,0,1,769.93,732Z"
                fill="#2f6840"
              />
              <path
                d="M769.43,731.67c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,769.43,731.67Z"
                fill="#3ba525"
              />
              <path
                d="M770.18,731.64a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,770.18,731.64Z"
                fill="#2f6840"
              />
              <path
                d="M773.66,730.85c-.26,0-.49,0-.72.09a3.57,3.57,0,0,0-.68.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,773.66,730.85Z"
                fill="#2f6840"
              />
              <path
                d="M772.29,734.06a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,772.29,734.06Z"
                fill="#2f6840"
              />
              <path
                d="M770.33,732.1c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,770.33,732.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M784.64,747.5c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,784.64,747.5Z"
                fill="#2f6840"
              />
              <path
                d="M784.13,747.16c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,784.13,747.16Z"
                fill="#3ba525"
              />
              <path
                d="M784.89,747.13a2.09,2.09,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,784.89,747.13Z"
                fill="#2f6840"
              />
              <path
                d="M788.36,746.34c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,788.36,746.34Z"
                fill="#2f6840"
              />
              <path
                d="M787,749.55a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,787,749.55Z"
                fill="#2f6840"
              />
              <path
                d="M785,747.59c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,785,747.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M771.18,741.94c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,771.18,741.94Z"
                fill="#2f6840"
              />
              <path
                d="M770.68,741.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,770.68,741.59Z"
                fill="#3ba525"
              />
              <path
                d="M771.43,741.56a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,771.43,741.56Z"
                fill="#2f6840"
              />
              <path
                d="M774.91,740.77c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,10.33,10.33,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,774.91,740.77Z"
                fill="#2f6840"
              />
              <path
                d="M773.54,744a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,773.54,744Z"
                fill="#2f6840"
              />
              <path
                d="M771.58,742c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,771.58,742Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M758.84,739.21c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A14.87,14.87,0,0,1,758.84,739.21Z"
                fill="#2f6840"
              />
              <path
                d="M758.33,738.87c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,758.33,738.87Z"
                fill="#3ba525"
              />
              <path
                d="M759.08,738.84a2.07,2.07,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,759.08,738.84Z"
                fill="#2f6840"
              />
              <path
                d="M762.56,738.05c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,762.56,738.05Z"
                fill="#2f6840"
              />
              <path
                d="M761.19,741.26a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,761.19,741.26Z"
                fill="#2f6840"
              />
              <path
                d="M759.24,739.3c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,759.24,739.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M756.18,747.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,756.18,747.94Z"
                fill="#2f6840"
              />
              <path
                d="M755.67,747.6c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,755.67,747.6Z"
                fill="#3ba525"
              />
              <path
                d="M756.42,747.57a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,756.42,747.57Z"
                fill="#2f6840"
              />
              <path
                d="M759.9,746.78c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,759.9,746.78Z"
                fill="#2f6840"
              />
              <path
                d="M758.53,750a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,758.53,750Z"
                fill="#2f6840"
              />
              <path
                d="M756.58,748c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,756.58,748Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M750.82,743c4.43-.26-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.24,14.24,0,0,1,750.82,743Z"
                fill="#2f6840"
              />
              <path
                d="M750.32,742.64c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,750.32,742.64Z"
                fill="#3ba525"
              />
              <path
                d="M751.07,742.61a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,751.07,742.61Z"
                fill="#2f6840"
              />
              <path
                d="M754.55,741.82c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,9.91,9.91,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,754.55,741.82Z"
                fill="#2f6840"
              />
              <path
                d="M753.18,745a1.82,1.82,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,753.18,745Z"
                fill="#2f6840"
              />
              <path
                d="M751.22,743.07c-.24.06-.47.09-.69.16a2.78,2.78,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,751.22,743.07Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M742.48,739.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,742.48,739.61Z"
                fill="#2f6840"
              />
              <path
                d="M742,739.27c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,742,739.27Z"
                fill="#3ba525"
              />
              <path
                d="M742.73,739.24a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.53A1,1,0,0,1,742.73,739.24Z"
                fill="#2f6840"
              />
              <path
                d="M746.21,738.45c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,746.21,738.45Z"
                fill="#2f6840"
              />
              <path
                d="M744.84,741.66a1.94,1.94,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,744.84,741.66Z"
                fill="#2f6840"
              />
              <path
                d="M742.88,739.7c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,742.88,739.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M757.19,755.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,757.19,755.1Z"
                fill="#2f6840"
              />
              <path
                d="M756.68,754.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,756.68,754.76Z"
                fill="#3ba525"
              />
              <path
                d="M757.43,754.73a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,757.43,754.73Z"
                fill="#2f6840"
              />
              <path
                d="M760.91,753.94c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,760.91,753.94Z"
                fill="#2f6840"
              />
              <path
                d="M759.54,757.15a1.88,1.88,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,759.54,757.15Z"
                fill="#2f6840"
              />
              <path
                d="M757.59,755.19c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,757.59,755.19Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M743.73,749.53c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,743.73,749.53Z"
                fill="#2f6840"
              />
              <path
                d="M743.22,749.19c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,743.22,749.19Z"
                fill="#3ba525"
              />
              <path
                d="M744,749.16a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,744,749.16Z"
                fill="#2f6840"
              />
              <path
                d="M747.45,748.37c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,747.45,748.37Z"
                fill="#2f6840"
              />
              <path
                d="M746.09,751.58a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,746.09,751.58Z"
                fill="#2f6840"
              />
              <path
                d="M744.13,749.62c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,744.13,749.62Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M730.55,738.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,730.55,738.2Z"
                fill="#2f6840"
              />
              <path
                d="M730,737.86c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,730,737.86Z"
                fill="#3ba525"
              />
              <path
                d="M730.8,737.83a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,730.8,737.83Z"
                fill="#2f6840"
              />
              <path
                d="M734.28,737c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.1,2.1,0,0,1,734.28,737Z"
                fill="#2f6840"
              />
              <path
                d="M732.91,740.25a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A1,1,0,0,1,732.91,740.25Z"
                fill="#2f6840"
              />
              <path
                d="M731,738.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,731,738.29Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M727.89,746.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,727.89,746.93Z"
                fill="#2f6840"
              />
              <path
                d="M727.39,746.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,727.39,746.59Z"
                fill="#3ba525"
              />
              <path
                d="M728.14,746.56a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,728.14,746.56Z"
                fill="#2f6840"
              />
              <path
                d="M731.62,745.76c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,731.62,745.76Z"
                fill="#2f6840"
              />
              <path
                d="M730.25,749a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,730.25,749Z"
                fill="#2f6840"
              />
              <path
                d="M728.29,747c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,728.29,747Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M722.54,742c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,722.54,742Z"
                fill="#2f6840"
              />
              <path
                d="M722,741.63c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,722,741.63Z"
                fill="#3ba525"
              />
              <path
                d="M722.79,741.6a2.15,2.15,0,0,0-.8-.93c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,722.79,741.6Z"
                fill="#2f6840"
              />
              <path
                d="M726.26,740.81c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.07,2.07,0,0,1,726.26,740.81Z"
                fill="#2f6840"
              />
              <path
                d="M724.9,744a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,724.9,744Z"
                fill="#2f6840"
              />
              <path
                d="M722.94,742.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.34,9.34,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,722.94,742.06Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M714.2,738.6c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,714.2,738.6Z"
                fill="#2f6840"
              />
              <path
                d="M713.69,738.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,713.69,738.26Z"
                fill="#3ba525"
              />
              <path
                d="M714.44,738.23a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,714.44,738.23Z"
                fill="#2f6840"
              />
              <path
                d="M717.92,737.43c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,717.92,737.43Z"
                fill="#2f6840"
              />
              <path
                d="M716.55,740.64a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,716.55,740.64Z"
                fill="#2f6840"
              />
              <path
                d="M714.59,738.69c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,714.59,738.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M728.9,754.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,728.9,754.09Z"
                fill="#2f6840"
              />
              <path
                d="M728.4,753.75c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,728.4,753.75Z"
                fill="#3ba525"
              />
              <path
                d="M729.15,753.72a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,729.15,753.72Z"
                fill="#2f6840"
              />
              <path
                d="M732.63,752.92c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.15,2.15,0,0,1,732.63,752.92Z"
                fill="#2f6840"
              />
              <path
                d="M731.26,756.13a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,731.26,756.13Z"
                fill="#2f6840"
              />
              <path
                d="M729.3,754.18c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,729.3,754.18Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M715.44,748.52c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,715.44,748.52Z"
                fill="#2f6840"
              />
              <path
                d="M714.94,748.18c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,714.94,748.18Z"
                fill="#3ba525"
              />
              <path
                d="M715.69,748.15a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,715.69,748.15Z"
                fill="#2f6840"
              />
              <path
                d="M719.17,747.35c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,719.17,747.35Z"
                fill="#2f6840"
              />
              <path
                d="M717.8,750.56a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,717.8,750.56Z"
                fill="#2f6840"
              />
              <path
                d="M715.84,748.61c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,715.84,748.61Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M746,741.47l3.63,2.26a1.21,1.21,0,0,0,1.11.07l8.71-3.89a1.18,1.18,0,0,0,.29-2h0a1.16,1.16,0,0,0-.93-.28l-12.34,1.64A1.18,1.18,0,0,0,746,741.47Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="752.49 732.46 747.57 733.5 743.24 736.83 750.5 739.74 759.38 736.1 752.49 732.46"
              fill="#ffedc8"
            />
            <polygon
              points="743.24 736.83 743.24 739.74 750.2 742.72 759.57 738.92 759.38 736.1 750.5 739.74 743.24 736.83"
              fill="#ccae79"
            />
            <polygon
              points="750.5 739.74 750.2 742.72 759.57 738.92 759.38 736.1 750.5 739.74"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M745.31,737.66a1.29,1.29,0,0,1,0,1.49c.33-.47.41-1.33.56-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M748.37,738.88A4.09,4.09,0,0,0,750.2,737l-1.31,2.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M754.17,738.23a1.35,1.35,0,0,1,.72,1.18l-.22-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M757.41,735.06a8.7,8.7,0,0,1-2.88,0,4.13,4.13,0,0,1-2.1.15s1.54-.15,2.1.37A12.42,12.42,0,0,1,757.41,735.06Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1169.77,617.18l3.63,2.26a1.19,1.19,0,0,0,1.1.07l8.72-3.89a1.18,1.18,0,0,0,.29-2h0a1.17,1.17,0,0,0-.93-.28L1170.24,615A1.18,1.18,0,0,0,1169.77,617.18Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1176.21 608.17 1171.3 609.21 1166.97 612.54 1174.22 615.45 1183.11 611.81 1176.21 608.17"
              fill="#ffedc8"
            />
            <polygon
              points="1166.97 612.54 1166.97 615.45 1173.93 618.43 1183.3 614.63 1183.11 611.81 1174.22 615.45 1166.97 612.54"
              fill="#ccae79"
            />
            <polygon
              points="1174.22 615.45 1173.93 618.43 1183.3 614.63 1183.11 611.81 1174.22 615.45"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1169,613.37a1.31,1.31,0,0,1,0,1.49c.33-.47.41-1.33.56-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1172.1,614.59a4.09,4.09,0,0,0,1.83-1.86l-1.31,2.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1177.89,613.94a1.35,1.35,0,0,1,.73,1.18l-.22-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1181.14,610.77a8.7,8.7,0,0,1-2.88,0,4.08,4.08,0,0,1-2.11.14s1.55-.14,2.11.38A12.42,12.42,0,0,1,1181.14,610.77Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1158.15,629.08l2.72,1.69a.9.9,0,0,0,.83.05l6.54-2.92a.89.89,0,0,0,.21-1.48h0a.86.86,0,0,0-.69-.2l-9.26,1.23A.89.89,0,0,0,1158.15,629.08Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1162.98 622.32 1159.3 623.1 1156.05 625.59 1161.49 627.77 1168.15 625.04 1162.98 622.32"
              fill="#ffedc8"
            />
            <polygon
              points="1156.05 625.59 1156.05 627.77 1161.27 630.01 1168.3 627.16 1168.15 625.04 1161.49 627.77 1156.05 625.59"
              fill="#ccae79"
            />
            <polygon
              points="1161.49 627.77 1161.27 630.01 1168.3 627.16 1168.15 625.04 1161.49 627.77"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1157.61,626.22a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1159.9,627.14a3.14,3.14,0,0,0,1.37-1.4l-1,1.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1164.24,626.65a1,1,0,0,1,.54.88l-.16-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1166.68,624.27a6.74,6.74,0,0,1-2.17,0,3.12,3.12,0,0,1-1.57.11s1.16-.12,1.57.28A9.18,9.18,0,0,1,1166.68,624.27Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1154.77,619.79l2.7,1.68a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.91.91,0,0,0-.69-.21l-9.19,1.23A.87.87,0,0,0,1154.77,619.79Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="1159.57 613.08 1155.91 613.86 1152.68 616.34 1158.09 618.5 1164.7 615.79 1159.57 613.08"
              fill="#ffedc8"
            />
            <polygon
              points="1152.68 616.34 1152.68 618.5 1157.87 620.72 1164.84 617.89 1164.7 615.79 1158.09 618.5 1152.68 616.34"
              fill="#ccae79"
            />
            <polygon
              points="1158.09 618.5 1157.87 620.72 1164.84 617.89 1164.7 615.79 1158.09 618.5"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1154.23,617a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1156.51,617.87a3.08,3.08,0,0,0,1.36-1.39l-1,1.54Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1160.82,617.38a1,1,0,0,1,.54.88l-.17-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1163.23,615a6.54,6.54,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.93,8.93,0,0,1,1163.23,615Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M741.38,751l1.59,1a.49.49,0,0,0,.48,0l3.83-1.71a.51.51,0,0,0,.12-.86h0a.5.5,0,0,0-.4-.13l-5.42.72A.52.52,0,0,0,741.38,751Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="744.2 746.99 742.05 747.45 740.15 748.91 743.33 750.18 747.23 748.59 744.2 746.99"
              fill="#ffedc8"
            />
            <polygon
              points="740.15 748.91 740.15 750.18 743.2 751.49 747.31 749.83 747.23 748.59 743.33 750.18 740.15 748.91"
              fill="#ccae79"
            />
            <polygon
              points="743.33 750.18 743.2 751.49 747.31 749.83 747.23 748.59 743.33 750.18"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M741.06,749.27a.59.59,0,0,1,0,.66c.14-.21.17-.59.24-.56Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M742.4,749.81a1.77,1.77,0,0,0,.8-.81l-.57.9Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M744.94,749.53a.58.58,0,0,1,.32.51l-.1-.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M746.36,748.13a3.57,3.57,0,0,1-1.26,0,1.79,1.79,0,0,1-.92.07s.67-.07.92.16A5.91,5.91,0,0,1,746.36,748.13Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M725.59,747l3.63,2.26a1.21,1.21,0,0,0,1.11.07l8.71-3.89a1.18,1.18,0,0,0,.29-2h0a1.12,1.12,0,0,0-.93-.28l-12.34,1.64A1.18,1.18,0,0,0,725.59,747Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="732.03 738.01 727.12 739.05 722.79 742.38 730.05 745.28 738.93 741.65 732.03 738.01"
              fill="#ffedc8"
            />
            <polygon
              points="722.79 742.38 722.79 745.28 729.75 748.27 739.12 744.47 738.93 741.65 730.05 745.28 722.79 742.38"
              fill="#ccae79"
            />
            <polygon
              points="730.05 745.28 729.75 748.27 739.12 744.47 738.93 741.65 730.05 745.28"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M724.86,743.21a1.31,1.31,0,0,1,0,1.49c.33-.47.41-1.33.56-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M727.92,744.43a4.09,4.09,0,0,0,1.83-1.86l-1.31,2.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M733.71,743.78a1.35,1.35,0,0,1,.73,1.18l-.22-1.39Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M737,740.61a8.7,8.7,0,0,1-2.88,0,4,4,0,0,1-2.1.14s1.54-.14,2.1.38A12.42,12.42,0,0,1,737,740.61Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M1142.17,670.15s.73,2.66,2.33,3.41,4.5-.41,3.82.89,2.77,2.66,4.38,2.59,5.64-2.66,5.83-3.7S1142.17,670.15,1142.17,670.15Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M1142.52,668.17l-.35,2,2.5,2.62,3.79.66.6,1.63s2.35,1.74,4.35.76a14.17,14.17,0,0,0,3.78-3l.35-2Z"
              fill="#ccae79"
            />
            <path
              d="M1145.83,667.42l-3.31.75,2.71,2.65,3.62.63.9,1.73s3.35,1.67,4,.7,3.79-3.08,3.79-3.08L1155,669Z"
              fill="#ffedc8"
            />
            <polygon
              points="1145.23 670.82 1144.67 672.77 1148.46 673.43 1148.85 671.45 1145.23 670.82"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1152.75,674.17s.26,1.93-.33,1.93a8.79,8.79,0,0,0,4.77-3.31l.35-2S1153.58,674.33,1152.75,674.17Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M1150.37,673.46l.69.27s-.43-.2-.49.65A2.1,2.1,0,0,0,1150.37,673.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1152,674a5.5,5.5,0,0,0,.92-.5,4.42,4.42,0,0,0,1.15-1.19s-1.89,1.46-1.56,1.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144.11,669.72a12.24,12.24,0,0,1-.26,1.43s.14-1.09.48-1.22Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1150.18,668.18l1.44.25c.1,0-1.13-.2-1.55.39l.11-.64"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M1144.19,667.79l.82-.18s-.48.18-.32.27.77.5,1.07.41a1.11,1.11,0,0,1,.71.16Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M721.5,747.27l3.62,2.25a1.18,1.18,0,0,0,1.11.08l8.71-3.9a1.18,1.18,0,0,0,.29-2h0a1.18,1.18,0,0,0-.92-.28L722,745.1A1.18,1.18,0,0,0,721.5,747.27Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="727.94 738.25 723.02 739.3 718.7 742.62 725.95 745.53 734.83 741.89 727.94 738.25"
              fill="#ffedc8"
            />
            <polygon
              points="718.7 742.62 718.7 745.53 725.66 748.51 735.02 744.71 734.83 741.89 725.95 745.53 718.7 742.62"
              fill="#ccae79"
            />
            <polygon
              points="725.95 745.53 725.66 748.51 735.02 744.71 734.83 741.89 725.95 745.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M720.77,743.45a1.32,1.32,0,0,1,0,1.5c.32-.47.4-1.34.55-1.27Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M723.83,744.68a4.16,4.16,0,0,0,1.83-1.86l-1.32,2.07Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M729.62,744a1.35,1.35,0,0,1,.72,1.17l-.22-1.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M732.86,740.85a8.17,8.17,0,0,1-2.88,0,4.13,4.13,0,0,1-2.1.15s1.54-.15,2.1.38A12.7,12.7,0,0,1,732.86,740.85Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g id="afc89190-5fb6-4300-8ac4-875df0c08c16" data-name="rays">
        <polygon
          points="127.71 0 621.09 711.23 534.29 701 127.71 0"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="642.41 296.78 1575.69 1012.49 1410.35 1062.05 642.41 296.78"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="780.81 277.06 1714.09 992.77 1548.74 1042.32 780.81 277.06"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="539.67 486.14 1087.81 979.68 987.35 969.77 539.67 486.14"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="529.02 255.54 1544.41 1236.5 1354.21 1272.56 529.02 255.54"
          fill="#fff"
          opacity="0.13"
        />
      </g>
    </g>
  );
};

export default UnderseaStaticElements;
